import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTheme } from "@mui/material/styles";
import {
  Grid,
  Box,
  Button,
  Typography,
  FormHelperText,
  CircularProgress,
  Stack,
  Skeleton,
  ListItem,
  ListItemAvatar,
  ListItemText,
  IconButton,
  Avatar,
  List,
  useMediaQuery,
  Tooltip,
  Modal
} from "@mui/material";
import SelectOptions from "../../../components/ui/SelectOptions";
import { InputField, PhoneInputField } from "../../../components/ui/Inputs";
import remarkSave from "./../../../assets/images/icons/remarkSave.png";
import InfoIcon2 from "../../../assets/icons/notification/info.png";
import {
  ErrorButton,
  OutlinedPrimaryButton,
  PrimaryButton,
  EditSecondaryButton,
  OutlinedSmallButton,
  OutlinedSecondaryButton
} from "../../../components/ui/Button";
import ButtonLoader from "../../../components/ui/ButtonLoader";
import Divider from "@mui/material/Divider";
import { Controller, set, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { setStatusPopup,clearStatusPopup } from "../../../services/redux/slices/statusPopupSlice";
import { RootState } from "../../../services/redux/store";
import service from "../../../services/api/service";
import postsServices from "../../../services/api/service/postsService";
import BasicDatePicker from "../../../components/ui/BasicDatePicker";
import dayjs from "dayjs";
import { handleKeyDown, getInitials } from "../../../utils/helpers";
import AddNewDocuments from "../../../components/ui/AddNewDocuments";
import AccountAggregator from "../../../components/ui/AccountAggregator";
import SearchSelectOption from "../../../components/ui/SearchSelectOption";
import { resetDisbursementButtonValue } from "../../../services/redux/slices/disbursementButtonSlice";
import ModalPopup from "../../../components/ui/ModalPopup";
import { setDocumentFormType } from "../../../services/redux/slices/documentFormSlice";
import {
  setDocumentNewData,
  clearDocumentFormType,
  clearDocumentNewData,
} from "../../../services/redux/slices/documentFormSlice";

import {
  authSelector,
  userLoanCatSelector,
} from "../../../services/redux/slices/authSlice";

import { formatIndianRupees } from "../../../utils/formatting";
import Card from "../../../components/ui/Card";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import WestIcon from "@mui/icons-material/West";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import DisbursementFormTermDetails from "./DisbursementFormTermDetails";
import DisbursementFormThanksPage from "./DisbursementFormThanksPage";
import documentsServices from "../../../services/api/service/documentService";
import CloseIcon from "@mui/icons-material/Close";
import { formatDateTime, formatDate,getDaysBetween,
    getDateRangeObject
} from "../../../utils/dateFormatUtils";
import { commonStyles } from "./styles";
import ConfirmDialog from "../../../components/ui/ConfirmModal";
import { trackEvent } from "../../../utils/ga";
import { decrypt } from "../../../utils/crypto";
import { actionRowDataSelector } from "../../../services/redux/slices/disbursementButtonSlice";
import CardDisbursement from "../../../components/ui/CardDisbursement";
import FundRequestCard from "../../../components/ui/mobile/FundRequestCard";
import InfoIcon from "../../../assets/images/icons/info.png";
import { get, request } from "http";
import { AxiosError } from "axios";
import { DialogBox, DialogBoxContent } from "../../../components/ui/DialogBox";
import { display } from "@mui/system";
interface Remark {
  updated_at: string;
  remark: string;
  role: string;
}
interface AggregatorData {
  status: string;
  // add other fields if needed
}
interface ExtendedFormData extends FormData {
  disbursementFormId: any; // or the appropriate type
}

interface FormData {
  requestType: string;
  paymentTypeId: number;
  universityId: number;
  bankId: number;
  lienBankId : string;
  disbursementPurpose1: any;
  disbursementPurpose: any;
  disbursementPurposeId: any;
  changeUniversityName: boolean;
  newUniversityId?: number;
  paymentCurrencyId: any;
  paymentDate: string;
  ifsccode: string;
  accountNumber: string;
  reEnterAccountNumber: string;
  requestedAmount: any;
  accHolderName: string;
  AmountPaid: number | null;
  overseasNumber?: string;
  overseasaddress?:string;
  countryCodeId?: any;
  isNewUniversity: any;
  loanAccountNumber: any;
  paymentMadeTo: any;
  avanseRemark: string;
  Remark: string;
  Key: string;
  // exchangePartner: string;
  accountTypeId: number;
  otherDisbursementPurpose: string;
  lienIfscCode: string;
  lienAccountHolderName: string;
  lienAccountNumber: string;
  reEnterLienAccountNumber: string;

}

interface Option {
  value: string;
  label: string;
}
interface FormValues {
  requestedAmount: number | "";
  // Add other fields as needed
}

// Utility function to mask account number
const maskAccountNumber = (accountNumber: string): string => {
  if (!accountNumber) return '';
  if (accountNumber.length <= 4) return accountNumber;
  const visiblePart = accountNumber.slice(-4);
  const maskedPart = 'x'.repeat(accountNumber.length - 4);
  return maskedPart + visiblePart;
};

// Utility function to validate account number match
const validateAccountNumberMatch = (original: string, reEnter: string): boolean => {
  return original === reEnter && original !== '' && reEnter !== '';
};

const DisbursementFormTerm: React.FC = () => {
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));
  const [changeUniversity, setChangeUniversity] =
    React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isLoadingUpdate, setIsLoadingUpdate] = React.useState(false);
  const [isLoadingUpdateNew, setIsLoadingUpdateNew] = React.useState(true);
  const [isLoadingUpdateSave, setIsLoadingUpdateSave] = React.useState(false);
  const [isShowModal, setIsShowModal] = useState(false)
  const modalStyle=
    {
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      bgcolor: "background.paper",
      borderTopLeftRadius: "16px",
      borderTopRightRadius: "16px",
      boxShadow: "0px -2px 10px rgba(0,0,0,0.2)",
      maxHeight: "85vh",
      overflowY: "auto",
      p: 2,
    }
  const [activeStep, setActiveStep] = React.useState<number>(0);
  const [isEditable, setIsEditable] = React.useState<boolean>(true);
  const [openModalNew, setOpenModalNew] = React.useState<boolean>(false);
  const [isDisbTypeApproved, setisDisbTypeApproved] = React.useState<boolean>(false);
  const [allDocsPresent, setallDocsPresent] = React.useState<boolean>(false);
  const [isEditableNext, setIsEditableNext] = React.useState<boolean>(true); // Editable state
  const [showEditButton, setShowEditButton] = useState(false);
  const [buttonEnable, setButtonEnable] = React.useState<boolean>(true);
  const [dataSet, setDataSet] = React.useState<any>({});
  const [dataSetRemark, setDataSetRemark] = React.useState<any>({});
  const [isRemarkLoading, setIsRemarkLoading] = React.useState<any>(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [cancelRemark, setCancelRemark] = useState("");
  const [bankList, setBankList] = useState<any>([]);
  const [bankListLien, setBankListLien] = useState<any>([]);
  const [aggregatorData, setAggregatorData] = useState<any>([]);
  const [isLoadingConsent, setisLoadingConsent] = React.useState<any>(false);
  const [validConsent, setValidConsent] = React.useState<any>(false);
  const [aggregatorNo, setAggregatorNo] = React.useState<any>("");
  const [continueButton, setContinueButton] = React.useState<any>(false);
  
  // State variables for account number masking
  const [accountNumberFocused, setAccountNumberFocused] = useState(false);
  const [reEnterAccountNumberFocused, setReEnterAccountNumberFocused] = useState(false);
  const [lienAccountNumberFocused, setLienAccountNumberFocused] = useState(false);
  const [reEnterLienAccountNumberFocused, setReEnterLienAccountNumberFocused] = useState(false);
  
  // State variables for account number validation errors
  const [accountNumberError, setAccountNumberError] = useState<string>("");
  const [lienAccountNumberError, setLienAccountNumberError] = useState<string>("");
  
  const initialFetch = useRef(false);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    control,
    setError,
    getValues,
    clearErrors,
    trigger,
    formState: { errors },
  } = useForm<FormData>();
  const [showHello, setShowHello] = React.useState<boolean>(false);
  const [showHelloOne, setShowHelloOne] = React.useState<boolean>(false);
  const [showRemark, setShowRemark] = useState(false);
  // const changeUniversityName = watch("changeUniversityName");
  const [activeFunction, setActiveFunction] = React.useState<number>(0);
  const [formID, setFormID] = useState(0);
  const [paymentTypeId, setPaymentTypeId] = useState(0);
  const [requestType, setRequestType] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isQueryable, setIsQueryable] = useState(false);
  const [isMoveToNext, setMoveToNext] = useState(false);
  const [formStatus, setFormStatus] = useState("");
  const [remarkId, setRemarkId] = useState(0);
  const [isRemarkHistoryList, setIsRemarkHistoryList] = useState(false);
  const [isContinue, setIsContinue] = useState(false);
  const [paymentCurrencyField, setPaymentCurrencyField] = useState(false);
  const [isFormSaved, setIsFormSaved] = useState(false);
  const [validationTrigger, setValidationTrigger] = useState(0); // For forcing validation updates
  // const selectedFormType = useSelector(
  //   (state: RootState) => state?.documentFormSlice
  // );
  const actionRowData = useSelector(actionRowDataSelector);
  const [disbList, setDisbList] = useState<any>([]);
  const [accountTypeList, setAccountTypeList] = useState<any>([]);
  const [accountTypeId, setAccountTypeId] = useState<any>(0);
  const [errorMessageAmountPaid, setErrorMessageAmountPaid] = useState<
    string | null
  >(null);
  const [lengthValidation, setLengthValidation] = useState({
    lien: {
      min: null,
      max: null
    },
    beneficiary: {
      min: null,
      max: null
    },
  });

  const [refernceNo, setRefernceNo] = useState<string>("");

  const dashboardDataSet = useSelector(
    (state: RootState) => state.dashboardData.sanctionedDisbursedData
  );
  const handleCloseModalNew=(val:boolean)=>{
    setOpenModalNew(val)
  }
  const handleNext = () => {
    switch (activeStep) {
      case 0:
      case 1:
        // Scroll to the top of the page
        window.scrollTo({
          top: 0,
          behavior: "smooth", // Optional: adds a smooth scrolling effect
        });
        break;
      default:
        break;
    }
    setActiveStep((prevActiveStep) => Math.min(prevActiveStep + 1, 5));
  };
  const handleBack = () => {
    removeQueryParams(window.location.href);
    if (isFormSaved) {
      dispatch(
        setStatusPopup({
          status: "info",
          message:
            "Unsaved data will be lost. Please save your changes before leaving this page.",
          isFunction: true,
          locationFunction: () => handleCancelIsFormSaved(),
        })
      );
    } else {
      if(activeStep==2){
        setActiveStep(1);
        return;
      }
      handlePrevNavigate();
    }
  };
  const handleBackyes = () => {
    if (isFormSaved) {
      dispatch(
        setStatusPopup({
          status: "info",
          message:
            "Unsaved data will be lost. Please save your changes before leaving this page.",
          isFunction: true,
          locationFunction: () => handleCancelIsFormSaved(),
        })
      );
    } else {
      handlePrevNavigate();
    }
  };
  /**
   * Handles the form saved state by setting the `isFormSaved` state to true
   * and dispatching an action to update the document data.
   *
   * @function handleIsFormSaved
   * @returns {void}
   */
  const handleIsFormSaved = (): void => {
    setIsFormSaved(true);
    dispatch(setDocumentNewData(true));
    dispatch(setDocumentFormType("continue"));
  };
  /**
   * Handles the action to set the form saved state to false.
   * This function updates the state to indicate that the form is not saved
   * and dispatches an action to update the document data state.
   */
  const handleIsFormSavedFalse = () => {
    setIsFormSaved(false);
    dispatch(clearDocumentNewData());
  };

  /**
   * Handles the cancel action for the form and updates the state accordingly.
   *
   * This function performs the following actions:
   * 1. Sets the `isFormSaved` state to `false`.
   * 2. Dispatches an action to update the document new data state to `false`.
   * 3. Navigates to the previous page.
   *
   * @returns {void}
   */
  const handleCancelIsFormSaved = () => {
    setIsFormSaved(false);
    dispatch(clearDocumentFormType());
    handlePrevNavigate();
  };

  const handleCancelForm = () => {
    setConfirmModal(true)
  }

  const handlePrevNavigate = () => {
    dispatch(resetDisbursementButtonValue());
    setActiveStep((prevActiveStep) => Math.max(prevActiveStep - 1, 0));
  };

  const handleCheckboxChange = (checked: any) => {
    if (isEditable) {
      setChangeUniversity(checked);
      setValue("isNewUniversity", checked);
      setValue("newUniversityId", undefined)
    }

    // Reset the newUniversityId when the checkbox is unchecked
    if (!checked) {
      setValue("newUniversityId", undefined); // or set to an empty string
    }
  };


  const dispatch = useDispatch();
  const selectedLoanNumber = useSelector(
    (state: RootState) => state?.dashboardData?.selectedLoanNumber
  );
  const loanTypeId = useSelector(
    (state: RootState) => state?.dashboardData?.sanctionedDisbursedData[0]?.loanTypeId
  );
  const lastDisbursementStatus = useSelector(
    (state: RootState) => state?.disbursementButtonSlice?.lastDisbursementStatus
  );
  const rowData = useSelector(
    (state: RootState) => state?.disbursementButtonSlice?.actionRowData
  );
  const formStatusValue = useSelector(
    (state: RootState) => state?.documentFormSlice?.formType
  );

  const onSubmit = async (data: FormData, endpoint: string) => {
    try {
      const response = await postsServices.addPost(endpoint, data);
      return response; // Return the entire response for further checks
    } catch (error) {
      throw error; // Propagate the error
    }
  };
  const handleRequestDetailsCondition = () => {
    if (getValues("requestType") == "lien") {
      return true;
    }
    return false;
  }
  const handleBankDetailsCondition = () => {
    if (getValues("paymentTypeId") == 3 && getValues("accountTypeId") == 2) {
      return true;
    } else if (
      getValues("paymentTypeId") == 5 
    ) {
      return true;
    } else if (
      getValues("paymentTypeId") == 1 &&
      getValues("accountTypeId") == 2
    ) {
      return true;
    } else if (
      getValues("paymentTypeId") == 1 &&
      getValues("accountTypeId") == 1
    ) {
      return false;
    } else if (
      getValues("paymentTypeId") == 4 &&
      getValues("accountTypeId") == 1
    ) {
      return false;
    } else if (
      getValues("paymentTypeId") == 3 &&
      getValues("accountTypeId") == 1
    ) {
      return false;
    }

    return false;
  };

  /**
   * Handles the continuous save operation for document submission.
   *
   * This function validates that every document in the form has at least one file uploaded.
   * If validation passes, it submits all documents using the `documentsServices.submitAllDocument` service.
   * Depending on the response status, it updates the loading state and active function.
   * If validation fails, it sets an error message and displays a toast notification.
   *
   * @async
   * @function handleContinousSave
   * @returns {Promise<void>} A promise that resolves when the save operation is complete.
   */

  const { userProfile, businessType } = useSelector(authSelector);
  const [mobileNumberNew, setMobileNumber] = useState<string>(
    decrypt(userProfile?.phoneNumber) || ""
  );
  const userLoanCategory = useSelector(userLoanCatSelector);
  const handleContinueUnderStand = async () => {
    if(isXsOrSm){
      setOpenModalNew(true)
    }else{
      setIsLoadingUpdate(true);
      setIsShowModal(true)
      // dispatch(
      //   setStatusPopup({
      //     status: "Important Information",
      //     // message: `One request is already raised, and its status is ${lastDisbFormStatusData?.lastDisbStatus}. You cannot raise a new request until the current request is approved or rejected. To continue with the open request, please click the action button below.`,
      //     message: "While processing the final disbursement amount, the amount marked as lien in your partner bank account will be disbursed first by lien removal and any additional funds required will be disbursed from Avanse as a tranche disbursement provided the total disbursement amount is within the sanctioned limit.\nPlease confirm to proceed.",
      //     buttonConfirm: true,
      //     btnFunc:handleContinousSave,
      //   })
      // );
      setIsLoadingUpdate(false);
    }
  }

  const handleContinousSave = async (): Promise<void> => {
    trackEvent('Dash_Disb_SubmitRequest', decrypt(userProfile?.id), {
      label: 'Dash_Disb_SubmitRequest',
      category: 'Dash_Disb_SubmitRequest',
      action: 'Dash_Disb_SubmitRequest',
    });
    setOpenModalNew(false);
    setIsLoadingUpdate(true);
    setActiveFunction(0);

    const body = {
      disbursementFormId: formID,
      remark: watch("Remark"),
      remarkId: remarkId,
      business: businessType?.id,
      loanCategory: userLoanCategory?.TermLoan[0]?.loanCategoryId,
      type:requestType,
    };

    if (!watch("Remark")) {
      dispatch(
        setStatusPopup({
          status: "error",
          message: "Remark is required field.",
          buttonStatus: false,
        })
      );
      return;
    }

    const response: any = await documentsServices.submitAllDocument(body);
    if (response?.status == 200) {
      setActiveStep(4);
      localStorage.setItem("activeFormStep", "4");
      setIsLoadingUpdate(false);
      setIsShowModal(false)
      dispatch(clearStatusPopup());
      // dispatch(
      //   setStatusPopup({
      //     status: "success",
      //     message: "Disbursement request submited successfully !",
      //   })
      // );
      dispatch(clearDocumentFormType());
    } else {
      setIsLoadingUpdate(false);
    }
  };

  /**
   * Converts the undisbursed loan amount from the last disbursement status to a number.
   * The amount is formatted as Indian Rupees and then stripped of any non-numeric characters
   * before being converted to a number.
   *
   * @returns {number} The undisbursed loan amount as a number.
   */
  const convertUndisbValue = useMemo(() => {
    const value = formatIndianRupees(
      lastDisbursementStatus?.loanUndisbursedAmount
    );
    return Number(value.replace(/[^\d.-]/g, "").split(".")[0]);
  }, [lastDisbursementStatus?.loanUndisbursedAmount]);
  const convertSanctionedValue = useMemo(() => {
    const value = formatIndianRupees(
      lastDisbursementStatus?.totalSanctionedAmount
    );
    return Number(value.replace(/[^\d.-]/g, "").split(".")[0]);
  }, [lastDisbursementStatus?.totalSanctionedAmount]);
  const handleValidateForm = () => {
    const formValues = getValues();

    let objectValue: any;
    if (showHello) {
      objectValue = {
        paymentTypeId: formValues.paymentTypeId,
        universityId: formValues.universityId,
        disbursementPurposeId: formValues.disbursementPurposeId,
        overseasaddress: formValues.overseasaddress,
        paymentCurrencyId: formValues.paymentCurrencyId,
        // exchangePartner: formValues.exchangePartner,
        requestedAmount: formValues.requestedAmount,
        countryCodeId: formValues.countryCodeId,
        overseasNumber: formValues.overseasNumber,
        Remark: formValues.Remark,
        accountType: formValues.accountTypeId,
      };
    } else {
      objectValue = {
        paymentTypeId: formValues.paymentTypeId,
        universityId: formValues.universityId,
        disbursementPurposeId: formValues.disbursementPurposeId,
        paymentCurrencyId: formValues.paymentCurrencyId,
        paymentDate: formValues.paymentDate,
        requestedAmount: formValues.requestedAmount,
        overseasaddress: formValues.overseasaddress,
        AmountPaid: formValues.AmountPaid,
        countryCodeId: formValues.countryCodeId,
        overseasNumber: formValues.overseasNumber,
        paymentMadeTo: formValues.paymentMadeTo,
        Remark: formValues.Remark,
        accountType: formValues.accountTypeId,
      };
    }
    if (getValues("paymentTypeId") == 3) {
      delete objectValue?.paymentDate;
      delete objectValue?.disbursementPurposeId;
      if(!objectValue?.overseasNumber){
        delete objectValue?.overseasNumber;
      }
      if(!objectValue?.overseasaddress){
        delete objectValue?.overseasaddress;
      }
      if(!objectValue?.countryCodeId){
        delete objectValue?.countryCodeId;
      }
      objectValue = {
        ...objectValue,
        otherDisbursementPurpose: formValues.otherDisbursementPurpose,
      };
    }
    if (getValues("paymentTypeId") == 5) {
      delete objectValue?.AmountPaid;
      delete objectValue?.paymentDate;
      delete objectValue?.paymentMadeTo;
      delete objectValue?.disbursementPurposeId;
      if(!objectValue?.overseasNumber){
        delete objectValue?.overseasNumber;
      }
      if(!objectValue?.overseasaddress){
        delete objectValue?.overseasaddress;
      }
      if(!objectValue?.countryCodeId){
        delete objectValue?.countryCodeId;
      }
      objectValue = {
        ...objectValue,
        otherDisbursementPurpose: formValues.otherDisbursementPurpose,
      }
    }
    if(getValues("paymentTypeId") == 5 || getValues("paymentTypeId") == 3){
      if(objectValue?.countryCodeId==null){
        delete objectValue?.countryCodeId;
      }
      if(objectValue?.overseasNumber==""){
        delete objectValue?.overseasNumber;
      }
      if(objectValue?.overseasaddress==""){
        delete objectValue?.overseasaddress;
      }
      objectValue = {
        ...objectValue,
      };
    }
    if(getValues("paymentTypeId")!=1){
       delete objectValue?.paymentDate;
       delete objectValue?.AmountPaid;
       delete objectValue?.paymentMadeTo;
       objectValue = {
        ...objectValue,
      };
    }
    if (getValues("paymentTypeId") == 1 || getValues("paymentTypeId") == 2 || getValues("paymentTypeId") == 1 ||getValues("paymentTypeId") == 3 ||getValues("paymentTypeId") == 4 ||getValues("paymentTypeId") == 5) {
      if(!objectValue?.overseasNumber){
        delete objectValue?.overseasNumber;
      }
      if(!objectValue?.overseasaddress){
        delete objectValue?.overseasaddress;
      }
      if(!objectValue?.countryCodeId){
        delete objectValue?.countryCodeId;
      }
      objectValue = {
        ...objectValue,
      }
    }
    if (handleBankDetailsCondition()) {
      objectValue = {
        ...objectValue,
        bankId: formValues.bankId,
        accountNumber: formValues.accountNumber,
        ifsccode: formValues.ifsccode,
        accHolderName: formValues.accHolderName,
      };
    } else {
      objectValue = {
        ...objectValue,
        // exchangePartner: formValues.exchangePartner,
      };
    }
    // formatIndianRupees
    if (formStatus == "reject" ||
      formStatus == "approve" ||
      formStatus == "pendingFromOperationMaker" ||
      formStatus=="pendingFromLienOperationChecker" ||
      formStatus == "pendingFromOperationChecker" ||
      formStatus == "pendingFromCredit" ||
      formStatus == "pendingFromCollection" ||
      formStatus == "cancelled" ||
      formStatus == "pendingFromSalesCoordinator" ||
      (isEnabled && formStatus == "query")) {
      return false
    }

    if (formValues?.isNewUniversity == true) {
      if (formValues?.newUniversityId == undefined || formValues?.newUniversityId == null) {
        return true
      }
    }
    if (objectValue?.AmountPaid && Number(objectValue?.AmountPaid) > Number(convertUndisbValue) && getValues("accountTypeId") ==2 && getValues("requestType")!="lien") {
      return true;
    }
    if (objectValue?.AmountPaid && Number(objectValue?.AmountPaid) > Number(convertSanctionedValue) && getValues("accountTypeId") ==2 && getValues("requestType")=="lien") {
      return true;
    }
    if (objectValue?.requestedAmount && Number(objectValue?.requestedAmount) > Number(convertUndisbValue) && getValues("accountTypeId") ==2 && getValues("requestType")!="lien") {
      return true;
    }
    if (objectValue?.requestedAmount && Number(objectValue?.requestedAmount) > Number(convertSanctionedValue) && getValues("accountTypeId") ==2 && getValues("requestType")=="lien") {
      return true;
    } 
    if (objectValue?.requestedAmount && objectValue?.AmountPaid && Number(objectValue?.requestedAmount) > Number(objectValue?.AmountPaid) ) {
      return true;
    }
    // Add validation for lien account fields when requestType is "2"
    if (getValues("requestType") == "lien") {
      // Check if lien account fields are required and filled
      if (!formValues.lienBankId  || formValues.lienBankId  === "") {
        return true;
      }
      if (!formValues.lienAccountNumber || formValues.lienAccountNumber === "") {
        return true;
      }
      if (!formValues.lienAccountHolderName || formValues.lienAccountHolderName === "") {
        return true;
      }
      if (!formValues.lienIfscCode || formValues.lienIfscCode === "") {
        return true;
      }
      // Validate re-enter lien account number
      if (!formValues.reEnterLienAccountNumber || formValues.reEnterLienAccountNumber === "") {
        return true;
      }
      if (formValues.lienAccountNumber !== formValues.reEnterLienAccountNumber) {
        return true;
      }
    }
    
    // Add validation for beneficiary account number re-enter field
    if (handleBankDetailsCondition()) {
      if (!formValues.reEnterAccountNumber || formValues.reEnterAccountNumber === "") {
        return true;
      }
      if (formValues.accountNumber !== formValues.reEnterAccountNumber) {
        return true;
      }
    }
    const isFormValid = Object.entries(objectValue).some(
      ([key, value]: any) => {
        if(((key==="overseasNumber" || key==="overseasaddress" || key === "countryCodeId") && (getValues("paymentTypeId")==1 || getValues("paymentTypeId")==2 || getValues("paymentTypeId")==4 || getValues("paymentTypeId")==3 || getValues("paymentTypeId")==5)) ){
          return false;
        }
        if (value == "" || value == null) return true;
        switch (key) {
          case "requestedAmount":
            {
              if(getValues("requestType") != "lien" && getValues("paymentTypeId") != 5 && getValues("accountTypeId") != 1){
                return parseInt(value) <= 0 || parseInt(value) > convertUndisbValue;
              }
              return false;
            }
          case "AmountPaid" : 
              {
            if (getValues("paymentTypeId") !== 5 && getValues("accountTypeId") != 1 && getValues("paymentTypeId") !== 1) {
              return (
                getValues("requestedAmount") > Number(value) ||
                Number(value) > convertUndisbValue
              );
            }
            return false; // skip validation if paymentTypeId === 5
          }
          case "overseasNumber":{
            if(value){
             return value.length < 7 || value.length > 15;
            }
            return false;
          }
            
          case "ifsccode":
            if(value){
              return !/^[A-Z0-9]{11}$/.test(value);
            }
            return false;
          case "accountNumber":
            if(value){
              return value.length < 8 || value.length > 17;
            }
            return false;
          default:
            return false;
        }
      }
    );
    return isFormValid;
  };
  const handleContinueAggregator=()=>{
    
  }
  const handleContinue = async (data: FormData) => {
    try {
      let continueData: any = getPayload(data, "continue");
      if (formStatus === "approve" || formStatus === "reject") {
        //handleNext();
      }
      if (!handleValidateForm()) {
        if (!handleBankDetailsCondition()) {
          delete continueData.bankId;
          delete continueData.accountNumber;
          delete continueData.ifsccode;
          delete continueData.accHolderName;
        } else {
          delete continueData.exchangePartner;
        }
        
        const createData: any = {
          ...continueData,
          requestedAmount: parseInt(continueData.requestedAmount),
          disbursementFormId: formID,
          exchangePartner: ""
        };

        if (formStatus != "query") {
          if (remarkId > 0) {
            createData["remarkId"] = remarkId;
          }
        }

        if (refernceNo) {
          createData["referenceNo"] = refernceNo;
        }
        if (isMoveToNext === false) {
          setIsLoadingUpdate(true);
          const createDataResponse = await onSubmit(
            createData,
            "/api/v1/disbursement-form/create-form"
          );
          const dataValue: any =
            createDataResponse?.data?.data?.saveForm?.remark?.find(
              (elem: any) => elem?.role === "customer"
            );
          const dataValueAgg: any =
            createDataResponse?.data?.data?.consentData;
          setRemarkId(dataValue?.id);
          setIsLoadingUpdate(false);
          setAccountTypeId(data?.accountTypeId);
          setPaymentTypeId(data.paymentTypeId);
          setRequestType(data?.requestType)
          setFormID(createDataResponse?.data?.data?.saveForm?.id);
          localStorage.setItem("disbursementFormId", createDataResponse?.data?.data?.saveForm?.id);
          setRefernceNo(createDataResponse?.data?.data?.saveForm?.refernceNo);
          setIsRemarkHistoryList(true);
          setFormStatus(createDataResponse?.data?.data?.saveForm?.status);
          if(dataValueAgg?.referenceNo){
            localStorage.setItem("aggApplicationNo", dataValueAgg?.referenceNo)
            setAggregatorNo(dataValueAgg?.referenceNo);
          }
          setErrorMessageAmountPaid(null);
          setErrorMessage(null);
          dispatch(
            setDocumentFormType(
              createDataResponse?.data?.data?.saveForm?.formStatus
            )
          );
          handleIsFormSavedFalse();
        }
        handleNext();
      } else {
        setIsContinue(true);
      }
    } catch (error: unknown) {
      setIsLoadingUpdate(false);
      dispatch(
        setStatusPopup({
          status: "error",
          message:error instanceof AxiosError
          ? error.response?.data?.message ||  "Something went wrong!"
          : "Something went wrong!",
          buttonStatus: false,
        })
      );
    }
  };

  /**
   * Validates the form values based on specific business rules.
   *
   * @returns {boolean} - Returns `true` if the form values pass all validation checks, otherwise `false`.
   *
   * The validation checks include:
   * - If `showHello` is false, the `AmountPaid` should not exceed the `loanUndisbursedAmount`.
   * - If `accountTypeId` is 2, the `accountNumber` should be between 8 and 17 characters long,
   *   and the `ifsccode` should match the regex pattern `/^[A-Z0-9]{11}$/`.
   * - The `requestedAmount` should not exceed the `loanUndisbursedAmount`.
   * - The `requestedAmount` should not exceed the `AmountPaid`.
   * - The `overseasNumber` should be between 7 and 15 characters long.
   */
  const handleSaveFormValidation = (): boolean => {
    const formValues: any = getValues();
    if (!showHello) {
      if (Number(formValues?.AmountPaid) > convertUndisbValue && formValues?.requestType!="lien") {
        //turn false;
      }
    }

    if (formValues?.accountTypeId == 2) {
      if (formValues?.ifsccode != "" && formValues?.accountNumber?.length > 0) {
                if (
          formValues?.accountNumber?.length < 8 ||
          formValues?.accountNumber?.length > 17
        ) {
          return false;
        } else if (!/^[A-Z0-9]{11}$/.test(formValues?.ifsccode)) {
          return false;
        }
      }
    }

    if (formValues?.requestedAmount) {
      if (Number(formValues?.requestedAmount) > convertUndisbValue) {
        //return false;
      }
    } else if (formValues?.requestedAmount && formValues?.AmountPaid) {
      if (
        Number(formValues?.requestedAmount) > Number(formValues?.AmountPaid)
      ) {
        return false;
      }
    }

    if (formValues?.overseasNumber) {
      if (
        formValues?.overseasNumber.length < 7 ||
        formValues?.overseasNumber.length > 15
      ) {
        return false;
      }
    }

    return true;
  };
  const handleBankName=async()=>{
    const response = await postsServices.addPost(
        "/api/v1/lien-bank-details/fetch",
        {}
      );
    setBankList(response?.data?.data);
  }
  const handleBankNameLien=async()=>{
    const response = await postsServices.addPost(
        "/api/v1/lien-bank-details/fetch",
        {}
      );
    setBankListLien(response?.data?.data);
  }
  const handleSave = async (data: FormData) => {
    if (!handleSaveFormValidation()) return;

    setIsLoadingUpdateSave(true);

    // Use getPayload to ensure re-enter fields are not included in the payload
    const basePayload = getPayload(data, "save");
    const payload: any = {
      ...basePayload,
      disbursementFormId: formID,
      requestedAmount: parseInt(data.requestedAmount),
    };
    if (formStatus != "query") {
      if (remarkId > 0) {
        payload["remarkId"] = remarkId;
      }
    }
    if (isQueryable) {
      payload["type"] = 1;
    }

    if (refernceNo) {
      payload["referenceNo"] = refernceNo;
    }

    try {
      const response = await postsServices.addPost(
        "api/v1/disbursement-form/save-form",
        payload
      );
      setFormID(response?.data?.data?.id);
      localStorage.setItem("disbursementFormId", response?.data?.data?.id);
      setIsContinue(false);
      setIsLoadingUpdateSave(false);

      if (typeof response?.data?.data?.remark === "object") {
        const setRemarkIdValue: any = response?.data?.data?.remark.find(
          (elem: any) => elem?.role === "customer"
        );
        if (setRemarkIdValue?.role == "customer") {
          setRemarkId(setRemarkIdValue?.id);
        }
      }
      setFormStatus("save");
      setRefernceNo(response?.data?.data?.refernceNo);
      setIsRemarkHistoryList(true);
      handleIsFormSavedFalse();
      // // Handle success response
      dispatch(
        setStatusPopup({
          status: "success",
          message: "Data saved successfully.",
          buttonStatus: false,
        })
      );
    } catch (error) {
      // Handle error response
      setIsLoadingUpdateSave(false);
      dispatch(
        setStatusPopup({
          status: "error",
          message: "An error occurred during save.",
          buttonStatus: false,
        })
      );
    }
  };
  const getPayload = (
    data: FormData,
    key: string,
    existingData: FormData[] = []
  ): FormData => {
    const {
      paymentTypeId,
      bankId,
      disbursementPurpose1,
      disbursementPurpose,
      disbursementPurposeId,
      changeUniversityName,
      overseasNumber,
      requestedAmount,
      paymentCurrencyId,
      paymentDate,
      ifsccode,
      accountNumber,
      overseasaddress,
      accHolderName,
      AmountPaid,
      countryCodeId,
      paymentMadeTo,
      Remark,
      // exchangePartner,
      newUniversityId,
      accountTypeId,
      otherDisbursementPurpose,
      requestType
    } = data;
    
    let commonFields: any = {
      universityId: data?.universityId || null,
      isNewUniversity: data?.isNewUniversity || false,
      newUniversityId: data.newUniversityId,
      overseasNumber,
      overseasaddress,
      countryCodeId,
      requestedAmount,
      paymentCurrencyId: paymentCurrencyId || null,
      loanAccountNumber: selectedLoanNumber, // Ensure this is set correctly
      Remark,
      Key: key,
      // exchangePartner,
      accountTypeId: accountTypeId || null,
      requestType: requestType || null,
    };
    if(requestType=="lien"){
      commonFields = {
      universityId: data?.universityId || null,
      isNewUniversity: data?.isNewUniversity || false,
      newUniversityId: data.newUniversityId,
      overseasNumber,
      overseasaddress,
      countryCodeId,
      requestedAmount,
      paymentCurrencyId: paymentCurrencyId || null,
      loanAccountNumber: selectedLoanNumber, // Ensure this is set correctly
      lienAccountHolderName: data?.lienAccountHolderName || "",
      Remark,
      Key: key,
      // exchangePartner,
      accountTypeId: accountTypeId || null,
      requestType: requestType || null,
      lienBankId : data?.lienBankId ,
      lienAccountNumber: data?.lienAccountNumber || "",
      lienIfscCode: data?.lienIfscCode || "",
    };
    }
    // Determine universityId based on existingData
    const universityId =
      existingData[0]?.isNewUniversity === true
        ? data.universityId || existingData[0]?.universityId
        : undefined; // Do not include if not needed

    if (paymentTypeId === 1) {
      if(!commonFields?.overseasNumber){
        delete commonFields?.overseasNumber;
      }
      if(!commonFields?.overseasaddress){
        delete commonFields?.overseasaddress;
      }
      if(!commonFields?.countryCodeId){
        delete commonFields?.countryCodeId;
      }
      return {
        ...commonFields,
        paymentTypeId,
        disbursementPurpose1: disbursementPurpose1 || "",
        disbursementPurpose: disbursementPurpose || "",
        disbursementPurposeId: disbursementPurposeId || null,
        paymentDate: paymentDate || "",

        bankId: bankId || 0,
        accHolderName: accHolderName || "",
        ifsccode: ifsccode || "",
        accountNumber: accountNumber || "",

        AmountPaid: AmountPaid || null,
        paymentMadeTo: paymentMadeTo || "",
        newUniversityId: newUniversityId,
        ...(universityId !== undefined && {
          universityId,
        }), // Include only if defined
      } as FormData;
    } else if (paymentTypeId === 2) {
      if(!commonFields?.overseasNumber){
        delete commonFields?.overseasNumber;
      }
      if(!commonFields?.overseasaddress){
        delete commonFields?.overseasaddress;
      }
      if(!commonFields?.countryCodeId){
        delete commonFields?.countryCodeId;
      }
      return {
        ...commonFields,
        paymentTypeId,
        disbursementPurposeId,
        ...(universityId !== undefined && {
          universityId,
        }), // Include only if defined
      } as FormData;
    } else if (paymentTypeId === 3) {
      
      if(!commonFields?.overseasNumber){
        delete commonFields?.overseasNumber;
      }
      if(!commonFields?.overseasaddress){
        delete commonFields?.overseasaddress;
      }
      if(!commonFields?.countryCodeId){
        delete commonFields?.countryCodeId;
      }
      return {
        ...commonFields,
        paymentTypeId,
        otherDisbursementPurpose:otherDisbursementPurpose,
        //paymentMadeTo: paymentMadeTo || "",
        //AmountPaid: AmountPaid || null,
        bankId: bankId || 0,
        accHolderName: accHolderName || "",
        ifsccode: ifsccode || "",
        accountNumber: accountNumber || "",
        ...(universityId !== undefined && {
          universityId,
        }), // Include only if defined
      } as FormData;
    } else if (paymentTypeId === 4) {
      if(!commonFields?.overseasNumber){
        delete commonFields?.overseasNumber;
      }
      if(!commonFields?.overseasaddress){
        delete commonFields?.overseasaddress;
      }
      if(!commonFields?.countryCodeId){
        delete commonFields?.countryCodeId;
      }
      return {
        ...commonFields,
        paymentTypeId,
        disbursementPurposeId,
        //paymentMadeTo: paymentMadeTo || "",
        //paymentDate: paymentDate || "",
        //AmountPaid: AmountPaid || null,
        ...(universityId !== undefined && {
          universityId,
        }), // Include only if defined
      } as FormData;
    }else if (paymentTypeId === 5) {
      if(!commonFields?.overseasNumber){
        delete commonFields?.overseasNumber;
      }
      if(!commonFields?.overseasaddress){
        delete commonFields?.overseasaddress;
      }
      if(!commonFields?.countryCodeId){
        delete commonFields?.countryCodeId;
      }
      return {
        ...commonFields,
        paymentTypeId,
        //disbursementPurposeId: disbursementPurposeId || null,
        otherDisbursementPurpose:otherDisbursementPurpose,
        //overseasaddress: overseasaddress || "",
        bankId: bankId || 0,
        accHolderName: accHolderName || "",
        ifsccode: ifsccode || "",
        accountNumber: accountNumber || "",
        // ...(overseasaddress ? { overseasaddress } : {}), // only add if truthy
        // ...(countryCodeId ? { countryCodeId } : {}), // only add if truthy
        newUniversityId: newUniversityId,
        ...(universityId !== undefined && {
          universityId,
        }), // Include only if defined
      } as FormData;
    }
    // Handle case if paymentTypeId is neither 1 nor 2
    return {} as FormData; // Adjust as necessary based on your requirements
  };

  const formIdpayload =
    rowData === ""
      ? localStorage.getItem("disbursementFormId") ?? lastDisbursementStatus?.lastDisbFormId
      : rowData?.disbFormId;

  useEffect(() => {
    if (formStatus == "reject" ||
      formStatus == "approve" ||
      formStatus == "pendingFromOperationMaker" ||
      formStatus=="pendingFromLienOperationChecker" ||
      formStatus == "pendingFromOperationChecker" ||
      formStatus == "pendingFromCredit" ||
      formStatus == "pendingFromCollection" ||
      formStatus == "cancelled" ||
      formStatus == "pendingFromSalesCoordinator"){
        setContinueButton(true);
      }
    if (formStatus == "query") {
      dispatch(
        setStatusPopup({
          status: "info",
          message: "A query is raised on this request. Please review the remarks provided. You can then click edit to update the request details or upload additional documents as required.",
          buttonStatus: false,
        })
      );
    }
  }, [formStatus])
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        let payloadData: any = {};
        if (Object.keys(rowData).length <= 0) {
          payloadData = {
            formId:formIdpayload,
            type: 1,
            loanAccountNumber:selectedLoanNumber,
          };
        } else {
          payloadData = {
            formId: formIdpayload,
          };
        }
      if(loanTypeId!=undefined && loanTypeId!=null && loanTypeId!="" && loanTypeId!=0){
        payloadData["loanTypeId"]=loanTypeId
      }

        let response;
        if (formIdpayload) {
          response = await postsServices.addPost(
            "/api/v1/disbursement-form/default",
            payloadData
          );
        } else {
          response = await postsServices.addPost(
            "/api/v1/disbursement-form/default",
            {loanAccountNumber:selectedLoanNumber}
          );
        }

        const defaultData: any = response?.data?.data?.getDefaultData;
        const existingData = response?.data?.data?.getExistingData || [];
        const lienData: any = response?.data?.data?.getDefaultData?.existingLienValues || [];
        const remarksArray = existingData?.remark || [];
        let avanseRemarks = "";
        let customerRemarks = "";
        setFormID(response?.data?.data?.getExistingData?.id);
        setisDisbTypeApproved(response?.data?.data?.isDisbTypeApproved);
        setallDocsPresent(response?.data?.data?.allDocsPresent);
        setChangeUniversity(
          response?.data?.data?.getExistingData?.isNewUniversity
        );

        if (response?.data?.data?.getExistingData?.status == "cancelled") {
          setFormStatus(response?.data?.data?.getExistingData?.status);
        } else {
          setFormStatus(
            response?.data?.data?.getExistingData?.formStatus == "save"
              ? "save"
              : response?.data?.data?.getExistingData?.status
          );
        }

        if (typeof response?.data?.data?.getExistingData === "object") {
          dispatch(
            setDocumentFormType(
              response?.data?.data?.getExistingData?.formStatus
            )
          );
          const dataValue: any = response?.data?.data?.getExistingData;
          const dataStatus: boolean = response?.data?.data?.allDocsPresent;
          setIsRemarkHistoryList(true);
          setPaymentTypeId(dataValue?.paymentTypeId);
          setRequestType(dataValue?.requestType);
          setAccountTypeId(dataValue?.accountTypeId);
          setRefernceNo(dataValue?.refernceNo);
          if(dataValue?.consentData?.referenceNo){
            localStorage.setItem("aggApplicationNo", dataValue?.consentData?.referenceNo)
            setAggregatorNo(dataValue?.consentData?.referenceNo);
          }
          const activeStepValue = localStorage.getItem("activeFormStep");
          if (activeStepValue == "3") {
            setActiveStep(3);
          } else {
            if (dataValue?.requestType==="lien" && dataValue?.formStatus == "") {
              setActiveStep(2);
            }
            else if (dataValue?.formStatus == "continue") {
              const params = new URLSearchParams(window.location.search);
              const consent = params.get("consent");
              if (consent != "true") {
                if(dataStatus==true && dataValue?.requestType=="lien"){
                  setActiveStep(2);
                }else{
                 setActiveStep(1);
                }
              }
            }
          }

          const existsDatalen: number = Object.keys(dataValue).length;
          if (existsDatalen > 0) {
            setPaymentCurrencyField(dataValue?.paymentTypeId === 1);

            // if (!initialFetch.current) {
            handleInvokeDisbursementPurposeApi(dataValue?.paymentTypeId);
            //   initialFetch.current = true;
            // }
            const roleStatus: any =
              response?.data?.data?.getExistingData?.remark.find(
                (elem: any) => elem?.role === "Avanse"
              );
            if (roleStatus?.remark) {
              setShowRemark(true);
            }
            const setRemarkIdValue: any =
              response?.data?.data?.getExistingData?.remark.find(
                (elem: any) => elem?.role === "customer"
              );
            setRemarkId(setRemarkIdValue?.id);
          }
        }

        remarksArray.forEach((item: Remark) => {
          if (item.role === "Avanse") {
            avanseRemarks += `${item.remark.trim()} `;
          } else if (item.role === "customer") {
            customerRemarks += `${item.remark.trim()} `;
          }
        });

        // Set form values for remarks
        setValue("avanseRemark", avanseRemarks.trim());
        setValue("Remark", customerRemarks.trim());
        if (existingData?.paymentTypeId === 2) {
          setShowHello(true);
        } else {
          setShowHello(false); // Optional: reset if it's not 2
        }
        if (existingData?.paymentTypeId === 3 ||existingData?.paymentTypeId === 4 ||existingData?.paymentTypeId === 5 ) {
          setShowHelloOne(true);
        } else {
          setShowHelloOne(false); // Optional: reset if it's not 2
        }
        defaultData["AccountType"] = [
          {
            id: 1,
            accountType: "International Account",
          },
          {
            id: 2,
            accountType: "Indian Account",
          },
        ];
        defaultData["RequestType"] = [
          {
            id: "tranche",
            requestType: "New Tranche",
          },
          {
            id: "lien",
            requestType: "Fund Release from Lien A/c",
          },
        ];
        setDataSet(defaultData);
        if(rowData && rowData?.lienValues.find((item:any) => item.status === "query")) {
          setIsQueryable(true);
        }
        if (rowData?.status === "approve" || rowData?.status === "reject" || rowData?.status === "cancelled") {
          setMoveToNext(true);
          setIsEditable(false);
          setShowEditButton(false);
          // setShowRemark(true);
          const updatedData: FormData = {
            otherDisbursementPurpose:
              existingData?.otherDisbursementPurpose || "",
            accountTypeId: existingData?.accountTypeId || null,
            paymentTypeId: existingData?.paymentTypeId || null,
            universityId: existingData?.universityId || null,
            bankId: existingData?.bankId || null,
            disbursementPurpose1: existingData?.disbursementPurpose1 || "", // Ensure this is correct
            disbursementPurpose: existingData?.disbursementPurpose || "", // Ensure this is correct
            disbursementPurposeId: existingData?.disbursementPurposeId || null,
            changeUniversityName: existingData?.changeUniversityName || false, // Ensure this is correct
            paymentCurrencyId: existingData?.paymentCurrencyId || null,
            paymentDate: existingData?.paymentDate || "",
            ifsccode: existingData?.ifsccode || "",
            accountNumber: existingData?.accountNumber || "",
            requestedAmount: existingData?.requestedAmount || "",
            overseasaddress: existingData?.overseasaddress || "",
            accHolderName: existingData?.accHolderName || "",
            AmountPaid:
              existingData?.AmountPaid == "0" ? "" : existingData?.AmountPaid,
            countryCodeId: existingData?.countryCodeId || null,
            overseasNumber: existingData?.overseasNumber || "",
            isNewUniversity: existingData?.isNewUniversity || false,
            loanAccountNumber: existingData?.loanAccountNumber,
            paymentMadeTo: existingData?.paymentMadeTo || "",
            // Remark: `${avanseRemarks.trim()}\n${customerRemarks.trim()}`,
            avanseRemark: avanseRemarks.trim(),
            Remark: customerRemarks.trim(),
            Key: "continue",
            // exchangePartner: existingData?.exchangePartner || "",
            newUniversityId: existingData?.newUniversityId || null,
            requestType:existingData?.requestType || "",
            lienAccountNumber: existingData?.lienAccountNumber || "",
            lienIfscCode: existingData?.lienIfscCode || "",
            lienBankId : existingData?.lienBankId ,
            lienAccountHolderName:existingData?.lienAccountHolderName || "",
            reEnterAccountNumber: existingData?.accountNumber || "",
            reEnterLienAccountNumber: existingData?.lienAccountNumber || "",
          };
          reset(updatedData);
        } else if (rowData?.status == "query") {
          setIsQueryable(true);
          setMoveToNext(true);
          setIsEditable(false);
          setShowEditButton(true);
          const updatedData: FormData = {
            otherDisbursementPurpose:
              existingData?.otherDisbursementPurpose || "",
            accountTypeId: existingData?.accountTypeId || null,
            paymentTypeId: existingData?.paymentTypeId || null,
            universityId: existingData?.universityId || null,
            bankId: existingData?.bankId || null,
            disbursementPurpose1: existingData?.disbursementPurpose1 || "", // Ensure this is correct
            disbursementPurpose: existingData?.disbursementPurpose || "", // Ensure this is correct
            disbursementPurposeId: existingData?.disbursementPurposeId || null,
            changeUniversityName: existingData?.changeUniversityName || false, // Ensure this is correct
            paymentCurrencyId: existingData?.paymentCurrencyId || null,
            paymentDate: existingData?.paymentDate || "",
            ifsccode: existingData?.ifsccode || "",
            accountNumber: existingData?.accountNumber || "",
            requestedAmount: existingData?.requestedAmount || "",
            overseasaddress: existingData?.overseasaddress || "",
            accHolderName: existingData?.accHolderName || "",
            AmountPaid:
              existingData?.AmountPaid == "0" ? "" : existingData?.AmountPaid,
            countryCodeId: existingData?.countryCodeId || null,
            overseasNumber: existingData?.overseasNumber || "",
            isNewUniversity: existingData?.isNewUniversity || false,
            loanAccountNumber: existingData?.loanAccountNumber,
            paymentMadeTo: existingData?.paymentMadeTo || "",
            // Remark: `${avanseRemarks.trim()}\n${customerRemarks.trim()}`,
            avanseRemark: avanseRemarks.trim(),
            Remark: customerRemarks.trim(),
            newUniversityId: existingData?.newUniversityId || null,
            Key: "continue",
            requestType:existingData?.requestType || "",
            lienAccountNumber: existingData?.lienAccountNumber || "",
            lienIfscCode: existingData?.lienIfscCode || "",
            lienBankId :existingData?.lienBankId ,
            lienAccountHolderName:existingData?.lienAccountHolderName || "",
            reEnterAccountNumber: existingData?.accountNumber || "",
            reEnterLienAccountNumber:existingData?.lienAccountNumber || "",
            // exchangePartner: existingData?.exchangePartner || "",
          };
          reset(updatedData);
        } else if (rowData?.status == "pendingFromAvanse" || rowData?.status == "pendingFromOperationMaker" || rowData?.status == "pendingFromOperationChecker" || rowData?.status == "pendingFromCredit" || rowData?.status == "pendingFromCollection" || rowData?.status == "pendingFromSalesCoordinator" || rowData?.status == "pendingFromLienOperationChecker" || rowData?.status == "pending" || rowData?.status=="partiallyApproved") {
          setIsEditable(false);
          setMoveToNext(true);
          const updatedData: FormData = {
            otherDisbursementPurpose:
              existingData?.otherDisbursementPurpose || "",
            accountTypeId: existingData?.accountTypeId || null,
            paymentTypeId: existingData?.paymentTypeId || null,
            universityId: existingData?.universityId || null,
            bankId: existingData?.bankId || null,
            disbursementPurpose1: existingData?.disbursementPurpose1 || "", // Ensure this is correct
            disbursementPurpose: existingData?.disbursementPurpose || "", // Ensure this is correct
            disbursementPurposeId: existingData?.disbursementPurposeId || null,
            changeUniversityName: existingData?.changeUniversityName || false, // Ensure this is correct
            paymentCurrencyId: existingData?.paymentCurrencyId || null,
            paymentDate: existingData?.paymentDate || "",
             ifsccode: existingData?.ifsccode || "",
            accountNumber: existingData?.accountNumber || null,
            requestedAmount: existingData?.requestedAmount || "",
            overseasaddress: existingData?.overseasaddress || "",
            accHolderName: existingData?.accHolderName || "",
            AmountPaid:
              existingData?.AmountPaid == "0" ? "" : existingData?.AmountPaid,
            countryCodeId: existingData?.countryCodeId || "",
            overseasNumber: existingData?.overseasNumber || "",
            isNewUniversity: existingData?.isNewUniversity || false,
            loanAccountNumber: existingData?.loanAccountNumber,
            paymentMadeTo: existingData?.paymentMadeTo || "",
            // Remark: `${avanseRemarks.trim()}\n${customerRemarks.trim()}`,
            avanseRemark: avanseRemarks.trim(),
            Remark: customerRemarks.trim(),
            newUniversityId: existingData?.newUniversityId || null,
            requestType: existingData?.requestType || "",
            lienBankId :existingData?.lienBankId ,
            Key: "continue",
            lienAccountNumber: existingData?.lienAccountNumber || "",
            lienIfscCode: existingData?.lienIfscCode || "",
            // exchangePartner: existingData?.exchangePartner || "",
            lienAccountHolderName: existingData?.lienAccountHolderName || "",
            reEnterAccountNumber: existingData?.accountNumber || "",
            reEnterLienAccountNumber: existingData?.lienAccountNumber || "",
          };
          reset(updatedData);
        } else if (
          lastDisbursementStatus?.lastDisbFormStatus === "approve" ||
          lastDisbursementStatus?.lastDisbFormStatus === "reject"
        ) {
          // Reset with default empty values if no existing data
          const defaultResetData: FormData = {
            otherDisbursementPurpose: "",
            accountTypeId: 0,
            paymentTypeId: 0,
            universityId: 0, // Set default value for universityId
            bankId: 0,
            disbursementPurpose1: "", // Ensure default is set if needed
            disbursementPurpose: "", // Ensure default is set if needed
            disbursementPurposeId: "",
            changeUniversityName: false, // Default value for changeUniversityName
            paymentCurrencyId: null,
            paymentDate: "",
            ifsccode: "",
            accountNumber: "",
            requestedAmount: "",
            overseasaddress: "",
            accHolderName: "",
            AmountPaid: null,
            countryCodeId: "",
            overseasNumber: "",
            isNewUniversity: false,
            loanAccountNumber: selectedLoanNumber,
            paymentMadeTo: "",
            avanseRemark: "",
            // customerRemark: "",
            Remark: "",
            Key: "save",
            // exchangePartner: "",
            newUniversityId: 0,
            requestType: "",
            lienAccountNumber: "",
            lienIfscCode: "",
            lienBankId : "",
            lienAccountHolderName: "",
            reEnterAccountNumber: "",
            reEnterLienAccountNumber: "",
          };

          reset(defaultResetData);
        } else {
          const updatedData: FormData = {
            otherDisbursementPurpose:
              existingData?.otherDisbursementPurpose || "",
            accountTypeId: existingData?.accountTypeId || 0,
            paymentTypeId: existingData?.paymentTypeId || null,
            universityId: existingData?.universityId || null,
            bankId: existingData?.bankId || null,
            disbursementPurpose1: existingData?.disbursementPurpose1 || "",
            disbursementPurpose: existingData?.disbursementPurpose || "",
            disbursementPurposeId: existingData?.disbursementPurposeId || null,
            changeUniversityName: existingData?.changeUniversityName || false,
            paymentCurrencyId: existingData?.paymentCurrencyId || null,
            paymentDate: existingData?.paymentDate || "",
            ifsccode: existingData?.ifsccode || "",
            accountNumber: existingData?.accountNumber || null,
            requestedAmount: existingData?.requestedAmount || "",
            overseasaddress: existingData?.overseasaddress || "",
            accHolderName: existingData?.accHolderName || "",
            AmountPaid:
              existingData?.AmountPaid == "0" ? "" : existingData?.AmountPaid,
            countryCodeId: existingData?.countryCodeId || null,
            overseasNumber: existingData?.overseasNumber || "",
            isNewUniversity: existingData?.isNewUniversity || false,
            loanAccountNumber: existingData?.loanAccountNumber,
            paymentMadeTo: existingData?.paymentMadeTo || "",
            // Remark: `${avanseRemarks.trim()}\n${customerRemarks.trim()}`,
            avanseRemark: avanseRemarks.trim(),
            Remark: customerRemarks.trim(),
            Key: "continue",
            // exchangePartner: existingData?.exchangePartner || "",
            newUniversityId: existingData?.newUniversityId || null,
            requestType:existingData?.requestType || "",
            lienAccountNumber:existingData?.lienAccountNumber? existingData?.lienAccountNumber:lienData?.lienAccountNumber ? lienData?.lienAccountNumber:"",
            lienIfscCode: existingData?.lienIfscCode?existingData?.lienIfscCode:lienData?.lienIfscCode ? lienData?.lienIfscCode:"",
            lienBankId :existingData?.lienBankId?existingData?.lienBankId:lienData?.lienBankId ? lienData?.lienBankId:existingData?.lienBankId,
            lienAccountHolderName:existingData?.lienAccountHolderName?existingData?.lienAccountHolderName:lienData?.lienAccountHolderName ? lienData?.lienAccountHolderName:"",
            reEnterAccountNumber: existingData?.accountNumber || "",
            reEnterLienAccountNumber: existingData?.lienAccountNumber? existingData?.lienAccountNumber:lienData?.lienAccountNumber ? lienData?.lienAccountNumber:"",
          };
          reset(updatedData);
          if(lastDisbursementStatus?.loanUndisbursedAmount<1){
            //handleIsFormSaved();
            const currentValues = getValues();
            const { reEnterAccountNumber, reEnterLienAccountNumber, ...valuesWithoutReEnter } = currentValues;
            reset({
              ...valuesWithoutReEnter,
              requestType: "lien",
              reEnterLienAccountNumber: valuesWithoutReEnter.lienAccountNumber || "",
            });
            setShowHello(true);
            handleBankNameLien();
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    if (!initialFetch.current) {
      fetchData();
      initialFetch.current = true;
    }
  }, [selectedLoanNumber, reset, lastDisbursementStatus, formIdpayload]);


  const options = (dataSet?.UniversityData || [])
    .filter(
      (uc: any, index: number, self: any[]) =>
        index === self.findIndex((u) => u.name === uc.name)
    )
    .sort((a: any, b: any) => a.name.localeCompare(b.name))
    .map((uc: any) => ({
      value: uc.id,
      label: uc.name,
    }));

  const options1 = (dataSet?.UniversityData || [])
    .filter(
      (uc: any, index: number, self: any[]) =>
        index === self.findIndex((u) => u.name === uc.name)
    )
    .sort((a: any, b: any) => a.name.localeCompare(b.name))
    .map((uc: any) => ({
      value: uc.id,
      label: uc.name,
    }));

  const options2 =
    dataSet?.defaultUniversity?.map((uc: any) => ({
      value: uc.id,
      label: uc.name,
    })) || [];

  const phoneCodeOptions: any =
    dataSet.PhoneCodes?.filter(
      (pc: any, index: number, self: any[]) =>
        index === self.findIndex((p) => p.countryCode === pc.countryCode)
    )
      .sort((a: any, b: any) => a.countryCode - b.countryCode)
      .map((pc: any) => ({
        value: pc.id,
        label: `+${pc.countryCode}`,
      })) || [];

  useEffect(() => {
    if (options2?.length > 0) {
      setValue("universityId", options2[0].value);
    }
  }, [options2]);

  const handleFromDateChange = (date: any) => {
    // Handle date change logic if needed
  };

  const handleFunctionForStep2 = (step: number) => {
    removeQueryParams(window.location.href)
    if(requestType==="lien"){
      setActiveFunction(step);
      setallDocsPresent(true);
      //setActiveStep(step);
    }else if(step===1){
      setActiveFunction(1);
      //setActiveStep(1);
    }
    else if(step===2){
      setActiveFunction(2);
      if (
      formStatus == "query" ||
      formStatus == "pendingFromOperationMaker" ||
      formStatus == "pendingFromOperationChecker" ||
      formStatus == "pendingFromLienOperationChecker" ||
      formStatus == "pendingFromCredit" ||
      formStatus == "pendingFromCollection" ||
      formStatus == "pendingFromSalesCoordinator" ||
      formStatus == "approve" ||
      formStatus == "reject" ||
      formStatus == "cancelled"
    ){
      setActiveStep(3);
    }
    }
    else{
      setActiveFunction(3);
      //setActiveStep(3);
    }
  };
  /**
   * Handles the click event for the filter button.
   *
   * This function performs the following actions:
   * 1. Sets the loading state to false.
   * 2. Makes an API call to fetch the remarks history based on the provided disbursement request ID and role.
   * 3. Updates the state with the fetched data.
   * 4. Handles any errors that occur during the API call by setting the loading state to false.
   * 5. Opens the modal.
   *
   * @returns {void}
   */
  const handleFilterButtonClick = () => {
    setIsLoading(false);
    setIsRemarkLoading(true)
    service.posts
      .getPosts(
        `api/v1/remarks/history?disbursementRequestId=${formID}&role=customer`
      )
      .then((response) => {
        const data: any = response?.data?.data || [];
        setDataSetRemark(data);
        setIsRemarkLoading(false)
      })
      .catch((error) => {
        setIsLoading(false);
        setIsRemarkLoading(false)
      });
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  /**
   * Handles the change event for the requested amount input field.
   *
   * This function checks if the entered requested amount exceeds the total sanctioned amount.
   * If it does, it sets an error message. Otherwise, it clears any existing error message.
   *
   * @param event - The change event triggered by the input field.
   */
  const handleRequestedAmountChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    handleIsFormSaved();
    let sanctionedAmount = lastDisbursementStatus?.totalSanctionedAmount;
    const value = event.target.value === "" ? "" : Number(event.target.value);

    // Check if value is a number before comparing
    if (typeof value === "number" && value > sanctionedAmount) {
      // Set error message
      setErrorMessage(`Requested amount cannot exceed ${sanctionedAmount}`);
    } else {
      setErrorMessage(null); // Clear error message
    }
  };

  /**
   * Handles the change event for the requested disbursement amount input field.
   * It validates the input value against the amount paid and the undisbursed loan amount,
   * and sets appropriate error messages if the validation fails.
   *
   * @param {any} event - The change event triggered by the input field.
   */
  const handleRequestedDisbAmount = (event: any) => {
    handleIsFormSaved();
    if (
      !showHello &&
      Number(event.target.value) > Number(watch("AmountPaid")) && getValues("paymentTypeId") ==1
    ) {
      setErrorMessage(
        "The requested disbursement amount cannot exceed the amount paid."
      );
    } 
    //else if (Number(event.target.value) > Number(convertUndisbValue) && getValues("accountTypeId") ==2 && getValues("requestType")!="lien") {
    //   setErrorMessage(
    //     "Requested Amount must not be greater than the undisbursed loan amount."
    //   );
    // }else if (Number(event.target.value) > Number(convertSanctionedValue) && getValues("accountTypeId") ==2 && getValues("requestType")=="lien") {
    //   setErrorMessage(
    //     "Requested Amount must not be greater than the sanctioned loan amount."
    //   );
    // }  
    else {
      setErrorMessage(null);
    }
  };

  /**
   * Handles the change event for the requested amount paid input field.
   * Validates the input value against the amount paid and the undisbursed loan amount.
   * Sets appropriate error messages if the validation fails.
   *
   * @param {any} event - The change event triggered by the input field.
   */
  const handleRequestedAmountPaid = (event: any) => {
    handleIsFormSaved();

    // if (Number(event.target.value) > Number(convertUndisbValue) && getValues("accountTypeId") ==2 && getValues("requestType")!="lien") {
    //   setErrorMessageAmountPaid(
    //     "Amount Paid must not be greater than the undisbursed loan amount."
    //   );
    // }else if (Number(event.target.value) > Number(convertSanctionedValue) && getValues("accountTypeId") ==2 && getValues("requestType")=="lien") {
    //   setErrorMessageAmountPaid(
    //     "Amount Paid must not be greater than the sanctioned loan amount."
    //   );
    // }else 
      if (Number(event.target.value) < Number(getValues("requestedAmount")) && getValues("accountTypeId") ==2 && getValues("requestType")=="lien") {
      setErrorMessageAmountPaid(
        "The requested disbursement amount cannot exceed the amount paid."
      );
      } else {
        setErrorMessageAmountPaid(null);
      }
  };


  useEffect(() => {
    const lienBankId = getValues("lienBankId");
    const bankId = getValues("bankId");
    const lienLength: any = {};
    const beneficiaryLength: any = {}
    if ((lienBankId) && bankListLien?.length) {
      const lienBank = bankListLien.find((b: any) => b?.id === lienBankId);
      lienLength.max = lienBank?.maxLength ?? 17;
      lienLength.min = lienBank?.minLength ?? 8;
      lienLength.bankName = lienBank?.bankName ?? ""
    }
    if(getValues("paymentTypeId")===5 && bankList?.length){
      const bankLien = bankList.find((b: any) => b?.id === bankId);

      beneficiaryLength.max = bankLien?.maxLength ?? 17;
      beneficiaryLength.min = bankLien?.minLength ?? 8;
      beneficiaryLength.bankName = bankLien?.bankName ?? ""
    }
    
    const bankListone = dataSet?.Bankdata || [];
    if ((bankId && getValues("paymentTypeId")!==5) && bankListone?.length) {
      const bank = bankListone.find((b: any) => b?.id === bankId);

      beneficiaryLength.max = bank?.maxLength ?? 17;
      beneficiaryLength.min = bank?.minLength ?? 8;
      beneficiaryLength.bankName = bank?.bankName ?? ""
    }
    setLengthValidation({ lien: lienLength, beneficiary: beneficiaryLength });
  }, [getValues("lienBankId"), getValues("bankId"), bankListLien,bankList, dataSet?.Bankdata, getValues("paymentTypeId")]);

  /**
   * Validates the form fields based on the provided field name.
   *
   * @param fieldValue - The name of the field to validate.
   * @returns A string containing the validation error message if the field is invalid, otherwise an empty string.
   *
   * The function checks if the form can continue (`isContinue` is true) and validates the specified field.
   * It returns appropriate error messages for the following fields if they are invalid:
   * - `paymentTypeId`: "Payment Type is required."
   * - `universityId`: "University is required."
   * - `paymentCurrencyId`: "Payment Currency is required."
   * - `requestedAmount`: "Requested Amount is required."
   * - `disbursementPurposeId`: "Disbursement Purpose is required."
   * - `exchangePartner`: "Exchange Partner is required."
   * - `countryCodeId`: "Country Code is required."
   * - `overseasNumber`: "Overseas Number is required."
   * - `overseasaddress`: "Overseas Address is required."
   * - `paymentDate`: "Payment Date is required."
   * - `bankId`: "Bank Name is required."
   * - `ifsccode`: "IFSC Number is required."
   * - `accountNumber`: "Account Number is required."
   * - `paymentMadeTo`: "Payment Made To is required."
   * - `AmountPaid`: "Amount Paid is required."
   * - `accHolderName`: "Account Holder Name is required."
   * - `Remark`: "Remark is required."
   *
   * If the field is valid or `isContinue` is false, it returns an empty string.
   */
  const handleFormValidation = (fieldValue: string) => {
   if (fieldValue === "lienAccountNumber") { 
      if (handleRequestDetailsCondition() && isContinue) {
        if (getValues("lienAccountNumber") == null || getValues("lienAccountNumber") == "") {
          return "Account Number is required.";
        }
        const { min, max, errorMsg } = getAccountConstraints(lengthValidation?.lien);
        if (getValues("lienAccountNumber")?.length < min) {
          return errorMsg ?? `Account Number must be at least ${min} digits.`;
        } else if(getValues("lienAccountNumber")?.length > max) {
          return errorMsg ?? `Account Number must be at most ${max} digits.`;
        }
      }
      return "";
    }
    if (isContinue) {
      switch (fieldValue) {
         case "requestType": {
          return getValues("requestType") == ""
            ? "Request Type is required."
            : "";
        }
        case "paymentTypeId": {
          return getValues("paymentTypeId") == null
            ? "Payment Type is required."
            : "";
        }
        case "accountTypeId": {
          return getValues("accountTypeId") == 0
            ? "Account Type is required."
            : "";
        }
        case "universityId": {
          return getValues("universityId") == null
            ? "University is required."
            : "";
        }
        case "requestedAmount": {
          return getValues("requestedAmount") == ""
            ? "Requested Amount is required."
            : getValues("requestType") != "lien" &&  getValues("accountTypeId") != 1 && (parseInt(getValues("requestedAmount")) <= 0 || parseInt(getValues("requestedAmount")) > convertUndisbValue)
                ? "Requested Amount must not be greater than undisbursed loan amount."
                : Number(getValues("requestedAmount")) > Number(convertSanctionedValue) && getValues("accountTypeId") ==2 && getValues("requestType")=="lien"
                ? "Requested Amount must not be greater than the sanctioned loan amount."
              : ""
        }
        case "AmountPaid": {
            return getValues("requestType") != "lien" && getValues("accountTypeId") != 1 &&  (getValues("requestedAmount") > Number(getValues("AmountPaid")) ||Number(getValues("AmountPaid")) > convertUndisbValue)?
               "Amount Paid must not be greater than undisbursed loan amount."
               : Number(getValues("AmountPaid"))  > Number(convertSanctionedValue) && getValues("accountTypeId") !=1 && getValues("requestType")=="lien"
               ? "Amount Paid must not be greater than the sanctioned loan amount."
              : ""
        }
        case "disbursementPurposeId": {
          return getValues("disbursementPurposeId") == null
            ? "Disbursement Purpose is required."
            : "";
        }
        // case "exchangePartner": {
        //   return getValues("exchangePartner") == ""
        //     ? "Exchange Partner is required."
        //     : "";
        // }
        case "countryCodeId": {
          return (getValues("countryCodeId") != null &&
            getValues("countryCodeId") != 0) && getValues("paymentTypeId")!=1 && getValues("paymentTypeId")!=2 && getValues("paymentTypeId")!=4 && getValues("paymentTypeId")!=3 && getValues("paymentTypeId")!=5
            ? "Country Code is required."
            : "";
        }
        case "overseasNumber": {
          return getValues("overseasNumber") !== "" && getValues("paymentTypeId")!=1 && getValues("paymentTypeId")!=2 && getValues("paymentTypeId")!=4 &&getValues("paymentTypeId")!=3 && getValues("paymentTypeId")!=5
            ? "Overseas Number is required."
            : "";
        }
        case "overseasaddress": {
          return getValues("overseasaddress") != "" && getValues("paymentTypeId")!=1 && getValues("paymentTypeId")!=2 && getValues("paymentTypeId")!=4 && getValues("paymentTypeId")!=3 && getValues("paymentTypeId")!=5
            ? "Overseas Address is required."
            : "";
        }
        case "paymentDate": {
          return getValues("paymentDate") == ""
            ? "Payment Date is required."
            : "";
        }
        case "paymentCurrencyId": {
          return getValues("paymentCurrencyId") == null
            ? "Payment Currency is required."
            : "";
        }

        case "newUniversityId": {
          return getValues("isNewUniversity") && getValues("newUniversityId") == null
            ? "New University is required."
            : "";
        }

        // =============================================================================
        case "bankId": {
          return handleBankDetailsCondition() && getValues("bankId") == null
            ? "Bank Name is required."
            : "";
        }
        case "ifsccode": {
          return handleBankDetailsCondition() && getValues("ifsccode") == ""
            ? "IFSC Code is required."
            : "";
        }
        case "accountNumber": {
          if(handleBankDetailsCondition()) {
            if((getValues("accountNumber") == null || getValues("accountNumber") == "")) {
              return "Account Number is required."
            }
            const { min, max, errorMsg } = getAccountConstraints(lengthValidation?.beneficiary);
            if (getValues("accountNumber")?.length < min) {
              return errorMsg ?? `Account Number must be at least ${min} digits.`;
            } else if(getValues("accountNumber")?.length > max) {
              return errorMsg ?? `Account Number must be at most ${max} digits.`;
            }
          }
          return ""
        }
        case "accHolderName": {
          return handleBankDetailsCondition() &&
            getValues("accHolderName") == ""
            ? "Account Holder Name is required."
            : "";
        }
        // =============================================================================
// =============================================================================
        case "lienBankId": {
          return handleRequestDetailsCondition() && getValues("lienBankId") == null
            ? "Bank Name is required."
            : "";
        }
        case "lienIfscCode": {
          return handleRequestDetailsCondition() && getValues("lienIfscCode") == ""
            ? "IFSC Code is required."
            : "";
        }
        case "lienAccountHolderName": {
          return handleRequestDetailsCondition() && getValues("lienAccountHolderName") == ""
            ? "Account Holder Name is required."
            : "";
        }
        case "reEnterLienAccountNumber": {
          if (handleRequestDetailsCondition() && (getValues("reEnterLienAccountNumber") == null || getValues("reEnterLienAccountNumber") == "")) {
            return "Re-enter Account Number is required.";
          }
          if (handleRequestDetailsCondition() && !validateAccountNumberMatch(getValues("lienAccountNumber"), getValues("reEnterLienAccountNumber"))) {
            return "Account Number does not match.";
          }
          return "";
        }
        // =============================================================================
        case "reEnterAccountNumber": {
          if (handleBankDetailsCondition() && (getValues("reEnterAccountNumber") == null || getValues("reEnterAccountNumber") == "")) {
            return "Re-enter Account Number is required.";
          }
          if (handleBankDetailsCondition() && !validateAccountNumberMatch(getValues("accountNumber"), getValues("reEnterAccountNumber"))) {
            return "Account Number does not match.";
          }
          return "";
        }
        // =============================================================================

        case "paymentMadeTo": {
          return getValues("paymentMadeTo") == ""
            ? "Payment Made To is required."
            : "";
        }
        case "AmountPaid": {
          return getValues("AmountPaid") == 0 ? "Amount Paid is required." : "";
        }

        case "Remark": {
          return getValues("Remark") == "" ? "Remark is required." : "";
        }
        case "otherDisbursementPurpose": {
          // return getValues("otherDisbursementPurpose") == ""
          //   ? "Disbursement Purpose is required."
          //   : "";
          const value = getValues("otherDisbursementPurpose");
          // Trim to avoid only-space input
          const trimmedValue = value ? value.trim() : "";
          if (!trimmedValue) {
            return "Disbursement Purpose is required.";
          }
          // Allow only alphabets and spaces
          if (!/^[a-zA-Z\s]+$/.test(trimmedValue)) {
            return "Only alphabets and spaces are allowed.";
          }
          return "";
        }
        default: {
          return "";
        }
      }
    } else {
      return "";
    }
  };

  /**
   * Handles the display of the new university selection form.
   *
   * This function returns a JSX fragment containing a checkbox to indicate whether the user wants to change the university,
   * and if the checkbox is checked, it displays a dropdown to select the new university.
   *
   * @returns {JSX.Element} A fragment containing the form elements for changing the university.
   *
   * @component
   * @example
   * // Example usage:
   * const element = handleShowNewUniversity();
   *
   * @remarks
   * - The checkbox is controlled by the `isNewUniversity` field from the form.
   * - The dropdown for selecting the new university is controlled by the `newUniversityId` field from the form.
   * - The `isEditable` prop determines whether the form elements are enabled or disabled.
   * - The `changeUniversity` state determines whether the dropdown is displayed.
   * - The `options1` prop provides the options for the university dropdown.
   * - The `setIsFormSaved` prop is a callback function to update the form's saved state.
   */
  const handleEditDetails=()=>{
    if (formStatus == "query") {
      setActiveStep(1);
    } else {
      setActiveStep(0);
    }
    setFormStatus(
      formStatus == "query"
        ? "query"
        : formStatus == "pendingFromOperationMaker"
          ? "pendingFromOperationMaker"
          : formStatus == "pendingFromLienOperationChecker"
          ? "pendingFromLienOperationChecker"
          : formStatus === "pendingFromCredit"
            ? "pendingFromCredit"
            : formStatus == "pendingFromCollection"
              ? "pendingFromCollection": 
              formStatus == "pendingFromSalesCoordinator"
              ? "pendingFromSalesCoordinator"
              : formStatus == "approve"
                ? "approve"
                : formStatus === "reject"
                  ? "reject"
                : formStatus == "cancelled"
                  ? "cancelled"
                  : "save"
    );
  }
  const getButton = () => {
    if (
      formStatus != "query" &&
      formStatus != "pendingFromOperationMaker" &&
      formStatus != "pendingFromOperationChecker" &&
      formStatus != "pendingFromLienOperationChecker" &&
      formStatus != "pendingFromCredit" &&
      formStatus != "pendingFromCollection" &&
      formStatus != "pendingFromSalesCoordinator" &&
      formStatus != "approve" &&
      formStatus != "reject" &&
      formStatus != "cancelled"
    ) {
      // return (
      //   <EditSecondaryButton
      //     width={isXsOrSm ? "100px" : "150px"}
      //     height={isXsOrSm ? "17px" : "42px"}
      //     onClick={() => {
      //       if (formStatus == "query") {
      //         setActiveStep(1);
      //       } else {
      //         setActiveStep(0);
      //       }
      //       setFormStatus(
      //         formStatus == "query"
      //           ? "query"
      //           : formStatus == "pendingFromOperationMaker"
      //             ? "pendingFromOperationMaker"
      //             : formStatus == "pendingFromLienOperationChecker"
      //             ? "pendingFromLienOperationChecker"
      //             : formStatus === "pendingFromCredit"
      //               ? "pendingFromCredit"
      //               : formStatus == "pendingFromCollection"
      //                 ? "pendingFromCollection": 
      //                 formStatus == "pendingFromSalesCoordinator"
      //                 ? "pendingFromSalesCoordinator"
      //                 : formStatus == "approve"
      //                   ? "approve"
      //                   : formStatus == "cancelled"
      //                     ? "cancelled"
      //                     : "save"
      //       );
      //     }}
      //   >
      //     <DriveFileRenameOutlineIcon sx={{ fontSize: "18px" }} /> &nbsp;{" "}
      //     {isXsOrSm ? "Edit" : "Edit Details"}
      //   </EditSecondaryButton>
      // );
    }
    if (
      formStatus == "query" ||
      formStatus == "pendingFromOperationMaker" ||
      formStatus == "pendingFromLienOperationChecker" ||
      formStatus == "approve" ||
      formStatus == "pendingFromOperationChecker" ||
      formStatus == "reject" ||
      formStatus == "pendingFromCredit" ||
      formStatus == "pendingFromCollection" ||
      formStatus == "cancelled" ||
      formStatus == "pendingFromSalesCoordinator"
    ) {
      return (
        <OutlinedPrimaryButton
          width={isXsOrSm ? "" : "129px"}
          height={isXsOrSm ? "36px" : "42px"}
          onClick={() => {
            if (formStatus == "query") {
              setActiveStep(1);
            } else {
              setActiveStep(0);
            }
            setFormStatus(
              formStatus == "query"
                ? "query"
                :formStatus=="pendingFromSalesCoordinator"?"pendingFromSalesCoordinator"
                : formStatus == "pendingFromOperationMaker"
                  ? "pendingFromOperationMaker"
                   : formStatus == "pendingFromLienOperationChecker"
                  ? "pendingFromLienOperationChecker"
                  : formStatus == "pendingFromOperationChecker"
                    ? "pendingFromOperationChecker"
                  : formStatus == "pendingFromCredit"
                    ? "pendingFromCredit"
                    : formStatus == "pendingFromCollection"
                      ? "pendingFromCollection" 
                      : formStatus == "approve"
                        ? "approve"
                         : formStatus === "reject"
                          ? "reject"
                        : formStatus == "cancelled"
                          ? "cancelled"
                          : "save"
            );
          }}
          fullWidth={true}
        >
          <WestIcon sx={{ fontSize: isXsOrSm ? "15px" : "20px" }} /> Previous
        </OutlinedPrimaryButton>
      );
    }
  };

  

  const handleShowNewUniversity = (): JSX.Element => {
    return (
      <>
        {/* <Grid item xs={12} sm={12} md={4} lg={4}>
          <FormControlLabel
            control={
              <Checkbox
                {...register("isNewUniversity")}
                onChange={handleCheckboxChange}
                disabled={!isEditable}
                checked={changeUniversity}
              />
            }
            label="Do you want to change University"
          />
        </Grid> */}
        {changeUniversity && (
          <Grid item xs={12} sm={12} md={4}>
            <Controller
              name="newUniversityId"
              control={control}
              render={({ field: { onChange, value } }) => (
                <SearchSelectOption
                  options={options1}
                  label="New Name of the University"
                  isMandatory={true}
                  value={getValues("newUniversityId") || ""}
                  onChange={onChange}
                  // width={300}
                  disabled={!isEditable} // Change as needed
                  setIsFormSaved={setIsFormSaved}
                  helperText={handleFormValidation("newUniversityId")}
                  error={!!handleFormValidation("newUniversityId")}
                />
              )}
            />
          </Grid>
        )}
      </>
    );
  };

  /**
   * Handles the display of the Disbursement Purpose field based on the payment type.
   * If the payment type ID is 4, it renders an InputField component for the disbursement purpose.
   * Otherwise, it renders a SelectOptions component with a list of disbursement purposes.
   *
   * @returns {JSX.Element} The JSX element containing the appropriate input field for the disbursement purpose.
   */
  const handleShowDisbursementPurpose = (): JSX.Element => {
    const isDisbursementPurposeDisabled: boolean =
      getValues("paymentTypeId") === 3 || getValues("paymentTypeId") === 5;

    return (
      <>
        {isDisbursementPurposeDisabled ? (
          <>
            <div>
              <label
                htmlFor="custom-autocomplete"
                className="disbursement-inside-page-lable-condtion-dark"
                style={{
                  color: !!handleFormValidation("disbursementPurposeId")
                    ? "red"
                    : "#5d586c",
                }}
              >
                {"Disbursement Purpose"} <span style={{ color: "red" }}>*</span>
              </label>
            </div>
            <Controller
              name="disbursementPurposeId"
              control={control}
              render={({ field }) => (
                <>
                  <InputField
                    {...register("otherDisbursementPurpose", {
                      setValueAs: (value: any) => (value === "" ? "" : value), // Convert to number
                    })}
                    onChange={(e: any) => {
                      // Allow only alphabets and spaces
                      const filteredValue = e.target.value.replace(/[^a-zA-Z\s]/g, "");

                      // Prevent starting space
                      const finalValue = filteredValue.replace(/^\s+/, "");

                      e.target.value = finalValue;
                    }}
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fontSize="11px"
                    //placeholder="Disbursement Purpose *"
                    error={!!handleFormValidation("otherDisbursementPurpose")}
                    helperText={handleFormValidation(
                      "otherDisbursementPurpose"
                    )}
                    onKeyDown={(e: any) => {
                      if (e.target.value.startsWith(" ")) {
                        e.target.value = e.target.value.trimStart();
                      }
                      handleIsFormSaved();
                    }}
                    disabled={!isEditable}
                  />
                </>
              )}
            />
          </>
        ) : (
          <SelectOptions
            helperText={handleFormValidation("disbursementPurposeId")}
            error={!!handleFormValidation("disbursementPurposeId")}
            options={
              disbList?.map((bd: any) => ({
                value: bd.id,
                label: bd.disbursementPurpose,
              })) || []
            }
            label="Disbursement Purpose"
            isMandatory={true}
            value={watch("disbursementPurposeId")}
            onChange={(value) => {
              handleIsFormSaved();
              setValue("disbursementPurposeId", value);
            }}
            lableClass="portal-text-lable"
            disabled={!isEditable || disbList?.length <= 1}
          />
        )}
      </>
    );
  };

  /**
   * Handles the display of the account type selection component.
   *
   * @returns {JSX.Element} The JSX element containing the SelectOptions component for account type.
   *
   * The SelectOptions component includes:
   * - `helperText`: Displays validation message for account type.
   * - `error`: Indicates if there is a validation error for account type.
   * - `options`: List of account types to choose from, mapped from `accountTypeList`.
   * - `label`: Label for the select input, set to "Account Type".
   * - `isMandatory`: Boolean indicating if the field is mandatory.
   * - `value`: The current selected value for account type.
   * - `onChange`: Function to handle changes in the selected account type. It also triggers form save state and updates the form value.
   * - `disabled`: Boolean indicating if the select input is editable.
   */
  const handleShowAccountType = (): JSX.Element => {
    return (
      <>
        <SelectOptions
          helperText={handleFormValidation("accountTypeId")}
          error={!!handleFormValidation("accountTypeId")}
          options={
            accountTypeList?.map((bd: any) => ({
              value: bd.id,
              label: bd.accountType,
            })) || []
          }
          lableClass="portal-text-lable"
          label="Account Type"
          isMandatory={true}
          value={watch("accountTypeId")}
          onChange={(value: any) => {
            handleIsFormSaved();
            setValue("accountTypeId", value);
            if (value === 2) {
              setValue("paymentCurrencyId", 13);
              setPaymentCurrencyField(true);
            } else {
              setValue("paymentCurrencyId", 30);
              setPaymentCurrencyField(false);
            }
          }}
          disabled={!isEditable || accountTypeList?.length <= 1}
        />
      </>
    );
  };

  const handleRemarkChange = (event: any) => {
    const debounce = (func: Function, delay: number) => {
      let timer: NodeJS.Timeout;
      return (...args: any[]) => {
        clearTimeout(timer);
        timer = setTimeout(() => func(...args), delay);
      };
    };

    const handleDebouncedRemarkChange = debounce((value: string) => {
      setValue("Remark", value.trim());
    }, 300);

    handleDebouncedRemarkChange(event?.target?.value);
  }

  /**
   * Renders a SelectOptions component for selecting an exchange partner.
   *
   * @returns {JSX.Element} The SelectOptions component.
   *
   * The SelectOptions component includes:
   * - A helper text for form validation of the "exchangePartner" field.
   * - An error state based on the form validation of the "exchangePartner" field.
   * - A list of options derived from the `dataSet.ExchangePartner` array, each containing a value and label.
   * - A label "Exchange Partner".
   * - A mandatory field indicator.
   * - A value that is watched from the "exchangePartner" field.
   * - An onChange handler that updates the form state and marks the form as unsaved.
   * - A disabled state based on the `isEditable` flag.
   */
  // const handleShowExchangePartner = (): JSX.Element => {
  //   return (
  //     <SelectOptions
  //       helperText={handleFormValidation("exchangePartner")}
  //       error={!!handleFormValidation("exchangePartner")}
  //       options={
  //         dataSet.ExchangePartner?.map((dis: any) => ({
  //           value: dis.id,
  //           label: dis.exchangePartnerName,
  //         })) || []
  //       }
  //       label="Exchange Partner"
  //       isMandatory={true}
  //       value={watch("exchangePartner")} // Ensure it has a default value
  //       onChange={(value: any) => {
  //         handleIsFormSaved();
  //         setValue("exchangePartner", String(value));
  //       }}
  //       disabled={!isEditable}
  //     />
  //   );
  // };

  /**
   * Handles the invocation of the Disbursement Purpose API.
   *
   * This function sends a POST request to the specified endpoint with the provided payment type ID.
   * If the request is successful, it updates the disbursement list state with the response data.
   * If an error occurs, it logs the error to the console.
   *
   * @param {any} value - The payment type ID to be sent in the request body.
   * @returns {Promise<void>} - A promise that resolves when the API call is complete.
   */
  const isDisabled = !isEditable || activeStep === 5;
  const isEnabled = isMoveToNext; // Overrides the disabled state if true.
  const handleInvokeDisbursementPurposeApi = async (
    value: any
  ): Promise<void> => {
    setIsLoading(true);
    try {
      const response = await postsServices.addPost(
        "/api/v1/disbursement-form/disbursement-purpose",
        {
          paymentTypeId: value,
        }
      );
      setDisbList(response?.data?.data?.disbPurspose);
      setAccountTypeList(response?.data?.data?.accountType);
      if (response?.data?.data?.accountType.length === 1) {
        setValue("accountTypeId", response?.data?.data?.accountType?.[0]?.id);
        if (response?.data?.data?.accountType?.[0]?.id == 1) {
          if(watch("requestedAmount")==""|| watch("paymentCurrencyId")==13){
            setValue("paymentCurrencyId", 30);
          }
          // else{
          //   setValue("paymentCurrencyId", 30);
          // }
        } else {
          setValue("paymentCurrencyId", 13);
        }
      }else{
        if (response?.data?.data?.accountType?.[0]?.id == watch("accountTypeId")) {
          if(watch("requestedAmount")=="" || watch("paymentCurrencyId")==13){
            setValue("paymentCurrencyId", 30);
          }
        }else if (response?.data?.data?.accountType?.[1]?.id == watch("accountTypeId")) {
          if(watch("requestedAmount")==""){
            setValue("paymentCurrencyId", 13);
          }
        } 
      }

      if (response?.data?.data?.disbPurspose?.length === 1) {
        setValue(
          "disbursementPurposeId",
          response?.data?.data?.disbPurspose?.[0]?.id
        );
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const handleAgreeSubmit = async (type: string) => {
    try {
      const obj: any = {
        formId: formID,
        type: type == "Yes" ? 1 : 2,
        lan: selectedLoanNumber,
        remark: cancelRemark || "No remark provided",
        loanCategory: userLoanCategory?.TermLoan[0]?.loanCategoryId || null,
        business: businessType?.id || null,
        cif: userProfile?.cifNumber,
        cifEntity: userProfile?.cifEntity,
      };

      if (type === "No") {
        // delete obj.remark;
        delete obj.cifEntity
      }
      const response = await postsServices.addPost(
        "/api/v1/disbursement-form/tranche-cancel",
        obj
      );
      if (response?.data?.status === "success") {
        setConfirmModal(false);
        setCancelRemark("");
        dispatch(
          setStatusPopup({
            status: "success",
            message: response?.data?.message,
            buttonStatus: false,
          })
        );
        setTimeout(() => {
          dispatch(clearStatusPopup());
        }, 2000)
        if (type == "Yes") {
          handleBackyes();
        }
      }
    } catch (error: any) {
      setConfirmModal(false);
      dispatch(
        setStatusPopup({
          status: "error",
          message: error?.data?.message || "Something went wrong!",
          buttonStatus: false,
        })
      );
    }
  }
  const [paymentTypeData, setPaymentTypeData] = useState<any>([]);
  useEffect(() => {
    let paymentTypeList = dataSet.PaymentType?.map((bd: any) => ({
      value: bd.id,
      label: bd.paymentType,
    })) || []
    if(getValues("requestType")=="lien"){
      paymentTypeList = paymentTypeList.filter((item:any) => item.value !== 5);
    }
    setPaymentTypeData(paymentTypeList);
  }, [getValues("requestType"),dataSet.PaymentType]);

  const FormSkeleton = () => {
    return (
      <form>
        <Box sx={{ paddingTop: "20px" }}>
          {/* First Row */}
          <Grid container spacing={2} mb={2}>
             <Grid item xs={12} sm={12} md={4} lg={4}>
              <Skeleton
                variant="rectangular"
                width="100%"
                height={36}
                sx={{ borderRadius: "8px" }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Skeleton
                variant="rectangular"
                width="100%"
                height={36}
                sx={{ borderRadius: "8px" }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Skeleton
                variant="rectangular"
                width="100%"
                height={36}
                sx={{ borderRadius: "8px" }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Skeleton
                variant="rectangular"
                width="100%"
                height={36}
                sx={{ borderRadius: "8px" }}
              />
            </Grid>
          </Grid>

          {/* Conditional Section */}
          <Grid container spacing={2} mb={2}>
            <Grid item sm={6}>
              <Skeleton
                variant="rectangular"
                width="100%"
                height={36}
                sx={{ borderRadius: "8px" }}
              />
            </Grid>
            <Grid item sm={4}>
              <Skeleton
                variant="rectangular"
                width="100%"
                height={36}
                sx={{ borderRadius: "8px" }}
              />
            </Grid>
            <Grid item sm={4}>
              <Skeleton
                variant="rectangular"
                width="100%"
                height={36}
                sx={{ borderRadius: "8px" }}
              />
            </Grid>
          </Grid>

          {/* Multi-line Text Field */}
          <Grid container spacing={2} mb={2}>
            <Grid item xs={12}>
              <Skeleton
                variant="rectangular"
                width="100%"
                height={80}
                sx={{ borderRadius: "8px" }}
              />
            </Grid>
          </Grid>

          <Box sx={{ paddingTop: "10px" }}>
            <Grid container spacing={2} mb={2}>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={36}
                  sx={{ borderRadius: "8px" }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={36}
                  sx={{ borderRadius: "8px" }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={36}
                  sx={{ borderRadius: "8px" }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={36}
                  sx={{ borderRadius: "8px" }}
                />
              </Grid>
            </Grid>
          </Box>
        </Box>
      </form>
    );
  };
  useEffect(() => {
    const fetchDataBank = async () => {
      if(getValues("paymentTypeId")==5) {
        await handleBankName();
      }
    }
    fetchDataBank();
  },[getValues("paymentTypeId")]);
  useEffect(() => {
    (async () => {
      if(getValues("requestType")=="lien") {
        await handleBankNameLien();
      }
    })();
  },[getValues("requestType")]);

  const getAccountConstraints = (
    validation: any
  ): { max: number; min: number; errorMsg: string | null } => {
    const max = validation?.max ?? 50;
    const min = validation?.min ?? 1;
    const errorMsg =
    validation?.max === validation?.min && validation?.max!== null
        ? `Please enter a valid ${validation?.max}-digit ${validation?.bankName} account number to proceed.`
      :validation?.max && validation?.min
        ? `Please enter a valid ${validation?.bankName} account number between ${validation?.min} and ${validation?.max} digits to proceed.`
        : null;
    return { max, min, errorMsg };
  };

const getAccountNumberValidationError = (
  value: string,
  validation?: any
): string => {
  const trimmedValue = (value || "").trim();

  // Empty value
  if (!trimmedValue) {
    return "";
  }

  const min = validation?.min;
  const max = validation?.max;
  const bankName = validation?.bankName || "Account number";
  if(validation?.max === validation?.min && validation?.max!== null &&  (trimmedValue.length < min || trimmedValue.length > max)) {
    return `Please enter a valid ${validation?.max}-digit ${validation?.bankName} account number to proceed.`;
  }
  else if(validation?.max && validation?.min &&  (trimmedValue.length < min || trimmedValue.length > max)){
    return  `Please enter a valid ${validation?.bankName} account number between ${validation?.min} and ${validation?.max} digits to proceed.`
  }   
  // No error
  return "";
};

  const renderStepContent = () => {
    let uniqueSortedBankData = (dataSet.Bankdata || [])
      .filter(
        (bd: any, index: number, self: any[]) =>
          index === self.findIndex((b) => b.bankName === bd.bankName)
      )
      .sort((a: any, b: any) => a.bankName.localeCompare(b.bankName))
      .map((bd: any) => ({
        value: bd.id,
        label: bd.bankName,
      }));
      if(getValues("paymentTypeId")==5){
        uniqueSortedBankData=bankList?.map((bank:any) => ({
            value: bank.id,  
            label: bank.bankName
          }));
      }
    let val = activeStep;
    if (localStorage.getItem("activeFormStep") == "3") {
      let num = localStorage.getItem("activeFormStep");
      val = Number(num);
    }
    switch (val) {
      case 0:
        return (
          <>
            {" "}
            <Divider sx={{ paddingTop: "20px" }} />
            <form
              onSubmit={handleSubmit((data) => handleContinue(data))}
              className="padding-box"
            >
              {isLoading ? (
                <> {FormSkeleton()} </>
              ) : (
                <>
                  <Box>
                    <Grid container item spacing={2} mb={2} className="form-container">
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Grid item xs={12} sm={12} md={4} lg={4} sx={{ display: "flex", alignItems: "center" }}>
                          <Box sx={{ flex: 1 }}>
                            <SelectOptions
                              helperText={handleFormValidation("requestType")}
                              lableClass="portal-text-lable"
                              error={!!handleFormValidation("requestType")}
                              padding="7px 14px 7px 14px"
                              options={
                                dataSet.RequestType?.map((bd: any) => ({
                                  value: bd.id,
                                  label: bd.requestType,
                                })) || []
                              }
                              label="Request Type"
                              isMandatory={true}
                              value={watch("requestType")}
                              onChange={(value) => {
                                //handleInvokeDisbursementPurposeApi(value);
                                handleIsFormSaved();
                                setValue("requestType", String(value));
                                setShowHello(value === "lien");
                                if(value=="lien"){
                                  handleBankNameLien()
                                }
                              }}
                              disabled={!isEditable || convertUndisbValue < 1 || isDisbTypeApproved}
                            />
                          </Box>
                          {/* <Tooltip title="Fund Release from Lien A/C" enterTouchDelay={50} placement="top">
                            <img
                              src={InfoIcon}
                              alt="Status"
                              style={{
                                height: "15px",
                                width: "15px",
                                marginLeft: 8,
                                cursor: "pointer",
                              }}
                            />
                          </Tooltip> */}
                        </Grid>
                      </Grid>
                      <Grid item xs={12} sm={12} md={4} lg={4}>
                        <SelectOptions
                          helperText={handleFormValidation("paymentTypeId")}
                          error={!!handleFormValidation("paymentTypeId")}
                          padding="7px 14px 7px 14px"
                          options={paymentTypeData || []
                          }
                          label="Payment Type"
                          lableClass="portal-text-lable"
                          isMandatory={true}
                          value={watch("paymentTypeId")}
                          onChange={(value) => {
                            handleInvokeDisbursementPurposeApi(value);
                            handleIsFormSaved();
                            setValue("paymentTypeId", Number(value));
                            //setIsContinue(true);
                            // if (value === 1) {
                            //   // setValue("paymentCurrencyId", 13);
                            //   setPaymentCurrencyField(true);
                            // } else {
                            //   // setValue("paymentCurrencyId", null);
                            //   setPaymentCurrencyField(false);
                            // }
                            setShowHello(value === 2);
                            setShowHelloOne(value === 3 || value === 4 ||  value === 5);
                          }}
                          
                          disabled={!isEditable || isDisbTypeApproved}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={4} lg={4}>
                        {handleShowDisbursementPurpose()}
                      </Grid>
                      <Grid item xs={12} sm={12} md={4} lg={4}>
                        {handleShowAccountType()}
                      </Grid>
                    </Grid>

                    {showHello ? (
                      <>
                        <Grid
                          container
                          item
                          spacing={2}
                          mb={2}
                          className="form-container"
                        >
                          <Grid item xs={12} sm={12} md={6}>
                            <Controller
                              name="universityId"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <SearchSelectOption
                                  isChangeUniversity={true}
                                  handleChangeUniversity={handleCheckboxChange}
                                  changeUniversityValue={changeUniversity}
                                  helperText={handleFormValidation(
                                    "universityId"
                                  )}
                                  error={!!handleFormValidation("universityId")}
                                  options={
                                    options2?.length > 0 ? options2 : options
                                  }
                                  label="Name of the University"
                                  isMandatory={true}
                                  value={value as any}
                                  onChange={onChange}
                                  disabled={!isEditable || options2?.length > 0|| isDisbTypeApproved} // Change as needed
                                  setIsFormSaved={setIsFormSaved}
                                />
                              )}
                            />
                          </Grid>
                          {handleShowNewUniversity()}
                        </Grid>
                        <Grid
                          container
                          item
                          spacing={2}
                          mb={2}
                          className="form-container"
                        >
                          <Grid item xs={12} sm={12} md={4}>
                            <Controller
                              name="paymentCurrencyId"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <SearchSelectOption
                                  options={
                                    dataSet.Curencies?.filter(
                                      (uc: any) =>
                                        !(
                                          watch("accountTypeId") === 1 &&
                                          uc.id === 13
                                        )
                                    ).map((uc: any) => ({
                                      value: uc.id,
                                      label: uc.currencyDescription,
                                    })) || []
                                  }
                                  label="Currency For Payment"
                                  isMandatory={true}
                                  value={value || ""}
                                  onChange={onChange}
                                  width={300}
                                  disabled={
                                    !isEditable ||
                                    watch("paymentCurrencyId") == 13|| isDisbTypeApproved
                                  } // Change as needed
                                  setIsFormSaved={setIsFormSaved}
                                  helperText={handleFormValidation("paymentCurrencyId")}
                                  error={!!handleFormValidation("paymentCurrencyId")}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={12} sm={12} md={4} lg={4} sx={{marginTop:"-3px"}}>
                            <div>
                              <label
                                htmlFor="custom-autocomplete"
                                className="disbursement-inside-page-lable-condtion-dark"
                                style={{
                                  color: !!handleFormValidation(
                                    "requestedAmount"
                                  )
                                    ? "red"
                                    : "#5d586c",
                                }}
                              >
                                {"Requested Amount For Disbursement"}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                            </div>
                            <Controller
                              name="requestedAmount"
                              control={control}
                              render={({ field }) => (
                                <>
                                  <InputField
                                    helperText={handleFormValidation(
                                      "requestedAmount"
                                    )}
                                    error={
                                      !!handleFormValidation("requestedAmount")
                                    }
                                    {...register("requestedAmount", {
                                      setValueAs: (value: any) =>
                                        value === "" ? "" : value, // Convert to number
                                    })}
                                    fullWidth
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    FormHelperTextProps={{
                                      sx: { marginLeft: 0 }, // remove default 14px left padding
                                    }}
                                    fontSize="11px"
                                    //placeholder="Requested Amount For Disbursement *"
                                    onChange={handleRequestedDisbAmount}
                                    // error={!!errorMessage}
                                    onKeyDown={handleKeyDown}
                                    disabled={!isEditable|| isDisbTypeApproved}
                                    inputProps={{ maxLength: 11 }}   
                                  // type="number"
                                  />
                                </>
                              )}
                            />

                            <FormHelperText error>
                              {errorMessage}
                            </FormHelperText>
                          </Grid>
                        </Grid>
                          {/* <Grid item xs={12} sm={12} md={4} lg={4}>
                            {handleShowExchangePartner()}
                          </Grid> */}
                        <Grid
                          container
                          item
                          spacing={2}
                          mb={2}
                          className="form-container"
                        >
                          <Grid item xs={12} sm={12} md={5} lg={5}>
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                <div>
                                  <label
                                    htmlFor="custom-autocomplete"
                                    className="disbursement-inside-page-lable-condtion-dark"
                                    style={{
                                      color: !!handleFormValidation(
                                        "overseasNumber"
                                      )
                                        ? "red"
                                        : "#5d586c",
                                    }}
                                  >
                                    {"Overseas Mobile Number"}
                                    <span style={{ color: "red" }}>{(getValues("paymentTypeId") == 5 ||getValues("paymentTypeId") == 3||getValues("paymentTypeId") == 1||getValues("paymentTypeId") ==2||getValues("paymentTypeId") == 4) ?"":""}</span>
                                  </label>
                                </div>

                                <Grid container spacing={2}>
                                  <Grid item xs={4} sm={4} md={4} lg={4}>
                                    <Controller
                                      name="countryCodeId"
                                      control={control}
                                      render={({
                                        field: { onChange, value },
                                      }) => (
                                        <SearchSelectOption
                                          options={phoneCodeOptions}
                                          error={
                                            !!handleFormValidation(
                                              "countryCodeId"
                                            )
                                          }
                                          helperText={handleFormValidation(
                                            "countryCodeId"
                                          )}
                                          isMandatory={false}
                                          value={value || ""}
                                          onChange={(value) => {
                                            handleIsFormSaved();
                                            setValue("countryCodeId", value);
                                          }}
                                          width={300}
                                          disabled={!isEditable|| isDisbTypeApproved} // Change as needed
                                          setIsFormSaved={setIsFormSaved}
                                        />
                                      )}
                                    />
                                  </Grid>
                                  <Grid item xs={8} sm={8} md={8} lg={8}>
                                    <InputField
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      fontSize="11px"
                                      //placeholder="Please enter Overseas Mobile Number"
                                      variant="outlined"
                                      fullWidth
                                    //required={(getValues("paymentTypeId") == 5 ||getValues("paymentTypeId") == 3)?false:true }
                                      disabled={!isEditable|| isDisbTypeApproved}
                                      rows={1}
                                      {...register("overseasNumber", {
                                        setValueAs: (value) =>
                                          value === "" ? "" : value,
                                        minLength: {
                                          value: 7,
                                          message:
                                            "Overseas mobile number must be at least 7 digits.",
                                        },
                                        maxLength: {
                                          value: 15,
                                          message:
                                            "Overseas mobile number must not exceed 15 digits.",
                                        },
                                        pattern: {
                                          value: /^[0-9]+$/, // Only allow digits
                                          message:
                                            "Overseas mobile number must contain only digits.",
                                        },
                                      })}
                                      helperText={handleFormValidation(
                                        "overseasNumber"
                                      )}
                                      inputProps={{
                                        maxLength: 15,
                                        inputMode: "numeric", // Ensures numeric keyboard is used on mobile devices
                                        pattern: "[0-9]*", // Ensures only digits are allowed

                                        onKeyDown: (
                                          e: React.KeyboardEvent<HTMLInputElement>
                                        ) => {
                                          handleIsFormSaved();
                                          // Block non-numeric key presses
                                          if (
                                            !/[0-9]/.test(e.key) &&
                                            e.key !== "Backspace" &&
                                            e.key !== "ArrowLeft" &&
                                            e.key !== "ArrowRight" &&
                                            e.key !== "Delete"
                                          ) {
                                            e.preventDefault();
                                          }
                                        },
                                      }}
                                      onChange={() => handleIsFormSaved()}
                                      error={
                                        !!handleFormValidation("overseasNumber")
                                      }
                                      FormHelperTextProps={{
                                      sx: { marginLeft: 0 }, // remove default 14px left padding
                                    }}
                                    />
                                    {errors.overseasNumber && (
                                      <FormHelperText error>
                                        {errors.overseasNumber.message}
                                      </FormHelperText>
                                    )}
                                  </Grid>
                                </Grid>

                                {/* {errors.overseasNumber && (
                                  <FormHelperText error>
                                    {errors.overseasNumber.message}
                                  </FormHelperText>
                                )} */}
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={7}
                            lg={7}
                            mb={1}
                            className="form-container"
                          >
                            <div>
                              <label
                                htmlFor="custom-autocomplete"
                                className="disbursement-inside-page-lable-condtion-dark"
                                style={{
                                  color: !!handleFormValidation(
                                    "requestedAmount"
                                  )
                                    ? "red"
                                    : "#5d586c",
                                }}
                              >
                                {"Overseas Address"}{" "}
                                <span style={{ color: "red" }}>{(getValues("paymentTypeId") == 5 ||getValues("paymentTypeId") == 3 || getValues("paymentTypeId") == 1 || getValues("paymentTypeId") == 2 || getValues("paymentTypeId") == 4) ?"":"*"}</span>
                              </label>
                            </div>
                            <InputField
                              InputLabelProps={{
                                shrink: true,
                              }}
                              fontSize="11px"
                              helperText={handleFormValidation(
                                "overseasaddress"
                              )}
                              FormHelperTextProps={{
                                sx: { marginLeft: 0 }, // remove default 14px left padding
                              }}
                              error={!!handleFormValidation("overseasaddress")}
                              //placeholder="Please enter Overseas Address"
                              variant="outlined"
                              fullWidth
                              padding="7px 14px 7px 14px"
                              required
                              multiline
                              disabled={!isEditable|| isDisbTypeApproved}
                              rows={1}
                              {...register("overseasaddress")}
                              onChange={(e) => {
                                if (e.target.value.startsWith(" ")) {
                                  e.target.value = e.target.value.trimStart();
                                }
                                handleIsFormSaved();
                              }}
                            />
                          </Grid>
                        </Grid>
                        <Grid container item spacing={2} mb={2}></Grid>
                      </>
                    ) : showHelloOne?(
                      <>
                        <Grid container item spacing={2} mb={2}>
                          <Grid item xs={12} sm={12} md={6}>
                            <Controller
                              name="universityId"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <SearchSelectOption
                                  isChangeUniversity={true}
                                  handleChangeUniversity={handleCheckboxChange}
                                  changeUniversityValue={changeUniversity}
                                  helperText={handleFormValidation(
                                    "universityId"
                                  )}
                                  error={!!handleFormValidation("universityId")}
                                  options={
                                    options2?.length > 0 ? options2 : options
                                  }
                                  label="Name of the University"
                                  isMandatory={true}
                                  value={value as any}
                                  onChange={onChange}
                                  width={300}
                                  disabled={!isEditable || options2?.length > 0|| isDisbTypeApproved} // Change as needed
                                  setIsFormSaved={setIsFormSaved}
                                />
                              )}
                            />
                          </Grid>

                          {handleShowNewUniversity()}
                        </Grid>
                        <Grid container
                          item
                          spacing={2}
                          mb={2}
                          className="form-container">
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={4}
                            lg={4}
                            style={{ marginTop: "-5px" }}
                          >
                            <Controller
                              name="paymentCurrencyId"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <SearchSelectOption
                                  options={
                                    dataSet.Curencies?.filter(
                                      (uc: any) =>
                                        !(
                                          watch("accountTypeId") === 1 &&
                                          uc.id === 13
                                        )
                                    ).map((uc: any) => ({
                                      value: uc.id,
                                      label: uc.currencyDescription,
                                    })) || []
                                  }
                                  label="Currency For Payment"
                                  isMandatory={true}
                                  value={value || ""}
                                  onChange={onChange}
                                  width={300}
                                  disabled={
                                    !isEditable ||
                                    watch("paymentCurrencyId") == 13|| isDisbTypeApproved
                                  } // Change as needed
                                  setIsFormSaved={setIsFormSaved}
                                  helperText={handleFormValidation("paymentCurrencyId")}
                                  error={!!handleFormValidation("paymentCurrencyId")}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={12} sm={12} md={4} lg={4}  sx={{marginTop:"-5px"}}>
                            <div>
                              <label
                                htmlFor="custom-autocomplete"
                                className="disbursement-inside-page-lable-condtion-dark"
                                style={{
                                  color: !!handleFormValidation(
                                    "requestedAmount"
                                  )
                                    ? "red"
                                    : "#5d586c",
                                }}
                              >
                                {"Requested Amount For Disbursement"}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                            </div>
                            <Controller
                              name="requestedAmount"
                              control={control}
                              render={({ field }) => (
                                <>
                                  <InputField
                                    helperText={handleFormValidation(
                                      "requestedAmount"
                                    )}
                                    fontSize="11px"
                                    error={
                                      !!handleFormValidation("requestedAmount")
                                    }
                                    {...register("requestedAmount", {
                                      setValueAs: (value: any) =>
                                        value === "" ? "" : value, // Convert to number
                                    })}
                                    fullWidth
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    FormHelperTextProps={{
                                      sx: { marginLeft: 0 }, // remove default 14px left padding
                                    }}
                                    //placeholder="Requested Amount For Disbursement *"
                                    onChange={handleRequestedDisbAmount}
                                    // error={!!errorMessage}
                                    onKeyDown={handleKeyDown}
                                    disabled={!isEditable|| isDisbTypeApproved}
                                    inputProps={{ maxLength: 11 }}   
                                  // type="number"
                                  />
                                </>
                              )}
                            />

                            <FormHelperText error>
                              {errorMessage}
                            </FormHelperText>
                          </Grid>
                        </Grid>
                        <Grid container item spacing={2} mb={2} className="form-container">
                          <Grid item xs={12} sm={12} md={5} lg={5}>
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                <div>
                                  <label
                                    htmlFor="custom-autocomplete"
                                    className="disbursement-inside-page-lable-condtion-dark"
                                    style={{
                                      color: !!handleFormValidation(
                                        "overseasNumber"
                                      )
                                        ? "red"
                                        : "#5d586c",
                                    }}
                                  >
                                    {"Overseas Mobile Number"}
                                    <span style={{ color: "red" }}>{(getValues("paymentTypeId") == 5 ||getValues("paymentTypeId") == 3 ||getValues("paymentTypeId") == 1 ||getValues("paymentTypeId") == 2 ||getValues("paymentTypeId") == 4) ?"":""}</span>
                                  </label>
                                </div>

                                <Grid container spacing={2}>
                                  <Grid item xs={4} sm={4} md={4} lg={4}>
                                    <Controller
                                      name="countryCodeId"
                                      control={control}
                                      render={({
                                        field: { onChange, value },
                                      }) => (
                                        <SearchSelectOption
                                          options={phoneCodeOptions}
                                          error={
                                            !!handleFormValidation(
                                              "countryCodeId"
                                            )
                                          }
                                          helperText={handleFormValidation(
                                            "countryCodeId"
                                          )}
                                          isMandatory={false}
                                          value={value || ""}
                                          onChange={(value) => {
                                            handleIsFormSaved();
                                            setValue("countryCodeId", value);
                                          }}
                                          width={300}
                                          disabled={!isEditable|| isDisbTypeApproved} // Change as needed
                                          setIsFormSaved={setIsFormSaved}
                                        />
                                      )}
                                    />
                                  </Grid>
                                  <Grid item xs={8} sm={8} md={8} lg={8}>
                                    <InputField
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      fontSize="11px"
                                      //placeholder="Please enter Overseas Mobile Number"
                                      variant="outlined"
                                      fullWidth
                                      required
                                      disabled={!isEditable|| isDisbTypeApproved}
                                      rows={1}
                                      {...register("overseasNumber", {
                                        setValueAs: (value) =>
                                          value === "" ? "" : value,
                                        minLength: {
                                          value: 7,
                                          message:
                                            "Overseas mobile number must be at least 7 digits.",
                                        },
                                        maxLength: {
                                          value: 15,
                                          message:
                                            "Overseas mobile number must not exceed 15 digits.",
                                        },
                                        pattern: {
                                          value: /^[0-9]+$/, // Only allow digits
                                          message:
                                            "Overseas mobile number must contain only digits.",
                                        },
                                      })}
                                      helperText={handleFormValidation(
                                        "overseasNumber"
                                      )}
                                      inputProps={{
                                        maxLength: 15,
                                        inputMode: "numeric", // Ensures numeric keyboard is used on mobile devices
                                        pattern: "[0-9]*", // Ensures only digits are allowed

                                        onKeyDown: (
                                          e: React.KeyboardEvent<HTMLInputElement>
                                        ) => {
                                          handleIsFormSaved();
                                          // Block non-numeric key presses
                                          if (
                                            !/[0-9]/.test(e.key) &&
                                            e.key !== "Backspace" &&
                                            e.key !== "ArrowLeft" &&
                                            e.key !== "ArrowRight" &&
                                            e.key !== "Delete"
                                          ) {
                                            e.preventDefault();
                                          }
                                        },
                                      }}
                                      onChange={() => handleIsFormSaved()}
                                      error={
                                        !!handleFormValidation("overseasNumber")
                                      }
                                      FormHelperTextProps={{
                                      sx: { marginLeft: 0 }, // remove default 14px left padding
                                    }}
                                    />
                                    {errors.overseasNumber && (
                                      <FormHelperText error>
                                        {errors.overseasNumber.message}
                                      </FormHelperText>
                                    )}
                                  </Grid>
                                </Grid>

                                {/* {errors.overseasNumber && (
                                  <FormHelperText error>
                                    {errors.overseasNumber.message}
                                  </FormHelperText>
                                )} */}
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid  item
                            xs={12}
                            sm={12}
                            md={7}
                            lg={7}
                            mb={1}
                            className="form-container">
                            <div>
                              <label
                                htmlFor="custom-autocomplete"
                                className="disbursement-inside-page-lable-condtion-dark"
                                style={{
                                  color: !!handleFormValidation(
                                    "overseasaddress"
                                  )
                                    ? "red"
                                    : "#5d586c",
                                }}
                              >
                                {"Overseas Address"}{" "}
                                <span style={{ color: "red" }}>{(getValues("paymentTypeId") == 5 ||getValues("paymentTypeId") == 3|| getValues("paymentTypeId") == 1 || getValues("paymentTypeId") == 2 || getValues("paymentTypeId") == 4) ?"":""}</span>
                              </label>
                            </div>
                            <InputField
                              helperText={handleFormValidation(
                                "overseasaddress"
                              )}
                              fontSize="11px"
                              error={!!handleFormValidation("overseasaddress")}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              FormHelperTextProps={{
                                sx: { marginLeft: 0 }, // remove default 14px left padding
                              }}
                              fullWidth
                              //placeholder={`Overseas Address ${(getValues("paymentTypeId") == 5 ||getValues("paymentTypeId") == 3) ?"":"*"}`}
                              {...register("overseasaddress")}
                              disabled={!isEditable|| isDisbTypeApproved}
                              onChange={(e) => {
                                if (e.target.value.startsWith(" ")) {
                                  e.target.value = e.target.value.trimStart();
                                }
                                handleIsFormSaved()
                              }}
                            />
                          </Grid>
                        </Grid>
                      </>
                    ):
                    (
                      <>
                        <Grid container item spacing={2} mb={2} className="form-container">
                          <Grid item xs={12} sm={12} md={6}>
                            <Controller
                              name="universityId"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <SearchSelectOption
                                  isChangeUniversity={true}
                                  handleChangeUniversity={handleCheckboxChange}
                                  changeUniversityValue={changeUniversity}
                                  helperText={handleFormValidation(
                                    "universityId"
                                  )}
                                  error={!!handleFormValidation("universityId")}
                                  options={
                                    options2?.length > 0 ? options2 : options
                                  }
                                  label="Name of the University"
                                  isMandatory={true}
                                  value={value as any}
                                  onChange={onChange}
                                  width={300}
                                  disabled={!isEditable || options2?.length > 0|| isDisbTypeApproved} // Change as needed
                                  setIsFormSaved={setIsFormSaved}
                                />
                              )}
                            />
                          </Grid>

                          {handleShowNewUniversity()}
                        </Grid>
                        <Grid container
                          item
                          spacing={2}
                          mb={2}
                          className="form-container">
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={4}
                            style={{ marginTop: "-5px" }}
                          >
                            <Controller
                              name="paymentCurrencyId"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <SearchSelectOption
                                  options={
                                    dataSet.Curencies?.filter(
                                      (uc: any) =>
                                        !(
                                          watch("accountTypeId") === 1 &&
                                          uc.id === 13
                                        )
                                    ).map((uc: any) => ({
                                      value: uc.id,
                                      label: uc.currencyDescription,
                                    })) || []
                                  }
                                  label="Currency For Payment"
                                  isMandatory={true}
                                  value={value || ""}
                                  onChange={onChange}
                                  width={300}
                                  disabled={
                                    !isEditable ||
                                    watch("paymentCurrencyId") == 13|| isDisbTypeApproved
                                  } // Change as needed
                                  setIsFormSaved={setIsFormSaved}
                                  helperText={handleFormValidation("paymentCurrencyId")}
                                  error={!!handleFormValidation("paymentCurrencyId")}
                                />
                              )}
                            />
                          </Grid>

                          {getValues("paymentTypeId") == 1 && (
                            <>
                            <Grid item xs={12} sm={12} md={4} lg={4} mt={-1}>
                              <Controller
                                name="paymentDate"
                                control={control}
                                render={({
                                  field: { onChange, onBlur, value },
                                }) => (
                                  <BasicDatePicker
                                    helperText={handleFormValidation(
                                      "paymentDate"
                                    )}
                                    error={
                                      !!handleFormValidation("paymentDate")
                                    }
                                    padding="7px 14px 7px 14px"
                                    label="Date of Payment Made"
                                    width="100%"
                                    disabled={!isEditable|| isDisbTypeApproved}
                                    onChange={(date) => {
                                      onChange(date);
                                      handleFromDateChange(date);
                                      handleIsFormSaved();
                                    }}
                                    value={value ? dayjs(value) : null}
                                    minDate={dayjs().subtract(5, "month")}
                                  />
                                )}
                              />
                            </Grid>

                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={4}
                              lg={4}
                              mb={1}
                              className="form-container"
                            >
                              <div
                                style={{ marginTop: isXsOrSm ? "0px" : "-5px" }}
                              >
                                <label
                                  htmlFor="custom-autocomplete"
                                  className="disbursement-inside-page-lable-condtion-dark"
                                  style={{
                                    color: !!handleFormValidation("paymentMadeTo")
                                      ? "red"
                                      : "#5d586c",
                                  }}
                                >
                                  {"Payment Made To"}
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                              </div>
                              <InputField
                                helperText={handleFormValidation("paymentMadeTo")}
                                error={!!handleFormValidation("paymentMadeTo")}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                fontSize="11px"
                                fullWidth
                                //placeholder="Payment Made To *"
                                {...register("paymentMadeTo")}
                                onChange={(e) => {
                                  if (e.target.value.startsWith(" ")) {
                                    e.target.value = e.target.value.trimStart();
                                  }
                                  handleIsFormSaved();
                                }}
                                disabled={!isEditable|| isDisbTypeApproved}
                              />
                            </Grid>
                          </>
                          )}
                        </Grid>

                        <Grid
                          container
                          item
                          spacing={2}
                          mb={1}
                          // mt={1}
                          className="form-container"
                        >
                          {getValues("paymentTypeId") == 1 && (
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                              <div>
                                <label
                                  htmlFor="custom-autocomplete"
                                  className="disbursement-inside-page-lable-condtion-dark"
                                  style={{
                                    color: !!handleFormValidation("AmountPaid")
                                      ? "red"
                                      : "#5d586c",
                                  }}
                                >
                                  {"Amount Paid"}{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                              </div>
                              <InputField
                                helperText={handleFormValidation("AmountPaid")}
                                error={!!handleFormValidation("AmountPaid")}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                fontSize="11px"
                                fullWidth
                                //placeholder="Amount Paid *"
                                {...register("AmountPaid", {
                                  setValueAs: (value) =>
                                    value === "" ? "" : Number(value),
                                })}
                                disabled={!isEditable|| isDisbTypeApproved}
                                onKeyDown={handleKeyDown}
                                onChange={handleRequestedAmountPaid}
                                inputProps={{ maxLength: 11 }} 
                                FormHelperTextProps={{
                                  sx: { marginLeft: 0 }, // remove default 14px left padding
                                }}
                              />

                              <FormHelperText error>
                                {errorMessageAmountPaid}
                              </FormHelperText>
                            </Grid>
                          )}

                          <Grid item xs={12} sm={12} md={4} lg={4}  sx={{marginTop:"-4x"}}>
                            <div>
                              <label
                                htmlFor="custom-autocomplete"
                                className="disbursement-inside-page-lable-condtion-dark"
                                style={{
                                  color: !!handleFormValidation(
                                    "requestedAmount"
                                  )
                                    ? "red"
                                    : "#5d586c",
                                }}
                              >
                                {"Requested Amount For Disbursement"}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                            </div>
                            <Controller
                              name="requestedAmount"
                              control={control}
                              render={({ field }) => (
                                <>
                                  <InputField
                                    helperText={handleFormValidation(
                                      "requestedAmount"
                                    )}
                                    fontSize="11px"
                                    error={
                                      !!handleFormValidation("requestedAmount")
                                    }
                                    {...register("requestedAmount", {
                                      setValueAs: (value: any) =>
                                        value === "" ? "" : value, // Convert to number
                                    })}
                                    fullWidth
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    FormHelperTextProps={{
                                      sx: { marginLeft: 0 }, // remove default 14px left padding
                                    }}
                                    //placeholder="Requested Amount For Disbursement *"
                                    onChange={handleRequestedDisbAmount}
                                    // error={!!errorMessage}
                                    onKeyDown={handleKeyDown}
                                    disabled={!isEditable|| isDisbTypeApproved}
                                    inputProps={{ maxLength: 11 }}   
                                  // type="number"
                                  />
                                </>
                              )}
                            />

                            <FormHelperText error>
                              {errorMessage}
                            </FormHelperText>
                          </Grid>
                        </Grid>

                        <Grid  container
                          item
                          spacing={2}
                          mb={2}
                          className="form-container">
                          <Grid item xs={12} sm={12} md={5} lg={5}>
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                <div>
                                  <label
                                    htmlFor="custom-autocomplete"
                                    className="disbursement-inside-page-lable-condtion-dark"
                                    style={{
                                      color: !!handleFormValidation(
                                        "overseasNumber"
                                      )
                                        ? "red"
                                        : "#5d586c",
                                    }}
                                  >
                                    {"Overseas Mobile Number"}
                                    <span style={{ color: "red" }}>{(getValues("paymentTypeId") == 5 ||getValues("paymentTypeId") == 3||getValues("paymentTypeId") == 1||getValues("paymentTypeId") == 2||getValues("paymentTypeId") == 4) ?"":""}</span>
                                  </label>
                                </div>

                                <Grid container spacing={2}>
                                  <Grid item xs={4} sm={4} md={4} lg={4}>
                                    <Controller
                                      name="countryCodeId"
                                      control={control}
                                      render={({
                                        field: { onChange, value },
                                      }) => (
                                        <SearchSelectOption
                                          options={phoneCodeOptions}
                                          error={
                                            !!handleFormValidation(
                                              "countryCodeId"
                                            )
                                          }
                                          helperText={handleFormValidation(
                                            "countryCodeId"
                                          )}
                                          isMandatory={false}
                                          value={value || ""}
                                          onChange={(value) => {
                                            handleIsFormSaved();
                                            setValue("countryCodeId", value);
                                          }}
                                          width={300}
                                          disabled={!isEditable|| isDisbTypeApproved} // Change as needed
                                          setIsFormSaved={setIsFormSaved}
                                        />
                                      )}
                                    />
                                  </Grid>
                                  <Grid item xs={8} sm={8} md={8} lg={8}>
                                    <InputField
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      fontSize="11px"
                                      //placeholder="Please enter Overseas Mobile Number"
                                      variant="outlined"
                                      fullWidth
                                      //quired
                                      disabled={!isEditable|| isDisbTypeApproved}
                                      rows={1}
                                      {...register("overseasNumber", {
                                        setValueAs: (value) =>
                                          value === "" ? "" : value,
                                        minLength: {
                                          value: 7,
                                          message:
                                            "Overseas mobile number must be at least 7 digits.",
                                        },
                                        maxLength: {
                                          value: 15,
                                          message:
                                            "Overseas mobile number must not exceed 15 digits.",
                                        },
                                        pattern: {
                                          value: /^[0-9]+$/, // Only allow digits
                                          message:
                                            "Overseas mobile number must contain only digits.",
                                        },
                                      })}
                                      helperText={handleFormValidation(
                                        "overseasNumber"
                                      )}
                                      inputProps={{
                                        maxLength: 15,
                                        inputMode: "numeric", // Ensures numeric keyboard is used on mobile devices
                                        pattern: "[0-9]*", // Ensures only digits are allowed

                                        onKeyDown: (
                                          e: React.KeyboardEvent<HTMLInputElement>
                                        ) => {
                                          handleIsFormSaved();
                                          // Block non-numeric key presses
                                          if (
                                            !/[0-9]/.test(e.key) &&
                                            e.key !== "Backspace" &&
                                            e.key !== "ArrowLeft" &&
                                            e.key !== "ArrowRight" &&
                                            e.key !== "Delete"
                                          ) {
                                            e.preventDefault();
                                          }
                                        },
                                      }}
                                      onChange={() => handleIsFormSaved()}
                                      error={
                                        !!handleFormValidation("overseasNumber")
                                      }
                                      FormHelperTextProps={{
                                      sx: { marginLeft: 0 }, // remove default 14px left padding
                                    }}
                                    />
                                    {errors.overseasNumber && (
                                      <FormHelperText error>
                                        {errors.overseasNumber.message}
                                      </FormHelperText>
                                    )}
                                  </Grid>
                                </Grid>

                                {/* {errors.overseasNumber && (
                                  <FormHelperText error>
                                    {errors.overseasNumber.message}
                                  </FormHelperText>
                                )} */}
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item
                            xs={12}
                            sm={12}
                            md={7}
                            lg={7}
                            mb={1}
                            className="form-container">
                            <div>
                              <label
                                htmlFor="custom-autocomplete"
                                className="disbursement-inside-page-lable-condtion-dark"
                                style={{
                                  color: !!handleFormValidation(
                                    "overseasaddress"
                                  )
                                    ? "red"
                                    : "#5d586c",
                                }}
                              >
                                {"Overseas Address"}{" "}
                                <span style={{ color: "red" }}>{(getValues("paymentTypeId") == 5 ||getValues("paymentTypeId") == 3||getValues("paymentTypeId") == 1||getValues("paymentTypeId") == 2||getValues("paymentTypeId") == 4) ?"":""}</span>
                              </label>
                            </div>
                            <InputField
                              helperText={handleFormValidation(
                                "overseasaddress"
                              )}
                              fontSize="11px"
                              error={!!handleFormValidation("overseasaddress")}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              FormHelperTextProps={{
                                sx: { marginLeft: 0 }, // remove default 14px left padding
                              }}
                              fullWidth
                              //placeholder="Overseas Address *"
                              {...register("overseasaddress")}
                              disabled={!isEditable|| isDisbTypeApproved}
                              onChange={(e) => {
                                if (e.target.value.startsWith(" ")) {
                                  e.target.value = e.target.value.trimStart();
                                }
                                handleIsFormSaved()
                              }}
                            />
                          </Grid>
                        </Grid>
                        {/* {getValues("accountTypeId") === 1 && (
                          <>
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                              {handleShowExchangePartner()}
                            </Grid>
                          </>
                        )} */}
                      </>
                    )}
                  </Box>
                  
                  {handleRequestDetailsCondition() && (
                    <>
                      <Grid item xs={12} sm={12} md={8} lg={8}>
                        <Typography
                          sx={{
                            fontSize: "15px",
                            color: "rgba(0, 179, 181, 1)",
                            lineHeight: "14px",
                            fontWeight: "500",
                          }}
                        >
                          LIEN A/C DETAILS
                        </Typography>
                      </Grid>
                      <Box>
                        <Grid
                          container
                          item
                          spacing={2}
                          mb={2}
                          sx={{ marginTop: "1px" }}
                          className="form-container"
                        >
                          <Grid item xs={12} sm={12} md={4} lg={4}>
                            <Controller
                              name="lienBankId"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <SearchSelectOption
                                  helperText={handleFormValidation("lienBankId")}
                                  error={!!handleFormValidation("lienBankId")}
                                  options={
                                    bankListLien?.map((bd: any) => ({
                                      value: bd.id,
                                      label: bd.bankName,
                                    })) || []
                                  }
                                  label="Bank Name"
                                  isMandatory={true}
                                  value={value || null}
                                  onChange={(selectedValue: any) => {
                                    // Update React Hook Form value
                                    onChange(selectedValue);
                                    setValue("lienAccountNumber", "");
                                    setValue("reEnterLienAccountNumber", "");
                                    setValue("lienIfscCode", "");
                                    setValue("lienAccountHolderName", "");
                                    clearErrors("lienAccountNumber");
                                  }}
                                  width={300}
                                  disabled={!isEditable||isDisbTypeApproved} // Change as needed
                                  setIsFormSaved={setIsFormSaved}
                                />
                              )}
                            />
                          </Grid>

                          <Grid item xs={12} sm={12} md={4} lg={4}>
                            <div>
                              <label
                                htmlFor="custom-autocomplete"
                                className="disbursement-inside-page-lable-condtion-dark"
                                style={{
                                  fontSize: "13px",
                                  color: !!handleFormValidation(
                                    "lienAccountNumber"
                                  )
                                    ? "red"
                                    : "#5d586c",
                                }}
                              >
                                {"Account Number"}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                            </div>
                            <InputField
                              InputLabelProps={{
                                shrink: true,
                              }}
                              fontSize="11px"
                              fullWidth
                              type={lienAccountNumberFocused ? "text" : "text"}
                              value={lienAccountNumberFocused ? (watch("lienAccountNumber") || "") : (watch("lienAccountNumber") || "").replace(/./g, "*")}
                              onChange={(e) => {
                                if (lienAccountNumberFocused) {
                                  setValue("lienAccountNumber", e.target.value);
                                  handleIsFormSaved();
                                  
                                  // Check if re-enter field has value and validate matching
                                  const reEnterValue = getValues("reEnterLienAccountNumber"); 
                                  const { min, max, errorMsg } = getAccountConstraints(lengthValidation?.lien);
                                  
                                  // Usage
                                  const error = getAccountNumberValidationError(
                                    e.target.value,
                                    lengthValidation?.lien
                                  );
                                  if(error){
                                    setError("lienAccountNumber", {
                                      type: "manual",
                                      message: error,
                                    });
                                  }
                                  else if (reEnterValue) {
                                    
                                    clearErrors("lienAccountNumber");
                                    if (e.target.value !== reEnterValue) {
                                      setLienAccountNumberError("Account number does not match.");
                                    } else {
                                      setLienAccountNumberError("");
                                    }
                                  } else {
                                    setLienAccountNumberError("");
                                    clearErrors("lienAccountNumber");
                                    trigger("lienAccountNumber"); // refresh UI
                                  }
                                }
                              }}
                              className="asterisk-password"
                              //placeholder=""
                              disabled={!isEditable||isDisbTypeApproved}
                              onFocus={() => setLienAccountNumberFocused(true)}
                              onBlur={() => setLienAccountNumberFocused(false)}
                              inputProps={{
                                maxLength: lengthValidation?.lien?.max ?? 17,
                                inputMode: "numeric", // Ensures numeric keyboard is used on mobile devices

                                onKeyDown: (
                                  e: React.KeyboardEvent<HTMLInputElement>
                                ) => {
                                  handleIsFormSaved();
                                  // Block non-numeric key presses
                                  if (
                                    !/[0-9]/.test(e.key) &&
                                    e.key !== "Backspace" &&
                                    e.key !== "ArrowLeft" &&
                                    e.key !== "ArrowRight" &&
                                    e.key !== "Delete"
                                  ) {
                                    e.preventDefault();
                                  }
                                },
                              }}
                              helperText={handleFormValidation("lienAccountNumber")}
                              error={!!handleFormValidation("lienAccountNumber")}
                              FormHelperTextProps={{
                                sx: { marginLeft: 0 }, // remove default 14px left padding
                              }}
                            />
                            {errors.lienAccountNumber && (
                              <FormHelperText error>
                                {errors.lienAccountNumber.message}
                              </FormHelperText>
                            )}
                          </Grid>

                          {handleRequestDetailsCondition() && (
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                              <div>
                                <label
                                  htmlFor="custom-autocomplete"
                                  className="disbursement-inside-page-lable-condtion-dark"
                                  style={{
                                    color: !!handleFormValidation("reEnterLienAccountNumber")
                                      ? "red"
                                      : "#5d586c",
                                  }}
                                >
                                  {"Re-enter Account Number"}{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                              </div>
                              <InputField
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                fontSize="11px"
                                fullWidth
                                type={"text"}
                                autoComplete="off"
                                {...register("reEnterLienAccountNumber", {
                                  setValueAs: (value) =>
                                    value === "" ? "" : value,
                                  minLength: {
                                    value: 8,
                                    message:
                                      "Account number must be at least 8 digits.",
                                  },
                                  maxLength: {
                                    value: lengthValidation?.lien?.max ?? 17,
                                    message:
                                      `Account number must not exceed ${lengthValidation?.lien?.max ?? 17} digits.`,
                                  },
                                })}
                                disabled={!isEditable|| isDisbTypeApproved}
                                onFocus={() => setReEnterLienAccountNumberFocused(true)}
                                onBlur={() => setReEnterLienAccountNumberFocused(false)}
                                inputProps={{
                                  maxLength: lengthValidation?.lien?.max ?? 17,
                                  inputMode: "numeric",
                                  onKeyDown: (
                                    e: React.KeyboardEvent<HTMLInputElement>
                                  ) => {
                                    handleIsFormSaved();
                                    if (
                                      !/[0-9]/.test(e.key) &&
                                      e.key !== "Backspace" &&
                                      e.key !== "ArrowLeft" &&
                                      e.key !== "ArrowRight" &&
                                      e.key !== "Delete"
                                    ) {
                                      e.preventDefault();
                                    }
                                  },
                                  onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                                    handleIsFormSaved();
                                    
                                    // Real-time validation for lien account number matching
                                    const lienAccountNumber = getValues("lienAccountNumber");
                                    if (lienAccountNumber && e.target.value) {
                                      if (lienAccountNumber !== e.target.value) {
                                        setLienAccountNumberError("Account number does not match");
                                      } else {
                                        setLienAccountNumberError("");
                                      }
                                    } else {
                                      setLienAccountNumberError("");
                                    }
                                    
                                    setTimeout(() => {
                                      setValidationTrigger(prev => prev + 1);
                                    }, 0);
                                  },
                                }}
                                helperText={lienAccountNumberError || handleFormValidation("reEnterLienAccountNumber")}
                                error={!!lienAccountNumberError || !!handleFormValidation("reEnterLienAccountNumber")}
                                FormHelperTextProps={{
                                  sx: { marginLeft: 0 },
                                }}
                              />
                              {errors.reEnterLienAccountNumber && (
                                <FormHelperText error>
                                  {errors.reEnterLienAccountNumber.message}
                                </FormHelperText>
                              )}
                            </Grid>
                          )}

                          <Grid item xs={12} sm={12} md={4} lg={4}>
                            <div>
                              <label
                                htmlFor="custom-autocomplete"
                                className="disbursement-inside-page-lable-condtion-dark"
                                style={{
                                  color: !!handleFormValidation("lienIfscCode")
                                    ? "red"
                                    : "#5d586c",
                                }}
                              >
                                {"IFSC Code"}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                            </div>
                            <InputField
                              InputLabelProps={{
                                shrink: true,
                              }}
                              fontSize="11px"
                              fullWidth
                              //placeholder="IFSC Code *"
                              {...register("lienIfscCode", {
                                pattern: {
                                  // Pattern to validate the IFSC Code format
                                  value: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                                  message:
                                    "IFSC Code must be 11 characters: first 4 uppercase letters, followed by 0, and ending with 6 alphanumeric characters.",
                                },
                                validate: (value) => {
                                  // Check if there are any lowercase letters
                                  if (/[a-z]/.test(value)) {
                                    return "IFSC Code must be uppercase letters only.";
                                  }
                                  return true;
                                },
                              })}
                              disabled={!isEditable||isDisbTypeApproved}
                              inputProps={{
                                maxLength: 11, // Restrict input to 11 characters
                                onKeyDown: (
                                  e: React.KeyboardEvent<HTMLInputElement>
                                ) => {
                                  handleIsFormSaved();
                                  // Allow only uppercase alphanumeric keys and control keys
                                  const isAlphanumeric =
                                    (e.key >= "a" && e.key <= "z") ||
                                    (e.key >= "A" && e.key <= "Z") ||
                                    (e.key >= "0" && e.key <= "9");
                                  const allowedKeys = [
                                    "Backspace",
                                    "ArrowLeft",
                                    "ArrowRight",
                                    "Delete",
                                    "Tab",
                                  ];

                                  if (
                                    !isAlphanumeric &&
                                    !allowedKeys.includes(e.key)
                                  ) {
                                    e.preventDefault();
                                  }
                                },
                                onChange: (
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  e.target.value = e.target.value.toUpperCase(); // Convert input to uppercase
                                },
                              }}
                              helperText={handleFormValidation("lienIfscCode")}
                              error={!!handleFormValidation("lienIfscCode")}
                              FormHelperTextProps={{
                                sx: { marginLeft: 0 }, // remove default 14px left padding
                              }}
                            />

                            {errors.lienIfscCode && (
                              <FormHelperText error>
                                {errors.lienIfscCode.message}
                              </FormHelperText>
                            )}
                          </Grid>
                          
                          <Grid item xs={12} sm={12} md={4} lg={4}>
                            <div>
                              <label
                                htmlFor="custom-autocomplete"
                                className="disbursement-inside-page-lable-condtion-dark"
                                style={{
                                  color: !!handleFormValidation("lienAccountHolderName")
                                    ? "red"
                                    : "#5d586c",
                                }}
                              >
                                {"Account Holder Name"}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                            </div>
                            <InputField
                              helperText={handleFormValidation("lienAccountHolderName")}
                              error={!!handleFormValidation("lienAccountHolderName")}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              fontSize="11px"
                              fullWidth
                              //placeholder="Account Holder Name *"
                              {...register("lienAccountHolderName", {
                                setValueAs: (value) =>
                                  value === "" ? "" : value,
                              })}
                              disabled={!isEditable||isDisbTypeApproved}
                              inputProps={{
                                onKeyDown: (
                                  e: React.KeyboardEvent<HTMLInputElement>
                                ) => {

                                  handleIsFormSaved();
                                  // Block non-numeric key presses
                                  
                                },
                              }}
                              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                handleIsFormSaved();
                                // Prevent pasted leading spaces
                                if (e.target.value.startsWith(" ")) {
                                  e.target.value = e.target.value.trimStart();
                                }
                                // Force validation update by triggering a re-render
                                setTimeout(() => {
                                  setValidationTrigger(prev => prev + 1);
                                }, 0);
                              }}
                              FormHelperTextProps={{
                                sx: { marginLeft: 0 }, // remove default 14px left padding
                              }}
                            />
                                {/* {isContinue && getValues("accHolderName") == "" && (
                              <FormHelperText error>
                                Account Holder Name is required.
                              </FormHelperText>
                            )} */}
                          </Grid>
                        </Grid>
                      </Box>
                    </>
                  )}
                  {handleBankDetailsCondition() && (
                    <>
                      <Grid item xs={12} sm={12} md={8} lg={8}>
                        <Typography
                          sx={{
                            fontSize: "15px",
                            color: "rgba(0, 179, 181, 1)",
                            lineHeight: "14px",
                            fontWeight: "500",
                          }}
                        >
                          BENEFICIARY BANK DETAILS
                        </Typography>
                      </Grid>
                      <Box>
                        <Grid
                          container
                          item
                          spacing={2}
                          mb={2}
                          sx={{ marginTop: "1px" }}
                          className="form-container"
                        >
                          <Grid item xs={12} sm={12} md={4} lg={4}>
                            <Controller
                              name="bankId"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <SearchSelectOption
                                  helperText={handleFormValidation("bankId")}
                                  error={!!handleFormValidation("bankId")}
                                  options={uniqueSortedBankData}
                                  label="Bank Name"
                                  isMandatory={true}
                                  value={value || null}
                                  onChange={(selectedValue: any) => {
                                    // Update React Hook Form value
                                    onChange(selectedValue);
                                    setValue("accountNumber", "");
                                    setValue("reEnterAccountNumber", "");
                                    setValue("ifsccode", "");
                                    setValue("accHolderName", "");
                                    clearErrors("accountNumber");
                                  }}
                                  width={300}
                                  disabled={!isEditable|| isDisbTypeApproved} // Change as needed
                                  setIsFormSaved={setIsFormSaved}
                                />
                              )}
                            />
                          </Grid>

                          <Grid item xs={12} sm={12} md={4} lg={4}>
                            <div>
                              <label
                                htmlFor="custom-autocomplete"
                                className="disbursement-inside-page-lable-condtion-dark"
                                style={{
                                  fontSize: "13px",
                                  color: !!handleFormValidation(
                                    "accountNumber"
                                  )
                                    ? "red"
                                    : "#5d586c",
                                }}
                              >
                                {"Account Number"}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                            </div>
                            <InputField
                              InputLabelProps={{
                                shrink: true,
                              }}
                              fontSize="11px"
                              fullWidth
                              type={accountNumberFocused ? "text" : "text"}
                              value={accountNumberFocused ? (watch("accountNumber") || "") : (watch("accountNumber") || "").replace(/./g, "*")}
                              onChange={(e) => {
                                if (accountNumberFocused) {
                                  setValue("accountNumber", e.target.value);
                                  handleIsFormSaved();
                                  
                                  // Check if re-enter field has value and validate matching
                                  const reEnterValue = getValues("reEnterAccountNumber");
                                  const error = getAccountNumberValidationError(
                                    e.target.value,
                                    lengthValidation?.beneficiary
                                  );
                                  if(error){
                                    setError("accountNumber", {
                                      type: "manual",
                                      message: error,
                                    });
                                  }
                                  else if (reEnterValue) {
                                     clearErrors("accountNumber");
                                    if (e.target.value !== reEnterValue) {
                                      setAccountNumberError("Account number does not match");
                                    } else {
                                      setAccountNumberError("");
                                    }
                                  } else {
                                    setAccountNumberError("");
                                    clearErrors("accountNumber");
                                    trigger("accountNumber"); // refresh UI
                                  }
                                }
                              }}
                              className="asterisk-password"
                              //placeholder="Account Number *"
                              disabled={!isEditable|| isDisbTypeApproved}
                              onFocus={() => setAccountNumberFocused(true)}
                              onBlur={() => setAccountNumberFocused(false)}
                              inputProps={{
                                maxLength: lengthValidation?.beneficiary?.max ?? 17,
                                inputMode: "numeric", // Ensures numeric keyboard is used on mobile devices

                                onKeyDown: (
                                  e: React.KeyboardEvent<HTMLInputElement>
                                ) => {
                                  handleIsFormSaved();
                                  // Block non-numeric key presses
                                  if (
                                    !/[0-9]/.test(e.key) &&
                                    e.key !== "Backspace" &&
                                    e.key !== "ArrowLeft" &&
                                    e.key !== "ArrowRight" &&
                                    e.key !== "Delete"
                                  ) {
                                    e.preventDefault();
                                  }
                                },
                              }}
                              helperText={handleFormValidation("accountNumber")}
                              error={!!handleFormValidation("accountNumber")}
                              FormHelperTextProps={{
                                sx: { marginLeft: 0 }, // remove default 14px left padding
                              }}
                            />
                            {errors.accountNumber && (
                              <FormHelperText error>
                                {errors.accountNumber.message}
                              </FormHelperText>
                            )}
                          </Grid>

                          {handleBankDetailsCondition() && (
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                              <div>
                                <label
                                  htmlFor="custom-autocomplete"
                                  className="disbursement-inside-page-lable-condtion-dark"
                                  style={{
                                    color: (!!accountNumberError || !!handleFormValidation("reEnterAccountNumber"))
                                      ? "red"
                                      : "#5d586c",
                                  }}
                                >
                                  {"Re-enter Account Number"}{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                              </div>
                              <InputField
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                fontSize="11px"
                                fullWidth
                                type={"text"}
                                autoComplete="off"
                                {...register("reEnterAccountNumber", {
                                  setValueAs: (value) =>
                                    value === "" ? "" : value,
                                  minLength: {
                                    value: 8,
                                    message:
                                      "Account number must be at least 8 digits.",
                                  },
                                  maxLength: {
                                    value: 17,
                                    message:
                                      "Account number must not exceed 17 digits.",
                                  },
                                })}
                                disabled={!isEditable|| isDisbTypeApproved}
                                onFocus={() => setReEnterAccountNumberFocused(true)}
                                onBlur={() => setReEnterAccountNumberFocused(false)}
                                inputProps={{
                                  maxLength: 17,
                                  inputMode: "numeric",
                                  onKeyDown: (
                                    e: React.KeyboardEvent<HTMLInputElement>
                                  ) => {
                                    handleIsFormSaved();
                                    if (
                                      !/[0-9]/.test(e.key) &&
                                      e.key !== "Backspace" &&
                                      e.key !== "ArrowLeft" &&
                                      e.key !== "ArrowRight" &&
                                      e.key !== "Delete"
                                    ) {
                                      e.preventDefault();
                                    }
                                  },
                                  onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                                    handleIsFormSaved();
                                    
                                    // Real-time validation for account number matching
                                    const accountNumber = getValues("accountNumber");
                                    
                                    if (accountNumber && e.target.value) {
                                      if (accountNumber !== e.target.value) {
                                        setAccountNumberError("Account number does not match");
                                      } else {
                                        setAccountNumberError("");
                                      }
                                    } else {
                                      setAccountNumberError("");
                                    }
                                  },
                                }}
                                helperText={accountNumberError || handleFormValidation("reEnterAccountNumber")}
                                error={!!accountNumberError || !!handleFormValidation("reEnterAccountNumber")}
                                FormHelperTextProps={{
                                  sx: { marginLeft: 0 },
                                }}
                              />
                              {errors.reEnterAccountNumber && (
                                <FormHelperText error>
                                  {errors.reEnterAccountNumber.message}
                                </FormHelperText>
                              )}
                            </Grid>
                          )}

                          <Grid item xs={12} sm={12} md={4} lg={4}>
                            <div>
                              <label
                                htmlFor="custom-autocomplete"
                                className="disbursement-inside-page-lable-condtion-dark"
                                style={{
                                  color: !!handleFormValidation("ifsccode")
                                    ? "red"
                                    : "#5d586c",
                                }}
                              >
                                {"IFSC Code"}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                            </div>
                            <InputField
                              InputLabelProps={{
                                shrink: true,
                              }}
                              fontSize="11px"
                              fullWidth
                              //placeholder="IFSC Code *"
                              {...register("ifsccode", {
                                pattern: {
                                  // Pattern to validate the IFSC Code format
                                  value: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                                  message:
                                    "IFSC Code must be 11 characters: first 4 uppercase letters, followed by 0, and ending with 6 alphanumeric characters.",
                                },
                                validate: (value) => {
                                  // Check if there are any lowercase letters
                                  if (/[a-z]/.test(value)) {
                                    return "IFSC Code must be uppercase letters only.";
                                  }
                                  return true;
                                },
                              })}
                              disabled={!isEditable|| isDisbTypeApproved}
                              inputProps={{
                                maxLength: 11, // Restrict input to 11 characters
                                onKeyDown: (
                                  e: React.KeyboardEvent<HTMLInputElement>
                                ) => {
                                  handleIsFormSaved();
                                  // Allow only uppercase alphanumeric keys and control keys
                                  const isAlphanumeric =
                                    (e.key >= "a" && e.key <= "z") ||
                                    (e.key >= "A" && e.key <= "Z") ||
                                    (e.key >= "0" && e.key <= "9");
                                  const allowedKeys = [
                                    "Backspace",
                                    "ArrowLeft",
                                    "ArrowRight",
                                    "Delete",
                                    "Tab",
                                  ];

                                  if (
                                    !isAlphanumeric &&
                                    !allowedKeys.includes(e.key)
                                  ) {
                                    e.preventDefault();
                                  }
                                },
                                onChange: (
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  e.target.value = e.target.value.toUpperCase(); // Convert input to uppercase
                                },
                              }}
                              helperText={handleFormValidation("ifsccode")}
                              error={!!handleFormValidation("ifsccode")}
                              FormHelperTextProps={{
                                sx: { marginLeft: 0 }, // remove default 14px left padding
                              }}
                            />

                            {errors.ifsccode && (
                              <FormHelperText error>
                                {errors.ifsccode.message}
                              </FormHelperText>
                            )}
                          </Grid>

                          <Grid item xs={12} sm={12} md={4} lg={4}>
                            <div>
                              <label
                                htmlFor="custom-autocomplete"
                                className="disbursement-inside-page-lable-condtion-dark"
                                style={{
                                  color: !!handleFormValidation("accHolderName")
                                    ? "red"
                                    : "#5d586c",
                                }}
                              >
                                {"Account Holder Name"}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                            </div>
                            <InputField
                              helperText={handleFormValidation("accHolderName")}
                              error={!!handleFormValidation("accHolderName")}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              fontSize="11px"
                              fullWidth
                              //placeholder="Account Holder Name *"
                              {...register("accHolderName")}
                              disabled={!isEditable|| isDisbTypeApproved}
                              onChange={(e) => {
                                handleIsFormSaved();

                                // Prevent pasted leading spaces
                                if (e.target.value.startsWith(" ")) {
                                  e.target.value = e.target.value.trimStart();
                                }
                              }}
                              FormHelperTextProps={{
                                sx: { marginLeft: 0 }, // remove default 14px left padding
                              }}
                            />
                            {/* {isContinue && getValues("accHolderName") == "" && (
                          <FormHelperText error>
                            Account Holder Name is required.
                          </FormHelperText>
                        )} */}
                          </Grid>
                        </Grid>
                      </Box>
                    </>
                  )}
                </>
              )}
            </form>
          </>
        );
      case 1:
        return (
          <>
            <AddNewDocuments
              disbursementFormId={formID}
              activeFunction={activeFunction}
              setActiveFunction={setActiveFunction}
              paymentTypeId={paymentTypeId}
              setActiveStep={setActiveStep}
              remarkId={remarkId}
              remark={watch("Remark")}
              isNewUniversity={watch("isNewUniversity")}
              accountTypeId={accountTypeId}
              isMoveToNext={isMoveToNext}
              setIsLoadingUpdate={setIsLoadingUpdate}
              isLoadingUpdate={isLoadingUpdate}
              requestType= {getValues("requestType")}
              setallDocsPresent={setallDocsPresent}
            />
          </>
        );
      case 2:
        return (
          <>
          <AccountAggregator  bankName ={getValues("lienBankId")}
            accountNumber = {getValues("lienAccountNumber")}
            ifscCode = {getValues("lienIfscCode")}
            mobileNumber = {mobileNumberNew}
            setMobileNumbers={setMobileNumber}
            //consentStatus = {}
            //dateRange = {getValues("lienDateRange")}
            bankListLien={bankListLien}
            aggregatorData={aggregatorData}
            validConsent={validConsent}
            continueButton={continueButton}
            isLoadingUpdateNew={isLoadingUpdateNew}
            isEditable={isEditable}
            // 
            />

          </>
        );
      case 3:
        return (
          <>
            <DisbursementFormTermDetails disbursementFormId={formID} validConsent={validConsent} formStatus={formStatus} onClickFunc={handleEditDetails} />
          </>
        );
      case 4:
        return (
          <>
            <DisbursementFormThanksPage disbursementFormId={formID} />
          </>
        );
    }
  };
  /**
   * Generates slider marks based on the current form status.
   *
   * @returns {Array<{ value: number, label: string }>} An array of objects representing the slider marks.
   * - If `formStatus` is "indraft", returns marks with 50% completion.
   * - If `formStatus` is empty or undefined, returns marks with 0% completion.
   * - Otherwise, returns marks with 100% completion.
   */
  const getSliderMarks = () => {
    if (formStatus === "indraft") {
      return [
        {
          value: 0,
          label: "",
        },
        {
          value: 50,
          label: "50% Completed",
        },
      ];
    } else if (formStatus == "" || formStatus == undefined) {
      return [
        {
          value: 0,
          label: "",
        },
        {
          value: 50,
          label: "0% Completed",
        },
      ];
    }
    return [
      {
        value: 0,
        label: "",
      },
      {
        value: 50,
        label: "100% Completed",
      },
    ];
  };

  /**
   * Calculates the value for the progress bar based on the form status.
   *
   * @returns {number} - Returns 50 if the form status is "indraft", otherwise returns 100.
   */
  const handleProgressbarValue = () => {
    if(requestType==="lien" || getValues("requestType")==="lien"){
      if(allDocsPresent==true){
        return 66.6;
      } 
      else if (formStatus === "indraft") {
        return 33.3;
      }
      else if (formStatus === "save") {
        return 33.3;
      } else if (formStatus == "" || formStatus == undefined) {
        return 0;
      }
    }else{
      if (formStatus === "indraft") {
        return 50;
      } else if (formStatus === "save") {
        return 50;
      } else if (formStatus == "" || formStatus == undefined) {
        return 0;
      }
    }
    
    return 100;
  };

  const handleOpenEditMode = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      setIsEditable(true);
    }, 300);
  };
  const handleSkipAggregator=()=>{
    setActiveStep(3);
    // setIsEditableNext(true);
    // setIsEditable(false);
    // setActiveFunction("disbursement");
  }
  const checkConsent=(data:any)=>{
    const isConsentValid =
      data.consent_status?.toLowerCase() === "approved" &&
      new Date(data.consent_to_date) >= new Date();
    
     return isConsentValid;
  }
  const handleGetAggregatorDetails=async()=>{
    const params = new URLSearchParams(window.location.search);
    const consent = params.get("consent");
    let aggAppNo=localStorage.getItem("aggApplicationNo");
    if(!aggAppNo){
       aggAppNo=aggregatorNo;
    }
    if(getValues("lienAccountNumber")!=undefined && getValues("lienAccountNumber")!="undefined" && getValues("lienAccountNumber")!="" && getValues("lienAccountNumber")!=null && selectedLoanNumber!=undefined){
      setIsLoadingUpdateNew(true);
      if(localStorage.getItem("isEdit")=="true"){
        setIsEditable(true);
        setMoveToNext(false);
      }
      service.posts
      .getPosts(
        `/api/v1/third-party-apis/consent-details?lan_number=${selectedLoanNumber}&lien_account_number=${getValues("lienAccountNumber")}`
      )
      .then((response) => {
        const data: any = response?.data?.data?.data || [];
        localStorage.removeItem("isEdit");
        if(data  && data?.mobile_no){
          setMobileNumber(data?.mobile_no);
        }
        if(checkConsent(data)===true){
          setValidConsent(true);
        }else if(data?.consent_status?.toLowerCase() === "in-progress"){
          setValidConsent("in-progress")
        }
        else{
          setValidConsent(false);
        }
        })
      .catch((error) => {
        setIsLoadingUpdateNew(false);
      }).finally(()=>{
        setIsLoadingUpdateNew(false); 
      })
      
    }
    if ((consent=="true" && (window.location.pathname === "/dashboard")) || validConsent==="in-progress" && aggAppNo!="" && aggAppNo!=null && aggAppNo!=undefined && aggAppNo!="undefined" ) {
       let statusVal = "in-progress";
       localStorage.removeItem("disbursementFormId");
      service.posts
        .getPosts(`api/v1/third-party-apis/account-aggregator-get-details/${aggAppNo}`)
        .then((response) => {
          const data: any = response?.data?.data || [];
          const appVal = data?.appVal?.[0];

          if (appVal) {
            setAggregatorData(appVal);
            setMobileNumber(appVal?.applicantMobile);
            const validConsentData = hasValidConsent(appVal?.consentDetails,data?.consentInfo?.lienAccountNumber);
            setValidConsent(validConsentData);

            statusVal = checkValidationConsent(appVal?.consentDetails,data?.consentInfo?.lienAccountNumber);
          }
        })
        .catch((error) => {
          statusVal = "in-progress"; // fallback
          setValidConsent(statusVal)
        })
        .finally(() => {
          const cleanUrl = window.location.origin + window.location.pathname;
          window.history.replaceState({}, "", cleanUrl);

          service.posts
            .updatePost(
              `api/v1/third-party-apis/consent-status-update/${aggAppNo}/${statusVal}`
            )
            .catch((error) => {
              console.error("Error in second API:", error);
            })
            .finally(() => {
              setIsLoadingUpdateNew(false);
            });
        });
    }
  }
  
  const hasValidConsent = (consents:any,lienAcc:string) => {
    const today = new Date();

    return consents?.some((consent:any) => {
      const start = new Date(consent?.request?.dataRange?.from);
      const expiry = new Date(consent?.request?.dataRange?.to);
      // Get last 4 digits of lienAccountNumber
      //getValues("lienAccountNumber")
      let lienAccountNumber=lienAcc;
      const lienLast4 = lienAccountNumber?.slice(-4);
      const last4Digits = consent?.response?.accountsLinked
        ?.map((acc: any) => acc?.maskedAccNumber)  // take last 4 digits
        .filter(Boolean)                                      // remove null/undefined
        .join(", ");  
      if(consent?.response?.accountsLinked?.some(
        (acc:any) => acc?.maskedAccNumber?.slice(-4) === lienLast4
      ) && 
      consent?.response?.status === "ACTIVE" &&       // must be approved
      today >= start && today <= expiry){ 
        return true;
      }
      else if(consent?.response?.accountsLinked?.some(
        (acc:any) => acc?.maskedAccNumber?.slice(-4) !== lienLast4
      ) && 
      consent?.response?.status === "ACTIVE" &&       // must be approved
      today >= start && today <= expiry){
        setContinueButton(true);
        let aggAppNo=localStorage.getItem("aggApplicationNo");
          if(!aggAppNo){
            aggAppNo=aggregatorNo;
          }
          if(consent?.consentId && aggAppNo!="" && aggAppNo!=null && aggAppNo!=undefined && aggAppNo!="undefined"){
            let objData={
              "applicationNo":aggAppNo,
              "lan":selectedLoanNumber,
              "consentId":consent?.consentId,
              "reason": "Customer requested revocation"
            }
            postsServices.addPost(
              "/api/v1/third-party-apis/revoke-consent-short-url",
              objData
            );
          }
          dispatch(
          setStatusPopup({
              status: "Incorrect Account Selected",
              message: `The account you selected for consent [${last4Digits}] does not match the lien account [XXXXXXXX${lienLast4}] in your request. A consent revocation link has been sent to your registered email and phone number.`,
              buttonStatus: false,
              submessage:'You can now close this message and click "Continue" to proceed with your request submission.'
            })
          );

      }else{
        return (
          consent?.response?.accountsLinked?.some(
            (acc:any) => acc?.maskedAccNumber?.slice(-4) === lienLast4
          ) && 
          consent?.response?.status === "ACTIVE" &&       // must be approved
          today >= start && today <= expiry      // must be within validity
        );
      }
    });
  };
  const checkValidationConsent = (consents: any,lienAcc:string) => {
    const today = new Date();
    const lienLast4 = lienAcc?.slice(-4);

    return consents?.map((consent: any) => {
      const start = new Date(consent?.request?.dataRange?.from);
      const expiry = new Date(consent?.request?.dataRange?.to);

      const hasMatchingAcc = consent?.response?.accountsLinked?.some(
        (acc: any) => acc?.maskedAccNumber?.slice(-4) === lienLast4
      );

      const hasDifferentAcc = consent?.response?.accountsLinked?.some(
        (acc: any) => acc?.maskedAccNumber?.slice(-4) !== lienLast4
      );

      if (
        hasMatchingAcc &&
        consent?.response?.status === "ACTIVE" &&
        today >= start &&
        today <= expiry
      ) {
        return "approved";
      } else if (
        hasDifferentAcc &&
        consent?.response?.status === "ACTIVE" &&
        today >= start &&
        today <= expiry
      ) {
        return "wrong-consent";
      } else if (consent?.response?.status === "REJECTED") {
        return "expired";
      } else {
        return "pending";
      }
    });
  };

 useEffect(() => {
  if(selectedLoanNumber) {
    localStorage.setItem("selectedLanNumber", selectedLoanNumber)
  }
  const params = new URLSearchParams(window.location.search);
  const consent = params.get("consent");
  if (consent=="true" && window.location.pathname==="/dashboard") {
    const aggApplicationNo = localStorage.getItem("aggApplicationNo")
    setAggregatorNo(aggApplicationNo);
    setActiveStep(2); // just set step, don't call API here
  }
}, []); // runs once on mount

useEffect(() => {
  if (activeStep === 2) {
    (async () => {
        await handleGetAggregatorDetails();
      })();
  }
}, [activeStep, actionRowData?.aggApplicationNo,getValues("lienAccountNumber"),selectedLoanNumber]);

const removeQueryParams = (fullUrl: string) => {
  try {
    const url = new URL(fullUrl);
    return `${url.origin}${url.pathname}`;
  } catch (error) {
    console.error("Invalid URL:", error);
    return null;
  }
};
  const handleProvideConsent=async()=>{
    let dateValue=getDateRangeObject(actionRowData?.loanDetails?.loanEndDate,actionRowData?.loanDetails?.loanStartDate);
    // Generate a four-digit random number
    const randomFourDigit = Math.floor(1000 + Math.random() * 9000);

    let payload = {
      "applicationNo": `${refernceNo}${randomFourDigit}`,
      "name": userProfile?.name,
      "apiFetchType": 1,
      "mobile": mobileNumberNew ? mobileNumberNew:decrypt(userProfile?.phoneNumber),
      "email": decrypt(userProfile?.email),
      "applicantType": "0",
      "consentProductType": "2",
      "fromDate": `${dateValue.startDate}`,
      "toDate": `${dateValue.endDate}`,
      "consentDuration": "DAY",
      "consentDurationValue":getDaysBetween(dateValue.startDate,dateValue.endDate).toString(),
      "accountType": "",
      "lan":selectedLoanNumber,
      "cif": "",
      "landingPageNotRequired":true,
      "disbursementFormId":formID,
      "lienAccountNumber":getValues("lienAccountNumber"),
      "redirectLink":`${removeQueryParams(window.location.href)}`,
    };
    try {
      setisLoadingConsent(true);
      localStorage.setItem("isEdit","true");
      const response = await postsServices.addPost(
        "/api/v1/third-party-apis/create-consent",
        payload
      );
      setisLoadingConsent(false);
      if(response?.data?.data?.link){
        localStorage.setItem("aggApplicationNo",response?.data?.data?.consentApplicationNo);
        
        let rawUrl = response?.data?.data?.link;
        let finalUrl = rawUrl?.startsWith("http") 
          ? rawUrl 
          : `https://${rawUrl}`;
          window.location.href = finalUrl;
        //can i call callback function here?
      }
      // // Handle success response
      // dispatch(
      //   setStatusPopup({
      //     status: "success",
      //     message: "Data saved successfully.",
      //     buttonStatus: false,
      //   })
      // );
    } catch (error) {
      // Handle error response
      setisLoadingConsent(false);
      const err = error as AxiosError<{ message?: string }>;
      dispatch(
        setStatusPopup({
          status: "error",
          message:err?.response?.data?.message ?? `An error occurred during save.`,
          buttonStatus: false,
        })
      );
    }
  }
  return (
    <Box>
      {/* <LoaderBackdrop open={isLoading} /> */}
      <Grid item xs={12} className="document-container">
        <Typography className="loan-account-sub-headings">
          {activeStep == 0 || activeStep == 1
            ? "Fund Release"
            : "Fund Release Details"}
        </Typography>

        {(activeStep == 0 || activeStep == 1|| activeStep == 2) && (
          <>
          {/*<Card borderColor={true} padding="15px 25px 15px 25px">
             <Grid container>
              <Grid item xs={9} sm={9} md={11} lg={11}>
                <Typography
                  className="loan-account-main-heading"
                  style={{ marginBottom: "5px" }}
                >
                  Loan A/c {selectedLoanNumber}
                </Typography>
                <Typography className="loan-account-sub-heading">
                  {dashboardDataSet?.[0]?.description}
                </Typography>
              </Grid> 

              <Grid
                item
                xs={4}
                sm={4}
                md={2}
                lg={2}
                sx={{
                  display: "flex", // Flex container for the Grid
                  justifyContent: "center", // Center content horizontally
                  alignItems: "center", // Center content vertically
                }}
              >
                <OutlinedSmallButton title={"Active"} click={() => { }} />
              </Grid>
            </Grid>
          </Card>*/}
          </>
        )}
        {(activeStep == 0 || activeStep == 1|| activeStep == 2) && 
         rowData && rowData?.lienValues?.length>0 && !isXsOrSm && <CardDisbursement data={rowData}/>  
        }
        {(activeStep == 0 || activeStep == 1|| activeStep == 2) && 
         rowData && rowData?.lienValues?.length>0 && isXsOrSm && <FundRequestCard data={rowData}/>  
        }
        <div className="mt-20">
          <Card padding="0px 0px 0px 0px">
            {(activeStep == 0 || activeStep == 1 || activeStep == 2) && (
              <>
                <div className="padding-box">
                  <Grid container alignItems="center">
                    <Grid item xs={12} sm={12} md={10}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px", // Space between the main sections
                        }}
                      >
                        {/* Section 1 */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: isXsOrSm ? "10px" : "5px", // Space between the two boxes within this section
                          }}
                        >
                          {/* Box 1 */}

                          <Box
                            sx={{
                              width: "40px",
                              height: "40px",
                              background:
                                formStatus === "save"
                                  ? "rgba(0, 179, 181, 1)"
                                  : formStatus === "indraft"
                                    ? "rgba(0, 179, 181, 0.08)"
                                    : formStatus === "reject" && activeStep == 1
                                      ? "rgba(0, 179, 181, 0.08)"
                                      : formStatus === "query" && activeStep == 1
                                        ? "rgba(0, 179, 181, 0.08)"
                                        : formStatus === "approve" && activeStep == 1
                                          ? "rgba(0, 179, 181, 0.08)"
                                          : formStatus === "cancelled" && activeStep == 1
                                            ? "rgba(0, 179, 181, 0.08)"
                                            : (formStatus === "pendingFromCollection" || formStatus == "pendingFromCredit" || formStatus === "pendingFromOperationMaker" || formStatus === "pendingFromOperationChecker" || formStatus=="pendingFromSalesCoordinator"|| formStatus=="pendingFromLienOperationChecker") && activeStep == 1
                                              ? "rgba(0, 179, 181, 0.08)"
                                              : "rgba(0, 179, 181, 1)",
                              borderRadius: "6px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color:
                                formStatus === "save"
                                  ? "white"
                                  : formStatus === "indraft"
                                    ? "rgba(0, 179, 181, 1)"
                                    : formStatus === "reject" && activeStep == 1
                                      ? "rgba(0, 179, 181, 1)"
                                      : formStatus === "query" && activeStep == 1
                                        ? "rgba(0, 179, 181, 1)"
                                        : formStatus === "approve" && activeStep == 1
                                          ? "rgba(0, 179, 181, 1)"
                                          : formStatus === "cancelled" && activeStep == 1
                                            ? "rgba(0, 179, 181, 1)"
                                            : (formStatus === "pendingFromCollection" || formStatus == "pendingFromCredit" || formStatus === "pendingFromOperationMaker" || formStatus === "pendingFromOperationChecker" || formStatus==="pendingFromSalesCoordinator" || formStatus=="pendingFromLienOperationChecker") && activeStep == 1
                                              ? "rgba(0, 179, 181, 1)"
                                              : "white",
                              fontWeight: "600",
                              fontSize: "18px",
                            }}
                          >
                            1
                          </Box>

                          {/* Box 2 */}
                          <Box sx={{ paddingLeft: isXsOrSm ? "0px" : "5px" }}>
                            {isXsOrSm ? (
                              <>
                                {activeStep == 0 && (
                                  <>
                                    <Typography
                                      sx={{
                                        color: "rgba(75, 70, 92, 1)",
                                        fontWeight: "600",
                                        fontSize: "15px",
                                        lineHeight: "21px",
                                      }}
                                    >
                                      Request Form
                                    </Typography>
                                    <Typography
                                      sx={{
                                        color: "rgba(75, 70, 92, 0.5)",
                                        fontWeight: "500",
                                        fontSize: "13px",
                                        lineHeight: "20px",
                                      }}
                                    >
                                      Name/Email/Contact
                                    </Typography>
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                <Typography
                                  sx={{
                                    color: "rgba(75, 70, 92, 1)",
                                    fontWeight: "600",
                                    fontSize: "15px",
                                    lineHeight: "21px",
                                  }}
                                >
                                  Request Form
                                </Typography>
                                <Typography
                                  sx={{
                                    color: "rgba(75, 70, 92, 0.5)",
                                    fontWeight: "500",
                                    fontSize: "13px",
                                    lineHeight: "20px",
                                  }}
                                >
                                  Name/Email/Contact
                                </Typography>
                              </>
                            )}
                          </Box>
                        </Box>

                        {/* Arrow */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <ArrowForwardIosIcon
                            sx={{
                              color: "rgba(75, 70, 92, 0.5)",
                              fontSize: "20px",
                            }}
                          />
                        </Box>

                        {/* Section 2 */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px", // Space between the two boxes within this section
                          }}
                        >
                          {/* Box 1 */}

                          <Box
                            sx={{
                              width: "40px",
                              height: "40px",
                              background:
                                formStatus === "indraft" && activeStep == 1
                                  ? "rgba(0, 179, 181, 1)"
                                  : formStatus === "query" && activeStep == 1
                                    ? "rgba(0, 179, 181, 1)"
                                    : formStatus === "approve" && activeStep == 1
                                      ? "rgba(0, 179, 181, 1)"
                                      : formStatus === "reject" && activeStep == 1
                                        ? "rgba(0, 179, 181, 1)"
                                        : formStatus === "cancelled" && activeStep == 1
                                          ? "rgba(0, 179, 181, 1)"
                                          : (formStatus === "pendingFromCollection" || formStatus == "pendingFromCredit" || formStatus === "pendingFromOperationMaker" || formStatus === "pendingFromOperationChecker" || formStatus==="pendingFromSalesCoordinator"|| formStatus=="pendingFromLienOperationChecker") && activeStep == 1
                                            ? "rgba(0, 179, 181, 1)"
                                            : "rgba(75, 70, 92, 0.08)",
                              borderRadius: "6px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color:
                                formStatus === "indraft" && activeStep == 1
                                  ? "white"
                                  : formStatus === "query" && activeStep == 1
                                    ? "white"
                                    : formStatus === "approve" && activeStep == 1
                                      ? "white"
                                      : formStatus === "reject" && activeStep == 1
                                        ? "white"
                                        : formStatus === "cancelled" && activeStep == 1
                                          ? "white"
                                          : (formStatus === "pendingFromCollection" || formStatus == "pendingFromCredit" || formStatus === "pendingFromOperationMaker" || formStatus === "pendingFromOperationChecker" || formStatus==="pendingFromSalesCoordinator"|| formStatus=="pendingFromLienOperationChecker") && activeStep == 1
                                            ? "white"
                                            : "rgba(75, 70, 92, 0.7)",
                              fontWeight: "600",
                              fontSize: "18px",
                            }}
                          >
                            2
                          </Box>
                        
                          {isXsOrSm ? (
                            <>
                              {activeStep == 1 && (
                                <>
                                  <Box>
                                    <Typography
                                      sx={{
                                        color: "rgba(75, 70, 92, 1)",
                                        fontWeight: "600",
                                        fontSize: "15px",
                                        lineHeight: "21px",
                                      }}
                                    >
                                      Documents
                                    </Typography>
                                    <Typography
                                      sx={{
                                        color: "rgba(75, 70, 92, 0.5)",
                                        fontWeight: "500",
                                        fontSize: "13px",
                                        lineHeight: "20px",
                                      }}
                                    >
                                      Upload Document
                                    </Typography>
                                  </Box>
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <Box>
                                <Typography
                                  sx={{
                                    color: "rgba(75, 70, 92, 1)",
                                    fontWeight: "600",
                                    fontSize: "15px",
                                    lineHeight: "21px",
                                  }}
                                >
                                  Documents
                                </Typography>
                                <Typography
                                  sx={{
                                    color: "rgba(75, 70, 92, 0.5)",
                                    fontWeight: "500",
                                    fontSize: "13px",
                                    lineHeight: "20px",
                                  }}
                                >
                                  Upload Document
                                </Typography>
                              </Box>
                            </>
                          )
                          }
                        </Box>
                      {getValues("requestType")==="lien" &&
                      <>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <ArrowForwardIosIcon
                            sx={{
                              color: "rgba(75, 70, 92, 0.5)",
                              fontSize: "20px",
                            }}
                          />
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px", // Space between the two boxes within this section
                          }}
                        >
                          {/* Box 1 */}

                          <Box
                            sx={{
                              width: "40px",
                              height: "40px",
                              background:
                                formStatus === "indraft" && activeStep == 2
                                  ? "rgba(0, 179, 181, 1)"
                                  : formStatus === "query" && activeStep ==2
                                    ? "rgba(0, 179, 181, 1)"
                                    : formStatus === "approve" && activeStep == 2
                                      ? "rgba(0, 179, 181, 1)"
                                      : formStatus === "reject" && activeStep == 2
                                        ? "rgba(0, 179, 181, 1)"
                                        : formStatus === "cancelled" && activeStep == 2
                                          ? "rgba(0, 179, 181, 1)"
                                          : (formStatus === "pendingFromCollection" || formStatus == "pendingFromCredit" || formStatus === "pendingFromOperationMaker" || formStatus === "pendingFromOperationChecker" || formStatus==="pendingFromSalesCoordinator"|| formStatus=="pendingFromLienOperationChecker") && activeStep == 2
                                            ? "rgba(0, 179, 181, 1)"
                                            : "rgba(75, 70, 92, 0.08)",
                              borderRadius: "6px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color:
                                formStatus === "indraft" && activeStep == 2
                                  ? "white"
                                  : formStatus === "query" && activeStep == 2
                                    ? "white"
                                    : formStatus === "approve" && activeStep == 2
                                      ? "white"
                                      : formStatus === "reject" && activeStep == 2
                                        ? "white"
                                        : formStatus === "cancelled" && activeStep == 2
                                          ? "white"
                                          : (formStatus === "pendingFromCollection" || formStatus == "pendingFromCredit" || formStatus === "pendingFromOperationMaker" || formStatus === "pendingFromOperationChecker" || formStatus==="pendingFromSalesCoordinator"|| formStatus=="pendingFromLienOperationChecker") && activeStep == 2
                                            ? "white"
                                            : "rgba(75, 70, 92, 0.7)",
                              fontWeight: "600",
                              fontSize: "18px",
                            }}
                          >
                            3
                          </Box>

                          {/* Box 2 */}
                          {isXsOrSm ? (
                            <>
                              {activeStep == 2 && (
                                <>
                                  <Box>
                                    <Typography
                                      sx={{
                                        color: "rgba(75, 70, 92, 1)",
                                        fontWeight: "600",
                                        fontSize: "15px",
                                        lineHeight: "21px",
                                      }}
                                    >
                                      Account Information Consent
                                    </Typography>
                                    <Typography
                                      sx={{
                                        color: "rgba(75, 70, 92, 0.5)",
                                        fontWeight: "500",
                                        fontSize: "13px",
                                        lineHeight: "20px",
                                      }}
                                    >
                                      Authorize Data Fetch
                                    </Typography>
                                  </Box>
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <Box sx={{
                              minWidth: "142px"}}>
                                <Typography
                                  sx={{
                                    color: "rgba(75, 70, 92, 1)",
                                    fontWeight: "600",
                                    fontSize: "15px",
                                    lineHeight: "21px",
                                  }}
                                >
                                  Account Information Consent
                                </Typography>
                                <Typography
                                  sx={{
                                    color: "rgba(75, 70, 92, 0.5)",
                                    fontWeight: "500",
                                    fontSize: "13px",
                                    lineHeight: "20px",
                                  }}
                                >
                                  Authorize Data Fetch
                                </Typography>
                              </Box>
                            </>
                          )}
                        </Box>
                      </>}
                      </Box>
                    </Grid>

                    <Grid item xs={12} sm={12} md={2}>
                      {!isXsOrSm && (
                        <>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-start", // Ensures items align inline from left to right
                              gap: "20px", // Adds spacing between the text and progress circle
                            }}
                          >
                            <Stack direction="column">
                              <Typography
                                sx={{
                                  fontSize: "13px",
                                  color: "#B0B0B0",
                                  fontWeight: 500,
                                  marginBottom: "4px",
                                }}
                              >
                                Completion Rate
                              </Typography>
                            </Stack>
                            <Typography
                              sx={{
                                fontSize: "15px",
                                color: "#00B3B5",
                                fontWeight: 600,
                              }}
                            >
                              {handleProgressbarValue()}%
                            </Typography>
                            <CircularProgress
                              variant="determinate"
                              value={handleProgressbarValue()}
                              sx={{
                                color: "#00B3B5",
                                borderRadius: "50%",
                              }}
                              thickness={5}
                              size={30}
                            />

                            {/* <Box>
                              {isLoading ? (
                                <Skeleton
                                  variant="rectangular"
                                  width="101px"
                                  height={42}
                                  sx={{ borderRadius: "8px" }}
                                />
                              ) : (
                                activeStep == 0 &&
                                formStatus == "query" &&
                                !isEditable && (
                                  <OutlinedSecondaryButton
                                    width={isXsOrSm ? "50px" : "70px"}
                                    height={isXsOrSm ? "30px" : "42px"}
                                    onClick={() => {
                                      setIsEditable(true);
                                      setMoveToNext(false);
                                    }}
                                    fullWidth={true}
                                  >
                                    <ButtonLoader
                                      title="Edit"
                                      isLoading={isLoading}
                                    />
                                  </OutlinedSecondaryButton>
                                )
                              )}
                            </Box> */}


                          </Box>

                        </>
                      )}
                    </Grid>


                  </Grid>

                </div>
              </>
            )}

            {renderStepContent()}

            {(activeStep == 0 || activeStep == 1) && (
              <div className="padding-box-2 form-container">
                <Box mt={2}>
                  <Grid
                    container
                    alignItems="center"
                    sx={{ paddingBottom: "10px" }}
                    spacing={activeStep==0?2:0}
                    className="form-container"
                  >
                    <Grid item xs={4} sm={4} md={8} lg={8}>
                      <Typography
                        sx={{
                          fontSize: "15px",
                          color: "rgba(0, 179, 181, 1)",
                          lineHeight: "14px",
                          fontWeight: "500",
                        }}
                      >
                        REMARKS
                      </Typography>
                    </Grid>
                    {isRemarkHistoryList && (
                      <Grid
                        item
                        xs={8}
                        sm={8}
                        md={4}
                        lg={4}
                        container
                        justifyContent="flex-end"
                      >
                        <Button
                          variant="outlined"
                          startIcon={
                            <img src={remarkSave} alt="Remark History" />
                          }
                          sx={{
                            color: "#fff",
                            borderColor: "#F2F2F2",
                            textTransform: "none",
                            backgroundColor: "#1CB1B1",
                            "&:hover": {
                              borderColor: "#F2F2F2",
                              backgroundColor: "#1CB1B1",
                            },
                          }}
                          onClick={handleFilterButtonClick}
                        >
                          Remark History
                        </Button>
                      </Grid>
                    )}
                  </Grid>

                  {showRemark && (
                    <>
                      <Grid mb={3}>
                        <Grid container item xs={isXsOrSm? (activeStep==0? 11.5 : 12 ): (activeStep==0?11.71:12)} >
                        
                          {isLoading ? (
                            <>
                              <Skeleton
                                variant="rectangular"
                                width="100%"
                                height={42}
                                sx={{ borderRadius: "8px" }}
                              />
                            </>
                          ) : (
                            <InputField
                              InputLabelProps={{
                                shrink: true,
                              }}
                              fontSize="11px"
                              highlightRed={true}
                              //placeholder="Please enter Avanse remark"
                              variant="outlined"
                              fullWidth
                              required
                              multiline
                              padding="7px 14px 7px 14px"
                              disabled={true}
                              rows={1}
                              {...register("avanseRemark")}
                            />
                          )}
                        </Grid>
                      </Grid>
                    </>
                  )}

                  <Grid container mb={3} className="form-container" spacing={activeStep==0?2:0}>
                    <Grid item xs={12}>
                      {isLoading ? (
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height={42}
                          sx={{ borderRadius: "8px" }}
                        />
                      ) : (
                        <>
                          <div>
                            <label
                              htmlFor="custom-autocomplete"
                              className="disbursement-inside-page-lable-condtion-dark"
                              style={{
                                color: !!handleFormValidation("Remark")
                                  ? "red"
                                  : "#5d586c",
                              }}
                            >
                              {"Customer Remark"}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                          </div>
                          <InputField
                            InputLabelProps={{
                              shrink: true,
                            }}
                            fontSize="11px"
                            error={!!handleFormValidation("Remark")}
                            helperText={handleFormValidation("Remark")}
                            //placeholder="Please enter customer remark"
                            padding="7px 14px 7px 14px"
                            variant="outlined"
                            fullWidth
                            required
                            multiline
                            disabled={!isEditable}
                            rows={1}
                            onChange={(event) => handleRemarkChange(event)}
                            defaultValue={getValues("Remark")}
                            FormHelperTextProps={{
                              sx: { marginLeft: 0 }, // remove default 14px left padding
                            }}
                          // {...register("Remark")}
                          />
                        </>
                      )}
                    </Grid>
                  </Grid>
                </Box>
              </div>
            )}
            {activeStep !== 4 && !isXsOrSm && (
              <>
                <div className="padding-box form-container">
                  <Box
                    display="flex"
                    flexWrap="wrap"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{ marginBottom: "10px" }}
                  >
                    {/* Previous Button */}
                    <Box
                      flex={`0 0 ${activeStep == 0 ? "16.666%" : "25%"}`}
                      display="flex"
                      alignItems="center"
                      sx={{
                        marginBottom: isXsOrSm ? "0px" : "20px",
                        // marginTop: isXsOrSm ? "0px" : "10px",
                      }}
                    >
                      {isLoading ? (
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height={42}
                          sx={{ borderRadius: "8px" }}
                        />
                      ) : (
                        <>
                          {activeStep == 0 || activeStep == 1|| activeStep == 2 ? (
                            <OutlinedPrimaryButton
                              width={isXsOrSm ? "90px" : "129px"}
                              height={isXsOrSm ? "30px" : "42px"}
                              onClick={() => {
                                if (activeStep == 1) {
                                  setFormStatus(
                                    formStatus == "query"
                                      ? "query"
                                      : formStatus == "pendingFromOperationChecker"
                                        ? "pendingFromOperationChecker"
                                        : formStatus == "pendingFromOperationMaker"
                                          ? "pendingFromOperationMaker"
                                          :formStatus=="pendingFromLienOperationChecker"
                                          ? "pendingFromLienOperationChecker"
                                          : formStatus == "approve"
                                            ? "approve"
                                            : formStatus == "reject"
                                              ? "reject"
                                              : formStatus == "pendingFromCredit"
                                                ? "pendingFromCredit"
                                                : formStatus == "pendingFromCollection"
                                                  ? "pendingFromCollection"
                                                : formStatus == "pendingFromSalesCoordinator"
                                                  ? "pendingFromSalesCoordinator"
                                                  : formStatus == "cancelled"
                                                    ? "cancelled"
                                                    : "save"
                                  );
                                  handleFunctionForStep2(1);
                                } else {
                                  handleBack();
                                }
                              }}
                              fullWidth={true}
                            >
                              <WestIcon
                                sx={{ fontSize: isXsOrSm ? "15px" : "20px" }}
                              />{" "}
                              Previous
                            </OutlinedPrimaryButton>
                          ) :
                          (
                            getButton()
                          )}
          
                      </>
                      )}
                    </Box>

                    {/* Spacer */}
                    <Box flex="1"></Box>

                    {/* Last Three Buttons */}
                    <Box
                      display="flex"
                      gap={isXsOrSm ? "3px" : "24px"} /* 24px gap between the buttons */
                      sx={{
                        // marginTop: isXsOrSm ? "10px" : "0px",
                        marginBottom: isXsOrSm ? "0px" : "10px",
                      }}
                    >
                      {/* Edit Button */}
                      <Box>
                        {isLoading ? (
                          <Skeleton
                            variant="rectangular"
                            width="101px"
                            height={42}
                            sx={{ borderRadius: "8px" }}
                          />
                        ) : (
                          activeStep == 0 &&
                          formStatus == "query" &&
                          !isEditable && (
                            <OutlinedSecondaryButton
                              width={isXsOrSm ? "50px" : "101px"}
                              height={isXsOrSm ? "30px" : "42px"}
                              onClick={() => {
                                setIsEditable(true);
                                setMoveToNext(false);
                              }}
                              fullWidth={true}
                            >
                              <ButtonLoader
                                title="Edit"
                                isLoading={isLoading}
                              />
                            </OutlinedSecondaryButton>
                          )
                        )}
                      </Box>


                      {isLoading ? (
                        <Skeleton
                          variant="rectangular"
                          width="101px"
                          height={42}
                          sx={{ borderRadius: "8px" }}
                        />
                      ) : (
                        <>
                          {(formStatus && (formStatus == "indraft" || isEditable)) && isDisbTypeApproved===false && (
                            <>
                              <OutlinedPrimaryButton
                                width={isXsOrSm ? "60px" : "101px"}
                                height={isXsOrSm ? "30px" : "42px"}
                                onClick={() => {                              // Handle cancel action here
                                  handleCancelForm();
                                }}
                              >
                                Cancel
                              </OutlinedPrimaryButton>
                            </>
                          )}
                        </>
                      )}

                      {isLoading ? (
                        <Skeleton
                          variant="rectangular"
                          width="101px"
                          height={42}
                          sx={{ borderRadius: "8px" }}
                        />
                      ) : (
                        <>
                        {/* (formStatus && (formStatus == "indraft" || isEditable)) && */}
                          { activeStep==2 && (validConsent===false || validConsent==="in-progress") && continueButton===false &&isEditable===true && (
                            <>
                              <OutlinedPrimaryButton
                                width={isXsOrSm ? "82px" : "130px"}
                                height={isXsOrSm ? "30px" : "42px"}
                                onClick={() => {                              // Handle cancel action here
                                  handleSkipAggregator();
                                }}
                                fullWidth={true}
                              >
                                {isXsOrSm ? "Skip":"Skip Consent"}
                              </OutlinedPrimaryButton>
                            </>
                          )}
                        </>
                      )}
                      {/* Save as Draft */}
                      {activeStep == 0 && isEditable && formStatus!="query" && (
                        <Box
                          sx={{
                            // marginTop: isXsOrSm ? "10px" : "0px",
                            marginBottom: isXsOrSm ? "0px" : "10px",
                          }}
                        >
                          {isLoading ? (
                            <Skeleton
                              variant="rectangular"
                              width="143px"
                              height={42}
                              sx={{ borderRadius: "8px" }}
                            />
                          ) : (
                            <OutlinedPrimaryButton
                              width={isXsOrSm ? "60px" : "143px"}
                              height={isXsOrSm ? "30px" : "42px"}
                              fullWidth={true}
                              onClick={handleSubmit((data) => {
                                handleSave(data)
                              })}
                              type="submit"
                              disabled={
                                !isEditable ||
                                isLoadingUpdateSave ||
                                isLoadingUpdate
                              }
                            >
                              <ButtonLoader
                                title={isXsOrSm ? "Save" : "Save as Draft"}
                                isLoading={isLoadingUpdateSave}
                              />
                            </OutlinedPrimaryButton>
                          )}
                        </Box>
                      )}

                      {/* Next Button */}
                      <Box
                        sx={{
                          // marginTop: isXsOrSm ? "10px" : "0px",
                          marginBottom: isXsOrSm ? "0px" : "10px",
                        }}
                      >
                        {isLoading ? (
                          <Skeleton
                            variant="rectangular"
                            width="101px"
                            height={42}
                            sx={{
                              borderRadius: "8px",
                              marginBottom: isXsOrSm ? "0px" : "10px",
                            }}
                          />
                        ) : (
                          <>{activeStep!==2 && 
                            <PrimaryButton
                              width={
                                activeStep == 3
                                  ? isXsOrSm
                                    ? "110px"
                                    : "262px"
                                  : activeStep == 2
                                  ? isXsOrSm
                                    ? "148px"
                                    : "148px"
                                  : isXsOrSm
                                    ? "90px"
                                    : "101px"
                              }
                              height={isXsOrSm ? "30px" : "39px"}
                              onClick={handleSubmit((data) => {
                                if (activeStep == 1) {
                                  handleFunctionForStep2(2);
                                } else if (activeStep == 0) {
                                  handleContinue(data);
                                }
                                else {
                                  handleContinueUnderStand();
                                }
                              })}
                              disabled={
                                (!isEnabled && isDisabled) ||
                                isLoadingUpdate ||
                                (formStatus == "query" && activeStep == 3 && isEnabled==true) ||
                                (formStatus == "pendingFromOperationMaker" && activeStep == 3) ||
                                (formStatus=="pendingFromLienOperationChecker" && activeStep == 3) || 
                                (formStatus == "pendingFromOperationChecker" && activeStep == 3) ||
                                (formStatus == "approve" && activeStep == 3) ||
                                (formStatus == "reject" && activeStep == 3) ||
                                (formStatus == "pendingFromCredit" && activeStep == 3) ||
                                (formStatus == "pendingFromCollection" && activeStep == 3) ||
                                (formStatus == "cancelled" && activeStep == 3) ||
                                (formStatus == "partiallyApproved" && activeStep == 3) ||
                                (formStatus == "cancelled" && activeStep == 1) ||
                                (formStatus == "pendingFromSalesCoordinator" && activeStep == 3) ||
                                isLoadingUpdateSave
                              }
                              fullWidth={true}
                            >
                              {activeStep == 3 ? (
                                <ButtonLoader
                                  title={
                                    isXsOrSm
                                      ? "Confirm"
                                      : "Confirm fund release request"
                                  }
                                  isLoading={isLoadingUpdate}
                                />
                              ) : 
                              (
                                <>
                                  <ButtonLoader
                                    title={`Next `}
                                    isLoading={isLoadingUpdate}
                                  />
                                  &nbsp;
                                  {!isLoadingUpdate && (
                                    <ArrowForwardIcon
                                      sx={{
                                        fontSize: isXsOrSm ? "15px" : "20px",
                                      }}
                                    />
                                  )}
                                </>
                              )}
                            </PrimaryButton>}
                            {activeStep===2 && ((validConsent===true || continueButton|| isEditable===false)? (
                                <PrimaryButton
                                width={
                                  activeStep == 2
                                    && isXsOrSm
                                      ? "100px"
                                      : "100px"
                                }
                                height={isXsOrSm ? "30px" : "39px"}
                                onClick={handleSkipAggregator}
                                disabled={isLoadingUpdateNew}
                                fullWidth={true}
                              >
                                {
                                  <>
                                  <ButtonLoader
                                    title={"Continue"}
                                    isLoading={isLoadingUpdateNew}
                                  />
                                  &nbsp;
                                  {!isLoadingUpdateNew && (
                                    <ArrowForwardIcon
                                      sx={{
                                        fontSize: isXsOrSm ? "15px" : "20px",
                                      }}
                                    />
                                  )}
                                  </>
                                }
                                </PrimaryButton>
                              ):(
                              <PrimaryButton
                                width={
                                  activeStep == 2
                                    && isXsOrSm
                                      ? "150px"
                                      : "140px"
                                }
                                height={isXsOrSm ? "30px" : "39px"}
                                onClick={handleProvideConsent}
                                disabled={isLoadingConsent}
                                fullWidth={true}
                              >
                                {
                                  <ButtonLoader
                                    title={"Provide Consent"}
                                    isLoading={isLoadingConsent}
                                  />
                                }
                                </PrimaryButton>
                              )
                            )}
                          </>
                        )}
                      </Box>
                    </Box>
                  </Box>
                </div>
              </>
            )}

            {activeStep !== 4 && isXsOrSm && (
              <>
             
                <div className="padding-box-2 form-container">
                   <Grid xs={activeStep==0?11.5 : activeStep==2 ? 11.75 : 0}>
                  <Box
                    display="flex"
                    flexWrap="wrap"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{ marginBottom: "10px" }}
                  >
                    

                    {/* Next Button */}
                    <Grid item xs={12} mb={1}
                    >
                      {isLoading ? (
                        <Skeleton
                          variant="rectangular"
                          width="101px"
                          height={42}
                          sx={{
                            borderRadius: "8px",
                            marginBottom: isXsOrSm ? "0px" : "10px",
                          }}
                        />
                      ) : (
                        <>{activeStep!==2 && 
                          <PrimaryButton
                            height={isXsOrSm ? "37px" : "39px"}
                            onClick={handleSubmit((data) => {
                              if (activeStep == 1) {
                                handleFunctionForStep2(2);
                              } else if (activeStep == 0) {
                                handleContinue(data);
                              }else {
                                handleContinueUnderStand();
                              }
                            })}
                            disabled={
                              (!isEnabled && isDisabled) ||
                              isLoadingUpdate ||
                              (formStatus == "query" && activeStep == 3 && isEnabled==true) ||
                              (formStatus == "pendingFromOperationMaker" && activeStep == 3) ||
                              (formStatus=="pendingFromLienOperationChecker" && activeStep == 3) || 
                              (formStatus == "pendingFromOperationChecker" && activeStep == 3) ||
                              (formStatus == "approve" && activeStep == 3) ||
                              (formStatus == "reject" && activeStep == 3) ||
                              (formStatus == "pendingFromCredit" && activeStep == 3) ||
                              (formStatus == "pendingFromCollection" && activeStep == 3) ||
                              (formStatus == "cancelled" && activeStep == 3) ||
                              (formStatus == "cancelled" && activeStep == 1) ||
                              (formStatus == "partiallyApproved" && activeStep == 3) ||
                              (formStatus == "pendingFromSalesCoordinator" && activeStep == 3) ||
                              isLoadingUpdateSave
                            }
                            fullWidth={true}
                          >
                            {activeStep == 3 ? (
                              <>
                              <ButtonLoader
                                title={"Confirm fund release request"}
                                isLoading={isLoadingUpdate}
                              />
                                &nbsp;
                                &nbsp;
                                &nbsp;
                                {!isLoadingUpdate && (
                                  <ArrowForwardIcon
                                    sx={{
                                      fontSize: isXsOrSm ? "15px" : "20px",
                                    }}
                                  />
                                )}</>
                            ) : 
                            (
                              <>
                                <ButtonLoader
                                  title={`Next `}
                                  isLoading={isLoadingUpdate}
                                />
                                &nbsp;
                                {!isLoadingUpdate && (
                                  <ArrowForwardIcon
                                    sx={{
                                      fontSize: isXsOrSm ? "15px" : "20px",
                                    }}
                                  />
                                )}
                              </>
                            )}
                          </PrimaryButton>}
                          {activeStep===2 && (
                            (validConsent===true || continueButton || isEditable===false)? (
                              <PrimaryButton
                              height={isXsOrSm ? "33px" : "39px"}
                              onClick={handleSkipAggregator}
                              disabled={isLoadingUpdateNew}
                              fullWidth={true}
                            >
                              {
                                <>
                                <ButtonLoader
                                  title={"Continue"}
                                  isLoading={isLoadingUpdateNew}
                                />
                                &nbsp;
                                {!isLoadingUpdateNew && (
                                  <ArrowForwardIcon
                                    sx={{
                                      fontSize: isXsOrSm ? "15px" : "20px",
                                    }}
                                  />
                                )}
                                </>
                              }
                              </PrimaryButton>
                            ):(
                            <PrimaryButton
                              height={isXsOrSm ? "33px" : "39px"}
                              onClick={handleProvideConsent}
                              disabled={isLoadingConsent}
                              fullWidth={true}
                            >
                              {
                                <ButtonLoader
                                  title={"Provide Consent"}
                                  isLoading={isLoadingConsent}
                                />
                              }
                              </PrimaryButton>
                            )
                          )}
                        </>
                      )}
                    </Grid>
                    <br/>
                    {/* Previous Button */}
                     <Grid item xs={12} mb={1} sx={{display: "flex"}}>
                      {isLoading ? (
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height={42}
                          sx={{ borderRadius: "8px" }}
                        />
                      ) : (
                        <>
                          {activeStep == 0 || activeStep == 1|| activeStep == 2 ? (
                            <OutlinedPrimaryButton
                              fullWidth
                              sx={{ width: "100%" }}
                              height={isXsOrSm ? "36px" : "42px"}
                              onClick={() => {
                                if (activeStep == 1) {
                                  setFormStatus(
                                    formStatus == "query"
                                      ? "query"
                                      : formStatus == "pendingFromOperationChecker"
                                        ? "pendingFromOperationChecker"
                                        : formStatus == "pendingFromOperationMaker"
                                          ? "pendingFromOperationMaker"
                                          :formStatus=="pendingFromLienOperationChecker"
                                          ? "pendingFromLienOperationChecker"
                                          : formStatus == "approve"
                                            ? "approve"
                                            : formStatus == "reject"
                                              ? "reject"
                                              : formStatus == "pendingFromCredit"
                                                ? "pendingFromCredit"
                                                : formStatus == "pendingFromCollection"
                                                  ? "pendingFromCollection"
                                                : formStatus == "pendingFromSalesCoordinator"
                                                  ? "pendingFromSalesCoordinator"
                                                  : formStatus == "cancelled"
                                                    ? "cancelled"
                                                    : "save"
                                  );
                                  handleFunctionForStep2(1);
                                } else {
                                  handleBack();
                                }
                              }}
                              
                            >
                              <WestIcon
                                sx={{ fontSize: isXsOrSm ? "15px" : "20px" }}
                              />{" "}
                              Previous
                            </OutlinedPrimaryButton>
                          ) :
                          (
                            getButton()
                          )}
          
                      </>
                      )}
                    </Grid>

                    {/* Last Three Buttons */}
                      {/* Edit Button */}
                      <>
                      <Grid item xs={12} mb={0} sx={{display: "flex"}}>
                        {isLoading ? (
                          <Skeleton
                            variant="rectangular"
                            height={42}
                            sx={{ borderRadius: "8px" }}
                          />
                        ) : (
                          activeStep == 0 &&
                          formStatus == "query" &&
                          !isEditable && (
                          <Grid item xs={12} mb={1} sx={{display: "flex"}}>
                            <OutlinedSecondaryButton
                            fullWidth
                              sx={{ width: "100%" }}
                              height={isXsOrSm ? "37px" : "42px"}
                              // width="100%"
                              onClick={() => {
                                setIsEditable(true);
                                setMoveToNext(false);
                              }}
                              // fullWidth={true}
                            >
                              <ButtonLoader
                                title="Edit"
                                isLoading={isLoading}
                              />
                            </OutlinedSecondaryButton>
                          </Grid>
                          )
                        )}
                      </Grid>
                      </>
                        {isLoading ? (
                          <Skeleton
                            variant="rectangular"
                            height={42}
                            sx={{ borderRadius: "8px" }}
                          />
                        ) : (
                          <>
                            {(formStatus && (formStatus == "indraft" || isEditable)) && isDisbTypeApproved===false &&(
                              <>
                              <Grid item xs={12} mb={1} sx={{display: "flex"}}>
                                <OutlinedPrimaryButton
                                fullWidth
                                  sx={{ width: "100%" }}
                                 height={isXsOrSm ? "37px" : "42px"}
                                  onClick={() => {                              // Handle cancel action here
                                    handleCancelForm();
                                  }}
                                 
                                >
                                  Cancel
                                </OutlinedPrimaryButton>
                              </Grid>
                            
                              </>
                            )}
                          </>
                        )}
                      {isLoading ? (
                        <Skeleton
                          variant="rectangular"
                          width="101px"
                          height={42}
                          sx={{ borderRadius: "8px" }}
                        />
                      ) : (
                        <>
                        {/* (formStatus && (formStatus == "indraft" || isEditable)) && */}
                          { activeStep==2 && (validConsent===false || validConsent==="in-progress") && continueButton===false && isEditable===true && (
                            <Grid item xs={12} mb={2} sx={{display: "flex"}}>
                              <OutlinedPrimaryButton
                              fullWidth
                                sx={{ width: "100%" }}
                                height={isXsOrSm ? "37px" : "42px"}
                                onClick={() => {                              // Handle cancel action here
                                  handleSkipAggregator();
                                }}
                                
                              >
                                {"Skip Consent"}
                              </OutlinedPrimaryButton>
                            </Grid>
                          )}
                        </>
                      )}
                    
                      {/* Save as Draft */}
                      {activeStep == 0 && isEditable && formStatus!="query" && (
                         <>
                          {isLoading ? (
                            <Skeleton
                              variant="rectangular"
                              width="143px"
                              height={42}
                              sx={{ borderRadius: "8px" }}
                            />
                          ) : (
                            <Grid item xs={12} mb={2} sx={{display: "flex"}}>
                              <OutlinedPrimaryButton
                                fullWidth
                                sx={{width: '100%'}}
                                height={isXsOrSm ? "37px" : "42px"}
                                
                                onClick={handleSubmit((data) => {
                                  handleSave(data)
                                })}
                                type="submit"
                                disabled={
                                  !isEditable ||
                                  isLoadingUpdateSave ||
                                  isLoadingUpdate
                                }
                              >
                                <ButtonLoader
                                  title={"Save as Draft"}
                                  isLoading={isLoadingUpdateSave}
                                />
                              </OutlinedPrimaryButton>
                            </Grid>
                          )}
                          </>
                      )}
                    </Box>
                    </Grid>
                </div>
              
              </>
            )}
          </Card>
        </div>
      </Grid>

      <ConfirmDialog
        type={"info"}
        open={confirmModal}
        onClose={() => setConfirmModal(false)}
        title="Cancel Request?"
        content="Are you sure you want to cancel this request?"
        onAgree={() => handleAgreeSubmit("Yes")}
        onDisagree={() => {setConfirmModal(false);
        setCancelRemark("");}}
        inputField={(value: any) => setCancelRemark(value)}
        fieldValue={cancelRemark}
      />

      <ModalPopup
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        title="Remark History"
        style={commonStyles.mainModal}
        onNavigate={() => { }}
        // childrenAction={
        //   <Box
        //     sx={{
        //       width: "100%",
        //       borderTop: "1px solid #ddd",
        //       textAlign: "center",
        //       bottom: 0,
        //     }}
        //   >
        //     <ErrorButton onClick={() => handleCloseModal()} fullWidth={true}>
        //       Close
        //     </ErrorButton>
        //   </Box>
        // }
      >
        <Box className="remark-history">
          {isRemarkLoading ? (
            <>
              {[1, 2, 3, 4, 5].map((_, index) => {
                return (
                  <>
                    <Stack direction="row" spacing={2} alignItems="flex-start" key={index} sx={{ mb: "50px" }}>
                      <Skeleton variant="circular" width={40} height={40} />
                      <Box sx={{ flexGrow: 1 }}>
                        <Stack spacing={0.5}>
                          <Skeleton variant="text" width="60%" height={20} />
                          <Skeleton variant="text" width="40%" height={16} />
                        </Stack>
                      </Box>
                    </Stack>
                  </>
                )
              })}

            </>
          ) : (
            <>
              {Object.keys(dataSetRemark).length > 0 ? (
                Object.keys(dataSetRemark).map((date) => (
                  <div key={date}>
                    <Box
                      sx={{
                        padding: "0px",
                        backgroundColor: "#fff",
                        borderRadius: "8px",
                      }}
                    >
                      <List>
                        {dataSetRemark[date].map((item: any, index: number) => (
                          <ListItem
                            key={index}
                            alignItems="flex-start"
                            sx={{ padding: "8px 0" }}
                          >
                            <ListItemAvatar>
                              <Avatar sx={commonStyles.avatarStyle}>
                                {getInitials(item?.role === "customer" ? item?.role : "Avanse User")}
                              </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                              primary={
                                <>
                                  <Box
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                  >
                                    <Grid container>
                                      <Grid item xs={12} sm={12}>
                                        <Grid container>
                                          <Grid item xs={8} sm={8}>
                                            <Typography
                                              variant="body1"
                                              sx={{
                                                fontWeight: "bold",
                                                color: "#333",
                                                width: "60%",
                                              }}
                                            >
                                              {item?.role === "customer" ? item?.role : "Avanse User"}
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={4} sm={4}>
                                            <Typography
                                              variant="caption"
                                              sx={{ color: "#A0A0A0" }}
                                            >
                                              {formatDate(date)}
                                              {/* {formatDateTime(item?.created_at)} */}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Box>
                                </>
                              }
                              secondary={
                                <>
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      width: isXsOrSm ? "160px" : "250px",
                                      color: "#666",
                                      marginBottom: "4px",
                                      wordWrap: "break-word",
                                      whiteSpace: "pre-wrap",
                                      textAlign: "justify",
                                    }}
                                  >
                                    {item?.remark}
                                  </Typography>
                                </>
                              }
                            />
                          </ListItem>
                        ))}
                      </List>
                    </Box>
                    {/* <Divider /> */}
                  </div>
                ))
              ) : (
                <Typography
                  variant="body2"
                  sx={{
                    color: "#aaa",
                    textAlign: "center",
                    paddingTop: "20%",
                  }}
                >
                  No remarks available.
                </Typography>
              )}
            </>
          )}

        </Box>
      </ModalPopup>
      <Modal open={openModalNew} onClose={()=>handleCloseModalNew(false)}>
          <Box sx={modalStyle}>
            {/* Content */}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={9}>
                <Box
                  sx={{
                    borderBottom: "none",
                    pb: 2,
                    mb: 2,
                  }}
                >
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Typography sx={{fontWeight:"bold",fontSize:"16px",marginBottom:"4px"}}>
                        Important Information
                      </Typography>
                      <Typography variant="caption">
                        While processing the final disbursement amount, the amount marked as lien in your partner bank account will be disbursed first by lien removal and any additional funds required will be disbursed from Avanse as a tranche disbursement provided the total disbursement amount is within the sanctioned limit.\nPlease confirm to proceed.
                      </Typography> 
                      <Typography fontWeight={600}>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
            {/* Close button */}
            <Box mt={2} textAlign="center">
              <Box
                component="button"
                onClick={()=>handleContinousSave()}
                style={{
                  backgroundColor: "#00B8A9",
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  padding: "12px 20px",
                  cursor: "pointer",
                  width: "100%",
                  fontWeight: 600,
                }}
              >
                I Understand
              </Box>
            </Box>
          </Box>
      </Modal>
      {/* For Desktop */}
      <DialogBox open={isShowModal} aria-hidden={!isShowModal}>
          <Box
              sx={{
                  display:"flex",
                  alignItems:"center",
                  paddingLeft: "20px",
                  paddingBottom: "20px",
                  color: "black",
                  width: "100%",
                }}
              >
                <img src={InfoIcon2} width="24px" alt="test" />
                &nbsp;
                <Typography>Important Information</Typography> 
                <IconButton
                aria-label="close"
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
                onClick={() => setIsShowModal(false)}
              >
                <CloseIcon />
              </IconButton>
          </Box>
        
            <DialogBoxContent>
              <Box
                sx={{
                  display: "block",
                  flexDirection: "column",
                  justifyContent: "left",
                  textAlign: "left",
                  paddingLeft: "12px",
                  gap: "24px",
                  py:  "auto",
                }}
              >
              <Typography
                sx={{
                  paddingInline: "8px",
                  textAlign: "left",
                  fontSize:  "14px",
                  fontWeight:  "400",
                  color: "auto",
                }}
              >
                While processing the final disbursement amount, the amount marked as lien in your partner bank account will be disbursed first by lien removal and any additional funds required will be disbursed from Avanse as a tranche disbursement provided the total disbursement amount is within the sanctioned limit. Please confirm to proceed.
              </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "right",
                  alignItems:  "right",
                  float:  "right",
                  gap: "24px",
                  marginTop: "20px",
                }}
              >
                <PrimaryButton
                  onClick={handleContinousSave}
                  sx={{ minWidth: "60px" }}
                  isLoading={isLoadingUpdate}
                  disabled={isLoadingUpdate}
                >
                  <ButtonLoader
                    title={"I Understand"}
                    isLoading={isLoadingUpdate}
                  />
                </PrimaryButton>
              </Box>
            </DialogBoxContent>
          </DialogBox>
    </Box>
  );
};

export default DisbursementFormTerm;